import {
  Button,
  Checkbox,
  Card,
  Col,
  Input,
  Row,
  Space,
  Table,
  Select,
  Image,
  Radio,
  FloatButton,
  Popover,
  Menu,
  Form,
  DatePicker,
  message,
  Modal,
  Upload,
  Tooltip as AntTooltip,
  Spin,
  Collapse,
} from "antd";
import React, { Component } from "react";
import VehicleOtherInfo from "./VehicleOtherInfo";
import CompanyAutocomplete from "./CompanyAutocomplete";
import DraggableModal from "./DraggableModal";
import LiveTrackingStore from "../store/LiveTrackingStore";
import { Icon, divIcon, point } from "leaflet";
import { format, addMinutes } from "date-fns";
import config from "../config";
import VehicleStore from "../store/VehicleStore";
import DriversStore from "../store/DriversStore";
import { FaClock, FaEye, FaFileImport, FaMapMarkerAlt, FaSearch, FaTrash, } from "react-icons/fa";
import trafficIcon from "../assets/images/trafficIcon.svg";
import "leaflet-arrowheads";
import {
  CloseOutlined,
  EditOutlined,
  DeleteFilled,
  UploadOutlined,
  PlusOutlined,
  DeleteOutlined,
  SearchOutlined,
  WechatFilled,
} from "@ant-design/icons";
import L from "leaflet";
import { autorun } from "mobx";
import {
  House,
  Hospital,
  FuelPump,
  BusFront,
  HouseGear,
  PersonWorkspace,
  PinMap,
  Eraser,
  PersonBoundingBox,
  Truck,
  PauseCircle,
  PlayCircle,
} from "react-bootstrap-icons";
import Draggable from "react-draggable";
import "./Tracking.css";
import MeasureDist from "./MeasureDist";
import dayjs from "dayjs";
import Autocomplete from "react-google-autocomplete";
import { Link } from "react-router-dom";
import DeleteConfirm from "./DeleteConfirm";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import LiveRootPathStore from "../store/LiveRootPathStore";
import VehicleOtherInfoStore from "../store/VehicleOtherInfoStore";
import Cookies from "universal-cookie";
import CompanyStore from "../store/CompanyStore";
import HistoryTracking from "./HistoryTracking";
import MapForVehiclePosition from "./MapForVehiclePosition";
import SendCommandPopup from "./SendCommandPopup";
import MarkerClusterPopup from "./MarkerClusterPopup";
import { throttle } from "lodash";
import ShareModalWindow from "./ShareModalWindow";
import AddGeofenceFields from "./Plugins/AddGeofence/AddGeofenceFields";
import AddVersionModal from "./Plugins/AddGeofence/AddVersionModal";
import VideoMonitoringStore from "../store/VideoMonitoringStore";
import borderIcon from "../assets/images/NewDesign/livetracking/border-style.svg";
import carIcon from "../assets/images/NewDesign/livetracking/Ellipse 439.svg";
import powerIconGreen from "../assets/images/NewDesign/livetracking/power.svg";
import powerIconRed from "../assets/images/NewDesign/livetracking/powerIconRed.svg";
import powerIconGray from "../assets/images/NewDesign/livetracking/powerIconGray.svg";
import odometerIcon from "../assets/images/NewDesign/livetracking/speedometer2.svg";
import locationIcon from "../assets/images/NewDesign/livetracking/geo-alt.svg";
import searchIcon from "../assets/images/NewDesign/livetracking/SearchIcon.svg";
import statusArrIcon from "../assets/images/NewDesign/livetracking/statusArrIcon.svg";
import statusArrIcon1 from "../assets/images/NewDesign/livetracking/statusArrowIcon1.svg";
import expiredIcon from "../assets/images/NewDesign/livetracking/expiredIcon.svg";
import collapseArrowIcon from "../assets/images/NewDesign/livetracking/caret-down-fill.svg";
import collapseRightArrowIcon from "../assets/images/NewDesign/livetracking/caret-right-fill.svg";
import plusCircle from "../assets/images/NewDesign/livetracking/plus-circle.svg";
import dashCircle from "../assets/images/NewDesign/livetracking/dash-circle.svg";
import MaintenanceDashboardStore from "../store/MaintenanceDashboardStore";
import SosAlertNotification from "./SosAlertNotification";
import InfiniteScroll from "react-infinite-scroll-component";
import { Skeleton } from "antd";
import HLSPlayer from "./HlsPlayer";
import FlvPlayer from "./Flvplayer";
import LiveTrackingMap from "./LiveTrackingMap";
import * as turf from "@turf/turf";
import maplibregl from "maplibre-gl";
import SosAlertStore from "../store/SosAlertStore";
import ChatDriver from "./ChatDriver";
import axios from "axios";
import { decode as base64_decode } from "base-64";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import upArrow from "../assets/images/NewDesign/up-arrow.png";
import downArrow from "../assets/images/NewDesign/down-arrow.png";

const { Option } = Select;
class LiveTracking extends Component {
  constructor(prop, context) {
    super(prop);
    this.rolePermission2 = JSON.parse(localStorage.getItem("rolePermission2"));

    this.state = {
      pageSize: 50,
      currentPage: 1,
      pageSize2: 50,
      currentPage2: 1,

      showSlider: false,
      companyId: "",
      selectedDriver: "",
      offSet: "",
      limit: "",
      // currentPage: "",
      loadState: 0,
      selectionType: "checkbox",
      position: [],
      bounds: null,
      markerGroupImage: "../assets/images/bus-icon-red.png",
      // mapType: "carto",
      mapType: "google",
      popupSearch: "",
      disableSearch: true,
      timer: 30,

      interval: 30000,
      timerPause: true,
      measureDistModal: false,
      shareSingleLocation: false,

      timerCount: 0,

      closebtnClick: false,
      removeBtnClick: false,
      AddBtn: false,
      selectedIndex: null,

      drawGeofence: false,
      update: 0,

      editing: false,
      drawnShapes: [],
      GeofancenType: "",

      ShowNearAssetPopup: false,

      drawingBounds: "",
      radius: "",
      vehicleId: "",
      fromDate: dayjs(),
      toDate: dayjs(),
      fromTime: "00:00:00",
      toTime: dayjs().format("HH:mm A"),
      showGofence: "",

      geofenceData: [],
      selectGeofenceInList: [],
      selectGeofenceObjects: [],
      zoneId: -1,
      navigationWindow: false,
      SearchAssetPopup: false,
      SearchDriverPopup: false,
      companyList: [],
      vehicleList: [],
      DriverList: [],
      shareLocationtitle: "",

      origin: "",
      destination: "",
      distance: "",
      getDirection: false,
      selectedVehicles: false,
      searchAddressWindowShow: false,
      searchGeoFence: "",
      showImportExcelModal: false,
      liveTrackingMainModal:
        Number(this.props.getUserData().isadmin) !== -1 &&
          Number(this.props.getUserData().isadmin) !== 3
          ? true
          : false,
      closeCard:
        Number(this.props.getUserData().isadmin) !== -1 &&
          Number(this.props.getUserData().isadmin) !== 3
          ? true
          : false,
      // Number(this.props.getUserData().isadmin) !== -1 &&
      // Number(this.props.getUserData().isadmin) !== 3
      vehicleDetailsShow: false,
      daySummary: {},
      selectedRowKeysArray: [],

      addressInfo: this.props.addressInfo,
      type: false,
      key: new Date(),
      traffic: false,
      flag: true,
      mapBtn: false,
      satelliteBtn: false,

      selectedVehicleIds: [],

      historyTrackingWindow: false,
      trackingMapBoolean: true,
      keepAnEyeModal: false,
      sendCommandPopUp: false,
      fuelStationCenterAreaLatLong: [24.7136, 46.6753],
      selectGeofenceRows: [],

      markerClusterGroupPopup: false,
      loadingCheckbox: false,
      drawGeoLocation: "",
      vehicleOtherInfo: false,
      clientHeight: window.innerHeight,
      company_value: "",
      geofenceTitle: context.translate("_NEW_GEOFENCE_"),
      isadminlogin: false,
      vehicleStatusInfo: [],
      userId: "",
      excelCompanyId: "",

      locationUrl: "",
      shareModalVisible: false,
      Id: -1,
      showCalculatedDist: false,
      selectedCheckBox: "",
      vehicleUpdatedPosition: [],
      // selectAll: 12,
      selectAllMarkers: false,
      selectedRowsLength: "",
      vehicleMarkerPos: [],
      isLocked: false,
      openAddVersionModal: false,

      openVideoMonitoringModal: false,
      videoMonitoringData: [],
      iframeUrl: "",
      videoMonitoringUrl: {},

      openVideoModal: null,

      statusPanel: true,
      showGroupsWindow: false,

      vehicleGroups: [],

      showCollapseGroups: false,
      addPreviousVehicles: false,

      selectedCardsData: [],
      focusedCard: null,
      activeCollapseKeys: [],

      alertCounts: [],
      maintenanceCounts: [],
      selectedActiveVehicleGroup: [],

      vehicleGroupData: {},
      selectAllChecked: false,
      // selectAllGrpChecked: false,
      selectAllGrpChecked: {},
      showGeofenceWindow: true,

      page: 1,
      hasMoreVehicles: false,
      loadingMore: false,

      selectedPlaces: [],
      fuelMarkers: [],
      hospitalMarkers: [],
      garageMarkers: [],
      policestationMarkers: [],

      polylineData: null,
      trackingPolylineData: null,
      poiCoordinates: [],

      vehicleMarkers: [],
      driverMarkers: [],

      nearestAssetData: [],
      clickedMarker: null,
      histTrackingOverspeedPolyline: null,
      overspeedMarkersData: null,
      histTrackingStraightPolyline: null,
      straightLineMarkersData: null,
      idleStopMarkersData: null,
      fuelMarkersData: null,
      loading: false,
      isPlottingVehicles: false,
      selectedVehicleId: null,
      focusedVehicleId: null,
      selectedCheckboxes: [],

      focusedVehicle: {},

      sosnotificationCount: 0,
      showChatSystem: false,
      chatView: false,
      showNewPoiPopup: false,
      showAllPoi: false,
      importExcelFromPoi: false,
      showPoicompanyId: null,
      searchPoicompanyId: null,
      selectedPoiId: null,
      showAllPoiData: [],
      showSearchPoiData: [],
      poicurrentVehicleLoc: false,
      selectedPoiVehicleData: {},
      createPoiCompanyId: null,
      poiId: -1,
      updateClickedPoi: {},
      showAlertPoiPopup: false,
      excelPoiCompanyId: null,
      Photo: '',
      centerLatLng: {},

      markersAddress: "",
      markerDistance: null,
      markerTime: null,
      deleteMarkerkey: null,
      lockedZoom: null,

      selectedLatLng: null,
      searchedMarker: null,
      minimized: false,
      vehicleStatus: null
    };

    this.cookies = new Cookies();
    this.mapSetting2 = true;
    this.loading = false;
    this.originInputRef = React.createRef();
    this.destinationInputRef = React.createRef();

    this.liveTrackingStore = new LiveTrackingStore(this);
    this.companyStore = new CompanyStore(this);
    this.vehicleStore = new VehicleStore();
    this.vehicleOtherinfoStore = new VehicleOtherInfoStore(this);

    this.liveRootPathStore = new LiveRootPathStore(this);
    this.driverStore = new DriversStore();

    this.videoMonitoringStore = new VideoMonitoringStore(this);
    this.maintenanceStore = new MaintenanceDashboardStore(this);
    this.ChatDriverStore = context.chatDriverStore;
    this.sosAlertStore = new SosAlertStore(this);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.mapRef = React.createRef();
    this.drawnItemsRef = React.createRef();
    this.groupRef = React.createRef();
    this.formRef = React.createRef();
    this.searchAssetformRef = React.createRef();
    this.livelocationFormRef = React.createRef();
    this.intervalCall = false;
    this.timer2 = false;
    this.greenIcon = L.icon({
      iconUrl: require("../assets/images/bus-icon-blue.png"),
      iconSize: [30, 20], // size of the icon
    });

    this.vehiCleLiveLatLongObj = [];
    this.vehiclePositionMap = {};

    this.polylineRef = React.createRef();

    this.pendingGeofence = {};
    this.liveTrackingMapRef = React.createRef();
    this.previousVehiclePositions = {};
    this.focusedAnimationFrame = null;
    this.activeAnimations = {};

    this.mapOptions = [

      {
        // label: "Openstreet",
        label: context.translate("_OPENSTREET_"),
        value: "openstreet",
      },
      {
        label: "Google",
        value: "google",
      },
      {
        label: context.translate("Default"),
        value: "carto",
      },
    ];

    this.handleMapTypeChange = this.handleMapTypeChange.bind(this);
    this.popupSearch = this.popupSearch.bind(this);
    this.AddFunc = this.AddFunc.bind(this);
    this.RemoveFunc = this.RemoveFunc.bind(this);
    this.SearchMenuItemClick = this.SearchMenuItemClick.bind(this);
    this.SearchAssetFunc = this.SearchAssetFunc.bind(this);
    this.handleVehicleChange = this.handleVehicleChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.customIconFunc = this.customIconFunc.bind(this);
    this.selectedSearchFunc = this.selectedSearchFunc.bind(this);
    this.handleDriverChange = this.handleDriverChange.bind(this);
    this.getVehicleOtherInfo = this.getVehicleOtherInfo.bind(this);
    this.setIntervals = this.setIntervals.bind(this);
    this.clearIntervals = this.clearIntervals.bind(this);

    this.searchMenu = [
      {
        label: context.translate("_FLEET_DASHBORD_NAVIRIGHT_SEARCHVEHICLE_"),
        key: "searchasset",
        icon: <BusFront />,
      },
      {
        label: context.translate("_FLEET_DASHBORD_NAVIRIGHT_SEARCHADDRESS_"),
        key: "searchaddress",
        icon: <House />,
      },
      {
        label: context.translate("_HOSPITAL_"),
        key: "hospital",
        icon: <Hospital />,
      },
      {
        label: context.translate("_FLEET_DASHBORD_NEWPOI_TYPEDDL_FUEL_"),
        key: "gas_station",
        icon: <FuelPump />,
      },
      {
        label: context.translate("_POLICE_STATION_"),
        key: "policestation",
        icon: <PersonBoundingBox />,
      },
      {
        label: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
        key: "driver",
        icon: <PersonWorkspace />,
      },
      {
        label: context.translate("_NEAREST_ASSET_"),
        key: "nearestasset",
        icon: <Truck />,
      },
      {
        label: context.translate("_GARAGE_"),
        key: "garage",
        icon: <HouseGear />,
      },
      {
        label: context.translate("_NAVIGATION_"),
        key: "navigation",
        icon: <PinMap />,
      },
      {
        label: context.translate("_CLEAR_MAP_"),
        key: "clermap",
        icon: <Eraser />,
      },
    ];

    this.poiMenus = [
      {
        label: context.translate("_FLEET_DASHBORD_NAVIRIGHT_NEWPOI_"),
        key: "showNewPoiPopup",
        icon: <FaMapMarkerAlt />,
      },
      {
        label: context.translate("_FLEET_DASHBORD_SHOWPOI_TITLE_"),
        key: "showAllPoi",
        icon: <FaEye />,
      },
      {
        label: context.translate("_FLEET_DASHBORD_NAVIRIGHT_CLEARPOI_"),
        key: "clearPoi",
        icon: <FaTrash />,
      },
      {
        label: context.translate("_FLEET_DASHBORD_NAVIRIGHT_SEARCHPOI_"),
        key: "searchPoi",
        icon: <FaSearch />,
      },
      {
        label: context.translate("_FLEET_DASHBORD_IMPORTPOI_TITLE_"),
        key: "importExcelFromPoi",
        icon: <FaFileImport />,
      },
    ];
    this.geofenceOptions = [
      // context.translate("_FLEET_DASHBORD_NAVIRIGHT_DROWGEO_"),
      context.translate("_FLEET_DASHBORD_NAVIRIGHT_SHOWGEO_"),
      // context.translate("_IMPORT_EXPORT_EXCEL_"),
    ];
  }

  fetchMoreVehicles = async () => {
    console.log("called fetchmorevehicles");

    if (this.state.loadingMore) return;
    this.setState({ loadingMore: true });

    const nextPage = this.state.currentPage2 + 1;

    try {
      this.setState(
        { currentPage2: nextPage, addPreviousVehicles: true },
        () => {
          this.handleSearch();
        },
      );

      const newData = await this.liveTrackingStore.liveTrackingData;
      // console.log(newData);

      // console.log(this.state.selectAllChecked, "this.state.selectAllChecked");
      // if (
      //   this.props.getUserData()?.isadmin !== -1 &&
      //   this.props.getUserData()?.isadmin !== 3 &&
      //   !this.state.selectAllChecked
      // ) {
      //   this.liveTrackingStore.selectedVehicles = newData;
      //   this.setState({
      //     // selectedCardsData: newData,
      //     // selectedCheckboxes: newData,
      //   });
      // }
      if (!newData?.length) {
        this.setState({ hasMoreVehicles: false });
      }
    } finally {
      this.setState({ loadingMore: false });
    }
  };

  resizeAndCenterMap = () => {
    const map = this.mapRef?.current;
    if (!map) return;

    setTimeout(() => {
      map.resize();
      this.startVehiclePosition();
    }, 300); //  important
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("resize", this.resizeAndCenterMap);

    this.clearIntervals();

    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
    clearInterval(this.sosinterval);
    this.sosinterval = null;
  }

  handleResize = () => {
    this.setState({
      clientHeight: window.innerHeight,
    });
    // console.log(this.state.clientHeight,"sdfghjksdfghj")
  };

  geofenceCardTitle = async (title) => {
    await this.setState({ geofenceTitle: title });
  };

  async componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", throttle(this.handleResize, 200));

    // In componentDidMount or where you initialize the map

    let tokendata = this.cookies.get("data")
      ? JSON.parse(base64_decode(this.cookies.get("data")))
      : "";
    const userToken = tokendata.userToken;

    this.setState({ token: userToken });
    // window.addEventListener("resize", this.resizeAndCenterMap);
    if (this.state.liveTrackingMainModal) {
      this.resizeAndCenterMap();
      this.setIntervals();
      this.SearchMenuItemClick("liveTrackingMainModal");
    }
    // await this.addCustomClasses()

    let chatView = this.rolePermission2["chat"]?.canView;
    this.setState({ chatView: chatView == 1 ?? true });

    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
        showPoicompanyId: this.props.getUserData().userCompanyId,
        excelPoiCompanyId: this.props.getUserData().userCompanyId,
        searchPoicompanyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      // await this.handleSearch();
      await this.setState({
        excelCompanyId: this.props.getUserData().userCompanyId,
      });

      await this.handleSearch();

      await this.plotDefaultVehiclesOnMap()

      await this.liveTrackingStore.getGofenceList({
        companyId: this.props.getUserData().userCompanyId,
        offset: 0,
        limit: 50,
      });

      var vehicleList = await this.vehicleStore.getVehiclesCompanyId(
        this.props.getUserData().userCompanyId,
      );
      await this.setState({ vehicleList: vehicleList });

      var DriverList = await this.driverStore.getDriverFunc({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ DriverList: DriverList });

      //  await this.onEditGeofence()
      await this.liveTrackingStore.poiCurrentVehicleUsingCompanyId({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.companyStore.getCompanyDataById(
        this.props.getUserData().userCompanyId,
      );

      await this.liveTrackingStore.getVehiclesUsingCompanyId({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.liveTrackingStore.showAllPois(this.props.getUserData().userCompanyId)

      if (config.pythonReport !== 1) {
        await this.ChatDriverStore.getMessages({
          companyId: this.props.getUserData().userCompanyId,
          isadmin: this.props.getUserData().isadmin,
          userId: this.props.getUserData().userId,
        });
      }
      this.setState({ loadData: 1 })
    }

    this.showGeofenceListColumn = [
      {
        // title: "Name",
        title: this.context.translate("_FLEET_DASHBORD_NEWPOI_NAME_"),
        dataIndex: "name",
        render: (_, record) => {
          return <>{_}</>;
        },
      },
      {
        // title: "Address",
        title: this.context.translate("_FLEET_DASHBORD_NEWPOI_ADDRESS_"),
        dataIndex: "address",
      },
      {
        // title: "Operation",
        title: this.context.translate("_OPERATION_"),
        dataIndex: "operation",

        render: (_, val) => {
          return (
            <Space>
              <Link
                onClick={async () => {
                  this.removePlottedGeofences();

                  // Optional: clear checkbox selection
                  this.setState({
                    selectGeofenceInList: [],
                    selectGeofenceRows: [],
                  });
                  this.onEditGeofence(val);

                  this.setState({ showGofence: false });
                  if (this.state.company_value) {
                    await this.geofenceCardTitle(
                      this.context.translate("_UPDATE_GEOFENCE_"),
                    );
                  }
                }}
              >
                <AntTooltip
                  // title="Edit Geofence"
                  title={this.context.translate("_EDIT_GEOFENCE_")}
                  placement="bottom"
                  color={config.tooltipColorEdit}
                >
                  <EditOutlined style={{ fontSize: "15px" }} />
                </AntTooltip>
              </Link>
              <DeleteConfirm
                onConfirm={(e) => {
                  this.deleteGeofence(val);
                }}
              >
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <AntTooltip
                    // title="Delete Geofence"
                    title={this.context.translate(
                      "_FLEET_DASHBORD_SHOWGEO_DELETE_",
                    )}
                    placement="bottom"
                    color={config.tooltipColorDelete}
                  >
                    <DeleteFilled style={{ color: config.deleteColor }} />
                  </AntTooltip>
                </Link>
              </DeleteConfirm>
            </Space>
          );
        },
      },
    ];

    this.columns = [
      {
        key: "1",
        // title: "Vehicle",
        title: this.context.translate("_VEHICLES_"),
        dataIndex: "vehicleNo",
        // ellipsis: true,
        width: 20, //170
        fixed: "left",
        // align: "center",
        render: (_, record) => {
          return (
            <AntTooltip
              title={`${this.context.translate(
                "_FLEET_DASHBORD_VEHICLE_INFORMATION_MOBILE_",
              )}: ${record.mobileno ? record.mobileno : "-"}`}
              color="green"
            >
              <div>
                <p style={{ margin: "0px" }}>
                  <Image
                    // onClick={async () => {
                    //   await this.setState({ vehicleOtherInfo: record });
                    //   await this.setState({ update: 1 });
                    // }}
                    onClick={async () => {
                      // this.liveTrackingStore.getDriverPerformance({
                      //   currentDate: dayjs().format("YYYY-MM-DD"),
                      //   companyId: record.companyId,
                      //   driverId: record.driverId,
                      // });

                      // this.liveTrackingStore.daySummary({
                      //   currentDate: dayjs().format("YYYY-MM-DD"),
                      //   companyId: record.companyId,
                      //   vehicleId: [record.vehicleId],
                      // });

                      // await this.setState({ vehicleOtherInfo: false });
                      await this.getVehicleOtherInfo(record);

                      // console.log(record.vehicleId, "record.vehicleId");
                      // this.setState(
                      //   {
                      //     selectedVehicleId: record.vehicleId,
                      //     vehicleOtherInfo: record, // immediate data
                      //   },
                      //   () => {
                      //     this.getVehicleOtherInfo(record.vehicleId);
                      //   }
                      // );
                      await this.setState({
                        liveTrackingMainModal: false,
                        closeCard: false,
                      });
                    }}
                    width={35}
                    src={require(
                      "../assets/images/detailtracking/" + record.listImage,
                    )}
                  ></Image>
                  {record.vehicleNo}/{record.name}
                </p>

                <p style={{ margin: "0px" }}>{record.formatted_address}</p>
              </div>
            </AntTooltip>
          );
        },
      },
      {
        key: "2",
        title: this.context.translate("_DATE_TIME_"),
        // title: "Date Time ",
        dataIndex: "updatedate",
        width: 10, //100
        render: (val) => {
          return dayjs(val).format("DD-MM-YYYY h:mm:ss A");
        },
      },
      /*{
          key: "driverName",
          width: 60, //100
          // title: "Driver Name",
          title: this.context.translate(
            "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
          ),
          dataIndex: "name",
        },*/
      // {
      //   key: "mobileno",
      //   width: '7%', //100
      //   // title: "Mobile No",
      //   title: this.context.translate(
      //     "_FLEET_DASHBORD_VEHICLE_INFORMATION_MOBILE_"
      //   ),
      //   dataIndex: "mobileno",
      // },
      /* {
  
  
  
  
  
  
  
  
  
        
          key: "10",
          width: 100,
          // title: "Last Location",
          title: this.context.translate("_LAST_LOCATION_"),
          dataIndex: "lastLocation",
        },*/
      {
        key: "4",
        width: 7,
        title: (
          <AntTooltip title={this.context.translate("_SPEED_")} color="blue">
            <i className="bi bi-speedometer2"></i>
          </AntTooltip>
        ),
        dataIndex: "speed",
        align: "center",
      },
      {
        key: "5",
        width: 7,
        // title: <i class="bi bi-broadcast-pin"></i>,
        title: (
          <AntTooltip title="GPS" color="blue">
            <span>
              {" "}
              <i class="bi bi-broadcast-pin"></i>
            </span>
          </AntTooltip>
        ),
        dataIndex: "gps",
        align: "center",
        render: (value) => {
          // let value = Number(mainValue);

          if (value === 1) {
            return (
              <div style={{ textAlign: "center" }}>
                <i
                  class="bi bi-broadcast-pin"
                  style={{
                    fontSize: "17px",
                    color: "green",
                    width: "17px",
                    height: "17px",
                    textAlign: "center",
                  }}
                ></i>
              </div>
            );
          } else if (value === 0) {
            return (
              <div style={{ textAlign: "center" }}>
                <i
                  class="bi bi-broadcast-pin"
                  style={{
                    fontSize: "17px",
                    color: "red",
                    width: "17px",
                    height: "17px",
                  }}
                ></i>
              </div>
            );
          } else if (value === undefined || value === null) {
            return (
              <div style={{ textAlign: "center" }}>
                <i
                  class="bi bi-broadcast-pin"
                  style={{
                    fontSize: "17px",
                    color: "gray",
                    width: "17px",
                    height: "17px",
                    textAlign: "center",
                  }}
                ></i>
              </div>
            );
          }
        },
      },
      // {
      //   key: "7",
      //   width: 35,
      //   title: <i class="bi bi-reception-4"></i>,
      //   dataIndex: "speed",
      // },
      {
        key: "8",
        width: 7,
        title: (
          <AntTooltip title={this.context.translate("_POWER_")} color="blue">
            <span>
              <i class="bi bi-power"></i>
            </span>
          </AntTooltip>
        ),
        dataIndex: "power",
        align: "center",
        render: (newValue) => {
          let value = Number(newValue);

          if (value === 0) {
            return (
              <i
                class="bi bi-power"
                style={{
                  fontSize: "19px",
                  color: "#288a28",
                  width: "19px",
                  height: "17px",
                }}
              // style={{ color: "green", height: "30px", width: "30px" }}
              ></i>
            );
          } else if (value === 1) {
            return (
              <i
                class="bi bi-power"
                style={{
                  fontSize: "17px",
                  color: "red",
                  width: "19px",
                  height: "17px",
                }}
              // style={{ color: "red", height: "30px", width: "30px" }}
              ></i>
            );
          } else if (value === undefined || value === null) {
            return (
              <i
                class="bi bi-power"
                style={{
                  fontSize: "17px",
                  color: "gray",
                  width: "17px",
                  height: "17px",
                }}
              ></i>
            );
          }
        },
      },
      {
        key: "3",
        // title: "Status & Last Duration",
        title: this.context.translate("_STATUS_AND_DURATION_"),
        width: 20,
        dataIndex: "currentStatus",

        render: (value, record) => {
          var lastReportingTime = record.updatedate;
          var serverCurrentTime = record.currtime;
          var diff = dayjs(serverCurrentTime) - dayjs(lastReportingTime);
          // console.log(diff);
          diff /= 60000;
          if (record.vehiclestatus == "expired") {
            //stopped
            return <span>Expired</span>;
          } else if (diff >= 90) {
            return (
              <span>
                Not Reporting Since:
                <small>
                  {" "}
                  {record.nodataSince != null
                    ? this.formatTime(record.nodataSince)
                    : "--"}{" "}
                </small>
              </span>
            );
          } else if (record.acc == 1 && record.speed == 0) {
            //idle
            if (record.idleSince == null) {
              // console.log(r.get('vehicleNo'))
            }

            return (
              <span>
                Idle Since:
                <small>
                  {" "}
                  {record.idleSince != null
                    ? this.formatTime(record.idleSince)
                    : this.getDateDiff(record.currtime, record.updatedate)}{" "}
                </small>
              </span>
            );
          } else if (record.acc == 0 || record.acc == null) {
            //stopped
            return (
              <span>
                Stop Since:
                <small>
                  {" "}
                  {record.stopSince != null
                    ? this.formatTime(record.stopSince)
                    : "--"}{" "}
                </small>
              </span>
            );
          } else if (record.acc == 1 && record.speed > 0) {
            //running
            return (
              <span>
                Running Since:
                <small>
                  {" "}
                  {record.runSince != null
                    ? this.formatTime(record.runSince)
                    : "--"}{" "}
                </small>
              </span>
            );
          }
        },
      },
    ];

    autorun(async () => {
      if (this.liveTrackingStore.AutorunVar) {
        this.setState({
          closebtnClick: false,
          removeBtnClick: false,
          loadState: 1,
        });

        this.liveTrackingStore.setAutorunVar(false);
      }

      if (this.liveTrackingStore.AutorunPopup) {
        this.setState({
          ShowNearAssetPopup: this.liveTrackingStore.showNearVehiclePopup,
          loadState: 1,
        });
        this.liveTrackingStore.setAutorunPopup(false);
      }
    });
  }

  plotDefaultVehiclesOnMap = async () => {
    if (
      this.props.getUserData()?.mapSetting2 === "1" &&
      !this.state.showGroupsWindow
    ) {
      console.log(this.props.getUserData()?.mapSetting2, " this.props.getUserData()?.mapSetting2")
      this.setState({ isPlottingVehicles: true });

      // CHANGE 1: try/finally so the loader ALWAYS turns off
      try {
        await this.liveTrackingStore.getAllVehicles(this.state.companyId);

        const allVehicles = this.liveTrackingStore?.plotAllVehicles || [];

        const validVehicles = allVehicles.filter((v) =>
          this.isValidLatLng(v.latitude, v.longitude) &&
          !(Number(v.latitude) === 0 && Number(v.longitude) === 0),
        );

        this.setState({
          selectedCardsData: allVehicles, // cards keep the full list
          selectAllChecked: allVehicles.length > 0,
          loadData: 1,
        });

        // CHANGE 2: the map store only gets drawable vehicles
        this.liveTrackingStore.selectedVehicles = validVehicles;

        // CHANGE 3: wait for a real, loaded map instead of using this.mapRef directly
        const map = await this.waitForMap();

        if (map && validVehicles.length > 0) {
          const bounds = new maplibregl.LngLatBounds();
          validVehicles.forEach((v) => {
            bounds.extend([Number(v.longitude), Number(v.latitude)]);
          });

          if (!bounds.isEmpty()) {
            map.fitBounds(bounds, {
              padding: 60,
              maxZoom: map.getZoom(),
              duration: 800,
            });
          }
        }
      } catch (error) {
        console.error("plotDefaultVehiclesOnMap failed:", error);
      } finally {
        if (!this._isUnmounted) {
          this.setState({ isPlottingVehicles: false });
        }
      }
    }
  };

  getMapInstance = () => {
    const m = this.mapRef?.current ?? this.mapRef;
    return m && typeof m.getZoom === "function" ? m : null;
  };

  waitForMap = async (timeoutMs = 10000) => {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      const m = this.getMapInstance();
      if (m && m.loaded()) return m;
      await new Promise((r) => setTimeout(r, 100));
    }
    return null;
  };

  convertMinutesToFormattedTime(minutes) {
    // console.log(minutes);
    const days = Math.floor(minutes / (24 * 60));
    const remainingMinutes = minutes % (24 * 60);
    const hours = Math.floor(remainingMinutes / 60);
    const minutesPart = remainingMinutes % 60;

    const daysString = days < 10 ? `0${days}` : days.toString();
    const hoursString = hours < 10 ? `0${hours}` : hours.toString();
    const minutesString =
      minutesPart < 10 ? `0${minutesPart}` : minutesPart.toString();

    return `${daysString} days, ${hoursString}:${minutesString}:00`;
  }

  formatTime = (totalSeconds) => {
    const days = Math.floor(totalSeconds / (24 * 3600));
    const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${String(days).padStart(2, "0")} days, ${String(hours).padStart(
      2,
      "0",
    )}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  getDateDiff(currtime, updatedate) {
    // console.log(currtime,updatedate)
    var startDate = dayjs(currtime);
    var endDate = dayjs(updatedate);
    // console.log("In");
    // Calculate the time difference in milliseconds
    var timeDifference = startDate - endDate;

    // Calculate days, hours, minutes, and seconds
    var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    var a = (days < 10 ? "0" + days : days) + " days,";
    a += hours < 10 ? "0" + hours : hours;
    a += ":" + (minutes < 10 ? "0" + minutes : minutes);
    a += ":" + (seconds < 10 ? "0" + seconds : seconds);
    return a;
  }

  toggleDrawer = () => {
    this.setState({ showSlider: !this.state.showSlider });
  };
  // async getVehicleOtherInfo(record) {
  //   // const data = await this.liveTrackingStore.getVehicleTrackingInfo({
  //   //   vehicleId: record.vehicleId,
  //   //   companyId: record.companyId,
  //   // });

  //   // console.log(data, "data", record, "record");
  //   await this.setState({ vehicleOtherInfo: record });
  //   // await this.setState({ vehicleStatusInfo: data });
  //   await this.setState({ update: 1 });
  // }

  getVehicleOtherInfo = (vehicleId) => {
    const vehicleList =
      this.liveTrackingStore?.liveTrackingData ||
      // this.liveTrackingStore?.selectedVehicles ||
      [];

    const updatedVehicle = vehicleList.find((v) => v.vehicleId === vehicleId);

    if (!updatedVehicle) {
      console.log("Selected vehicle not found in refreshed list");
      return;
    }

    this.setState({
      // vehicleOtherInfo: updatedVehicle,
      vehicleOtherInfo: { ...updatedVehicle },
      loadData: 1,
      update: Date.now(),
    });
  };

  async handleChange(comp) {
    await this.setState({
      selectedRowKeysArray: [],
      popupSearch: "",
      selectedCardsData: [],
      selectAllChecked: false
    });
    this.liveTrackingStore.selectedVehicles = [];
    await this.setState({ currentPage: 1, companyId: comp.value, });

    const data = await this.companyStore.getCompanyDataById(
      this.state.companyId,
    );

    await this.setState({ company_value: data });
    // await this.getStatusWiseList();
    // await this.getRuleTriggerAlerts();
    // await this.getMaintenanceCountData();
    await this.handleSearch();
  }

  getAlertCountByVehicleId = (vehicleId) => {
    const match = this.state.alertCounts?.find(
      (alert) => alert.vehicleId === vehicleId,
    );
    return match ? match.count : "0";
  };

  getMaintenanceCountByVehicleId = (vehicleId) => {
    const match = this.state.maintenanceCounts?.find(
      (maintenance) => maintenance.vehicleId === vehicleId,
    );
    return match ? match.count : "0";
  };

  getRuleTriggerAlerts = async () => {
    const alertCounts = await this.liveTrackingStore.getAlertCounts({
      companyId: this.state.companyId,
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
    });

    this.setState({ alertCounts: alertCounts?.data?.data?.vehicleData || [] });
  };

  getMaintenanceCountData = async () => {
    const maintenanceCounts = await this.liveTrackingStore.getMaintenanceCounts(
      {
        companyId: this.state.companyId,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
      },
    );

    this.setState({
      maintenanceCounts: maintenanceCounts?.data?.data?.maintenancereport || [],
    });
  };
  handleClearFields = () => {
    // Clear the origin and destination states
    this.setState({
      origin: null,
      destination: null,
      distance: "",
    });

    // Clear the input field values by manipulating DOM elements
    if (this.originInputRef.current) {
      this.originInputRef.current.value = "";
    }
    if (this.destinationInputRef.current) {
      this.destinationInputRef.current.value = "";
    }
  };

  async handleCompId(comp) {
    this.setState({
      companyId: comp.value,
    });
    var vehicleList = await this.vehicleStore.getVehiclesCompanyId(comp.value);
    await this.setState({ vehicleList: vehicleList });

    var DriverList = await this.driverStore.getDriverFunc({
      companyId: comp.value,
    });
    await this.setState({ DriverList: DriverList });
  }

  async handleMapTypeChange(comp) {
    await this.setState({ mapType: comp.target.value, listUpdated: 1 });
    // console.log('in map change ')
    // L.on('loading', function (event) {
    //     console.log('start loading tiles');
    // });
  }

  timerPauseFun = async () => {
    let currentTimer = this.state.timer;

    if (!this.state.timerPause) {
      await this.setState({ timer: this.state.timerCount });
    }

    await this.clearIntervals();

    await this.setState({ timerPause: !this.state.timerPause });

    if (this.state.timerPause) {
      this.setIntervals();
      await this.setState({ timer: currentTimer });
    }
  };
  AddFunc = async (e) => {
    await this.setState({
      AddBtn: true,
      selectedIndex: e,
    });
    this.liveTrackingStore.AddSelectedAdrressArray(e);
    await this.setState({
      loadState: 1,
    });
  };
  RemoveFunc = async (e) => {
    await this.setState({
      AddBtn: false,
      removeBtnClick: true,
      // loadState: 1 ,
    });
    this.liveTrackingStore.updateSelectedAdrressArray(e);
    await this.setState({
      loadState: 1,
    });
  };

  iconCreateFunction = function (cluster) {
    //   console.log('innn')
    //console.log(cluster._markers[0].options.currentStatus);

    const markers1 = cluster._markers;
    var count = markers1.length;
    var idle = 0;
    var stopped = 0;
    var running = 0;
    var nodata = 0;
    var indexA = "";
    var clusterIconType = [];

    //if (count != 0) {

    const markers = cluster.getAllChildMarkers();

    Object.keys(markers).map((e, i) => {
      var currentStatus = markers[i].options.currentStatus;

      var lastReportingTime = markers[i].options.options.obj.updatedate;
      var serverCurrentTime = markers[i].options.options.obj.currtime;

      var acc = markers[i].options.options.obj.acc;
      var speed = markers[i].options.options.obj.speed;

      var diff = new Date(serverCurrentTime) - new Date(lastReportingTime);

      diff /= 60000; //diff convert in minutes.

      if (diff >= 90) {
        if (!clusterIconType.includes(1)) {
          clusterIconType.push(1);
        }
      } else if (acc == 1 && speed == 0) {
        //idle
        if (!clusterIconType.includes(2)) {
          clusterIconType.push(2);
        }
      } else if (acc == 0 || speed == null) {
        //stopped
        if (!clusterIconType.includes(3)) {
          clusterIconType.push(3);
        }
      } else if (acc == 1 && speed > 0) {
        //running
        if (!clusterIconType.includes(4)) {
          clusterIconType.push(4);
        }
      }
    });

    switch (parseInt(clusterIconType.sort().join(""))) {
      case 1:
        indexA = 1;
        break;
      case 2:
        indexA = 2;
        break;
      case 3:
        indexA = 3;
        break;
      case 4:
        indexA = 4;
        break;
      case 12:
        indexA = 5;
        break;
      case 13:
        indexA = 6;
        break;
      case 14:
        indexA = 7;
        break;
      case 23:
        indexA = 8;
        break;
      case 24:
        indexA = 9;
        break;
      case 34:
        indexA = 10;
        break;
      case 123:
        indexA = 11;
        break;
      case 124:
        indexA = 12;
        break;
      case 134:
        indexA = 13;
        break;
      case 234:
        indexA = 14;
        break;
      case 1234:
        indexA = 15;
        break;

      default:
        indexA = 1;
        break;
    }

    var imagename = indexA + ".png";

    const imageUrl = require("../assets/images/clusterMarkers/" + imagename);
    return L.divIcon({
      html: `<div style="border-radius: 50%;  width: 40px; height: 40px;position: relative;text-align:center"><img src="${imageUrl}" /><span style="color: black;position: absolute;left: 0;right: 0;
            line-height: 36px;">${cluster.getChildCount()}</span></div>`,
      className: "marker-cluster-custom",
      iconSize: [40, 40],
    });
    //}
  };
  async getMessages() {
    const response = await this.ChatDriverStore.getMessages({
      companyId: this.props.getUserData().userCompanyId,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
    });
  }

  clearIntervals = function () {
    if (this.timer2) {
      clearInterval(this.timer2);
      this.timer2 = null;
    }
  };

  setIntervals = function () {
    this.setState({ timerCount: this.state.timer });

    this.timer2 = setInterval(async () => {
      this.setState({ timerCount: this.state.timerCount - 1 });

      if (this.state.timerCount === 1) {
        // this.clearIntervals();

        try {
          console.log("map lock state:", this.state.isLocked, "handleSearch");
          // if (!this.state.isLocked) {
          if (this.state.companyId && this.state.showGeofenceWindow) {
            this.setState(
              { currentPage2: 1, addPreviousVehicles: false },
              () => {
                // if (this.props.getUserData().isadmin != -1 || this.props.getUserData().isadmin != 3) {
                this.handleSearch(this.state.selectedActiveVehicleGroup);

                // }

                // this.startVehiclePosition();
                if (config.pythonReport !== 1) {
                  this.getMessages();
                }
              },
            );
          }
          // if (this.state.selectedVehicleId) {
          //   this.getVehicleOtherInfo(this.state.selectedVehicleId);
          // }
          if (this.state.selectAllChecked && !this.state.showGroupsWindow) {
            this.liveTrackingStore.getAllVehicles(this.state.companyId);
          }
          // }
        } catch (error) {
          console.error(
            "Error updating vehicle positions or handling search:",
            error,
          );
        }

        // Reset the timer
        this.setState({ timerCount: this.state.timer });
      }
    }, 1000);
  };

  componentDidUpdate(prevProps, prevState) {
    // if (
    //   this.state.focusedVehicleId &&
    //   prevState.focusedVehicleId !== this.state.focusedVehicleId
    // ) {
    //   const vehicle = this.state.selectedCardsData.find(
    //     (v) => v.vehicleId === this.state.focusedVehicleId
    //   );
    //   console.log(this.state.selectedCardsData, "this.state.selectedCardsData");
    //   console.log(this.state.focusedVehicleId, "this.state.focusedCard");
    //   if (
    //     vehicle &&
    //     vehicle.latitude != null &&
    //     vehicle.longitude != null &&
    //     this.mapRef
    //   ) {
    //     this.mapRef.jumpTo({
    //       center: [vehicle.longitude, vehicle.latitude],
    //       zoom: 19,
    //     });
    //   }
    // }

    // Update polyline arrowheads
    if (this.polylineRef.current) {
      const leafletPolyline = this.polylineRef.current;
      this.addArrowheads(leafletPolyline);
    }

    // Reset position when companyId changes
    if (prevState.companyId !== this.state.companyId) {
      this.setState({ position: [] });
    }
  }

  async handleSearch(val) {
    const isSearching =
      this.state.popupSearch && this.state.popupSearch.trim().length > 0;
    const MAX_SELECTED_IDS = 50;

    const selectedCardsVehicleIds = this.state.selectedCardsData.map(
      (v) => v.vehicleId,
    );
    // const selectedVehicleId = [
    //   ...(selectedCardsVehicleIds || []),
    //   ...(this.state.selectedVehicleId ? [this.state.selectedVehicleId] : []),
    // ]
    //   .filter(Boolean)
    //   .filter((v, i, arr) => arr.indexOf(v) === i) // remove duplicates
    //   .join(",");

    const selectedVehicleId = [
      ...(this.state.selectedVehicleId ? [this.state.selectedVehicleId] : []), // put first so it is never cut
      ...(selectedCardsVehicleIds || []),
    ]
      .filter(Boolean)
      .filter((v, i, arr) => arr.indexOf(v) === i) // remove duplicates
      .slice(0, MAX_SELECTED_IDS) // only the first 50
      .join(",");

    // console.log(this.state.selectAllChecked, "this.state.selectAllChecked")
    // if (isSearching && this.state.selectAllChecked) {
    //   this.liveTrackingStore.selectedVehicles = [];
    //   this.setState({
    //     selectAllChecked: false,
    //     selectedCardsData: [],
    //     selectedCheckboxes: [],
    //     isPlottingVehicles: false,
    //   });
    // }

    const finalSelectedVehicleId =
      this.state.addPreviousVehicles || this.state.selectAllChecked || isSearching
        ? ""
        : selectedVehicleId;

    this.setState({ loading: true });
    await this.liveTrackingStore.loadData({
      offset: (this.state.currentPage2 - 1) * this.state.pageSize2,
      limit: this.state.pageSize2,
      companyId: this.state.companyId,
      poupSearch: this.state.popupSearch,
      vehicleStatus: this.state.vehicleStatus,
      value: this.state.selectedVehicleIds,
      // deviceGroupId: this.state.selectedActiveVehicleGroup,
      deviceGroupId: this.state.showGroupsWindow ? val : "",
      groups: !this.state.showGroupsWindow ? "groups" : "",
      addPreviousVehicles: this.state.addPreviousVehicles,

      // selectedVehicleId: this.state.selectAllChecked ? "" : selectedVehicleId,
      selectedVehicleId: finalSelectedVehicleId,
    });

    this.setState({ loading: false });

    const groupData = this.liveTrackingStore.liveTrackingData;

    // console.log(groupData, "groupData")
    // if (this.state.selectAllChecked) {
    //   this.setState({
    //     selectedCardsData: groupData,
    //   });
    // }

    // if (this.state.selectAllChecked && !this.state.showGroupsWindow) {
    // const allVehicles = this.liveTrackingStore.plotAllVehicles || [];

    // // only act once the full list has loaded
    // if (allVehicles.length > 0) {
    //   const freshById = new Map(groupData.map((v) => [v.vehicleId, v]));

    //   // full fleet, with the latest data for any vehicle in the current result
    //   const fullSelected = allVehicles.map(
    //     (v) => freshById.get(v.vehicleId) || v,
    //   );

    //   // this.liveTrackingStore.selectedVehicles = fullSelected;
    //   this.liveTrackingStore.selectedVehicles = fullSelected.filter((v) =>
    //     this.isValidLatLng(v.latitude, v.longitude),
    //   );
    //   this.setState({ selectedCardsData: fullSelected });
    // }
    // }

    if (this.state.selectAllChecked && !this.state.showGroupsWindow) {
      const allVehicles = this.liveTrackingStore.plotAllVehicles || [];

      if (allVehicles.length > 0) {
        const freshById = new Map(groupData.map((v) => [v.vehicleId, v]));
        const fullSelected = allVehicles.map((v) => freshById.get(v.vehicleId) || v);

        this.liveTrackingStore.selectedVehicles = fullSelected.filter((v) =>
          this.isValidLatLng(v.latitude, v.longitude),
        );
        this.setState({ selectedCardsData: fullSelected });
      }
    } else if (this.state.selectedCardsData.length > 0) {
      // keep the user's selection, only update their live data
      const freshById = new Map(groupData.map((v) => [v.vehicleId, v]));
      const refreshed = this.state.selectedCardsData.map(
        (v) => freshById.get(v.vehicleId) || v,
      );

      this.liveTrackingStore.selectedVehicles = refreshed.filter((v) =>
        this.isValidLatLng(v.latitude, v.longitude),
      );
      this.setState({ selectedCardsData: refreshed });
    }

    if (this.liveTrackingStore.totalCount <= this.state.pageSize2) {
      this.setState({ hasMoreVehicles: false });
    } else {
      this.setState({ hasMoreVehicles: true });
    }

    this.setState((prevState) => ({
      vehicleGroupData: {
        ...prevState.vehicleGroupData,
        [val]: groupData, // Store data by groupId
      },
      listUpdated: 1,
      disableSearch: false,
    }));
    // await this.setState({ listUpdated: 1, disableSearch: false }); //need to reload data
    if (!this.state.focusedVehicleId) {
      this.startVehiclePosition();
    }
    // if (this.state.focusedVehicleId) {
    //   console.log("this.state.focusedVehicleId", this.state.focusedVehicleId);
    //   this.updateVehiclePositions([this.state.focusedVehicle]);
    // }

    const focusedVehicle = groupData.find(
      (v) => v.vehicleId === this.state.focusedVehicleId,
    );

    if (focusedVehicle) {
      this.updateVehiclePositions(focusedVehicle);

      const pos = this.previousVehiclePositions[focusedVehicle.vehicleId];

      this.animateVehicleMovement(
        focusedVehicle,
        focusedVehicle.vehicleId,
        [Number(pos.prevLongitude), Number(pos.prevLatitude)],
        [Number(pos.longitude), Number(pos.latitude)],

        pos.direction,
        pos.mapImage,
      );
    }
    if (this.state.selectedVehicleId) {
      this.getVehicleOtherInfo(this.state.selectedVehicleId);
    }
    if (this.liveTrackingStore.totalvehstate.total > 0) {
      this.clearIntervals();
      this.setIntervals();
    }

    return groupData;
  }

  calculateDistance = (from, to) => {
    const R = 6371000;
    const toRad = (d) => (d * Math.PI) / 180;

    const dLat = toRad(to[1] - from[1]);
    const dLng = toRad(to[0] - from[0]);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(from[1])) *
      Math.cos(toRad(to[1])) *
      Math.sin(dLng / 2) ** 2;

    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleCompanyChange();
  }

  handleCompanyChange = async () => {
    await this.liveTrackingStore.getGofenceList({
      companyId: this.state.companyId,
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
    });
    // console.log(offset,limit)
    this.setState({ loadData: 1 });
  };
  async popupSearch(e) {
    const value = e.target.value;
    await this.setState({
      currentPage2: 1,
      popupSearch: value,
      addPreviousVehicles: false,
      // selectAllChecked: false,
    });
    if (value.length >= 4 || value.length === 0) {
      // if (value.length === 0) {
      //   this.setState({
      //     selectAllChecked: false,
      //   });
      // }
      if (this.state.companyId) {
        // selectAllChecked: false, selectedCardsData: [], vehicleOtherInfo: false 
        // this.liveTrackingStore.selectedVehicles = [];
        await this.setState({ offset: 0, popupSearch: value, });

        await this.handleSearch();
      }
    }
  }

  getStatusWiseList = async (name) => {
    // console.log(b)
    // console.log(b.target.n);
    // let buttonName = b.target.name;
    await this.setState({ vehicleStatus: name });
    await this.handleSearch();
  };
  setRefreshTime = async (val) => {
    await this.clearIntervals();
    await this.setState({ timer: val });
    await this.setIntervals();
  };

  customIcon = new Icon({
    // iconUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
    iconUrl: require("../assets/images/logo_icon.png"),
    iconSize: [38, 38], // size of the icon
  });

  customIconFunc(data) {
    var customIcon1 = new Icon({
      iconUrl: this.liveTrackingStore.getIcon(data),

      iconSize: [21, 52], // size of the icon
    });

    return customIcon1;
  }

  createClusterCustomIcon = function (cluster) {
    //console.log(cluster)
    return new divIcon({
      html: `<span class="cluster-icon">${cluster.getChildCount()}</span>`,
      className: "custom-marker-cluster",
      iconSize: point(45, 45, true),
    });
  };

  async SearchMenuItemClick(data) {
    let allStateFields = {
      ShowNearAssetPopup: false,
      editing: false,
      measureDistModal: false,
      SearchDriverPopup: false,
      position: [],
      selectGeofenceObjects: [],
      geofenceData: [],
      navigationWindow: false,
      SearchAssetPopup: false,
      searchAddressWindowShow: false,
      liveTrackingMainModal: false,
      closeCard: false,
      drawGeofence: false,
      showGofence: false,
      showImportExcelModal: false,
      mapType: "carto",
      showNewPoiPopup: false,
      showAllPoi: false,
      searchPoi: false,

    };
    // const positionLatLngs = this.liveTrackingStore.selectedVehicles.map((val) =>
    //   L.latLng(val.latitude, val.longitude)
    // );

    // const lastPosition = positionLatLngs[positionLatLngs.length - 1];

    // if (lastPosition) {
    //   // this.mapRef.setView(lastPosition, 12);

    //   var lantlng = [lastPosition?.lat, lastPosition?.lng];
    // }

    const selectedVehicles = this.liveTrackingStore.selectedVehicles;

    let lantlng = null;

    if (selectedVehicles.length > 0) {
      const lastVehicle = selectedVehicles[selectedVehicles.length - 1];

      lantlng = [lastVehicle.latitude, lastVehicle.longitude];
    }
    if (data === "nearestasset") {
      await this.liveTrackingStore.setShowNearVehiclePopup(true);
      await this.liveTrackingStore.setAutorunPopup(true);
      await this.setState({
        ...allStateFields,
        ShowNearAssetPopup: this.liveTrackingStore.showNearVehiclePopup,
      });
    } else if (data === "navigation") {
      await this.setState({
        ...allStateFields,
        navigationWindow: true,
        mapType: "google",
      });
    } else if (data === "searchasset") {
      await this.setState({ ...allStateFields, SearchAssetPopup: true });
    } else if (data === "driver") {
      await this.setState({ ...allStateFields, SearchDriverPopup: true });
    } else if (data === "searchaddress") {
      await this.setState({ ...allStateFields, searchAddressWindowShow: true });
      //   drawGeofence:false,
      // showGofence:false,
      // showImportExcelModal:false,
    } else if (data === "drawGeofence") {
      await this.setState({
        ...allStateFields,
        drawGeofence: true,
        editing: true,
        mapType: this.state.mapType,
      });
    } else if (data === "showGofence") {
      await this.setState({
        // ...allStateFields,
        showGofence: true,
        drawGeoLocation: "",
        showGeofenceWindow: false,
        closeCard: false,
        vehicleOtherInfo: false,
      });
    } else if (data === "showImportExcelModal") {
      await this.setState({ ...allStateFields, showImportExcelModal: true });
    } else if (data === "measureDistModal") {
      await this.setState({
        ...allStateFields,
        measureDistModal: true,
        mapType: "google",
      });
    } else if (data === "liveTrackingMainModal") {
      await this.setState({
        ...allStateFields,
        liveTrackingMainModal: true,
        showGeofenceWindow: true,
        closeCard: true,
        mapType: this.state.mapType,
      });
    } else if (data === "clermap") {
      this.mapRef.current.eachLayer((layer) => {
        // if (layer instanceof L.Marker) {
        if (layer instanceof L.Polyline) {
          this.mapRef.current.removeLayer(layer);
        }
        this.setState({
          position: [],
          selectGeofenceObjects: [],
          geofenceData: [],
        });
      });
      this.liveTrackingStore.selectedVehicles = [];
      this.setState({ position: [] });
    } else if (data === "hospital") {
      const resp = await this.liveTrackingStore.getTypeData({
        type: "hospital",
        // latlong: [24.7136, 46.6753],
        latlong: lantlng ? lantlng : config.mapCenter,
        // map: this.mapRef
      });
      console.log("first", resp.results)
      resp.forEach((val) => {
        this.showingPetrolPump_Hospital(val, "hospital");
      });
    } else if (data === "gas_station") {
      const resp = await this.liveTrackingStore.getTypeData({
        type: "gas_station",
        // latlong: this.state.fuelStationCenterAreaLatLong,
        latlong: lantlng ? lantlng : config.mapCenter,
      });
      // resp.results.forEach((val) => {
      //   this.showingPetrolPump_Hospital(val, "petrol");
      // });
      resp.forEach((val) => {
        this.showingPetrolPump_Hospital(val, "petrol");
      });
    } else if (data === "policestation") {
      const resp = await this.liveTrackingStore.getTypeData({
        type: "police",
        // latlong: [24.7136, 46.6753],
        latlong: lantlng ? lantlng : config.mapCenter,
      });
      resp.forEach((val) => {
        this.showingPetrolPump_Hospital(val, "police");
      });
    } else if (data === "garage") {
      const resp = await this.liveTrackingStore.getTypeData({
        type: "car_repair",
        // latlong: [24.7136, 46.6753],
        latlong: lantlng ? lantlng : config.mapCenter,
      });
      resp.forEach((val) => {
        this.showingPetrolPump_Hospital(val, "garage");
      });
    } else if (data === "showNewPoiPopup") {
      await this.setState({
        ...allStateFields,
        showNewPoiPopup: true,
      });
    } else if (data === "showAllPoi") {

      if (this.props.getUserData().isadmin == 1 || this.props.getUserData().isadmin == 0) {
        console.log(this.props.getUserData().isadmin, "this.props.getUserData().isadmin")
        await this.setState({
          ...allStateFields,
          showAllPoi: false,
        });
        this.showAllPoiData();
      } else {
        await this.setState({
          ...allStateFields,
          showAllPoi: true,
        });
      }

    } else if (data === "searchPoi") {
      await this.setState({
        ...allStateFields,
        searchPoi: true,
      });
    } else if (data === "importExcelFromPoi") {
      await this.setState({
        ...allStateFields,
        importExcelFromPoi: true,
      });
    } else if (data === "clearPoi") {
      this.clearPoiFromMap()
    }
  }

  clearPoiFromMap = () => {
    this.setState({ showAllPoiData: [], showSearchPoiData: [], poiId: null })
  }

  removePlacesFromMap = (key) => {
    const map = this.mapRef.current;
    if (!map) return;

    let markerArrayName = "";

    switch (key) {
      case "gas_station":
        markerArrayName = "fuelMarkers";
        break;
      case "hospital":
        markerArrayName = "hospitalMarkers";
        break;
      case "garage":
        markerArrayName = "garageMarkers";
        break;
      case "policestation":
        markerArrayName = "policestationMarkers";
        break;
      default:
        return;
    }

    const markers = this.state[markerArrayName];
    if (markers && markers.length) {
      markers.forEach((m) => {
        if (map.hasLayer(m)) map.removeLayer(m);
      });
    }

    this.setState({ [markerArrayName]: [] });
  };

  clearPOIMarkers = (type) => {
    if (!type) return;

    const markerMap = {
      gas_station: "fuelMarkers",
      hospital: "hospitalMarkers",
      garage: "garageMarkers",
      policestation: "policestationMarkers",
    };

    const stateKey = markerMap[type];
    if (!stateKey) return;

    this.state[stateKey].forEach((marker) => marker.remove());

    this.setState({
      [stateKey]: [],
    });
  };

  // showingPetrolPump_Hospital = (val, type) => {
  //   let lat = val.geometry.location.lat;
  //   let long = val.geometry.location.lng;

  //   const marker = L.marker([lat, long], {
  //     icon: new Icon({
  //       iconUrl: require("../assets/images/" + type + ".png"),
  //       iconSize: [35, 35],
  //     }),
  //     draggable: false,
  //   }).addTo(this.mapRef.current);

  //   this.setState((prev) => {
  //     if (type === "petrol")
  //       return { fuelMarkers: [...prev.fuelMarkers, marker] };
  //     if (type === "hospital")
  //       return { hospitalMarkers: [...prev.hospitalMarkers, marker] };
  //     if (type === "garage")
  //       return { garageMarkers: [...prev.garageMarkers, marker] };
  //     if (type === "police")
  //       return { policestationMarkers: [...prev.policestationMarkers, marker] };
  //     return null;
  //   });
  // };

  showingPetrolPump_Hospital = (val, type) => {
    if (!this.mapRef) return;

    console.log(val, "vasdfghjtreffeweffedfvfd")
    // const lat = val.geometry.location.lat;
    // const lng = val.geometry.location.lng;

    const lat = val.geometry.location.lat();
    const lng = val.geometry.location.lng();

    console.log(lat, lng, "sdfghnmkjtrdfggfd")
    const el = document.createElement("div");
    el.style.backgroundImage = `url(${require(
      "../assets/images/" + type + ".png",
    )})`;
    el.style.width = "35px";
    el.style.height = "35px";
    el.style.backgroundSize = "contain";
    el.style.backgroundRepeat = "no-repeat";

    const marker = new maplibregl.Marker({ element: el })
      .setLngLat([lng, lat])
      .addTo(this.mapRef);

    this.setState(
      (prev) => ({
        poiCoordinates: [...prev.poiCoordinates, [lng, lat]],
        ...(type === "petrol" && {
          fuelMarkers: [...prev.fuelMarkers, marker],
        }),
        ...(type === "hospital" && {
          hospitalMarkers: [...prev.hospitalMarkers, marker],
        }),
        ...(type === "garage" && {
          garageMarkers: [...prev.garageMarkers, marker],
        }),
        ...(type === "police" && {
          policestationMarkers: [...prev.policestationMarkers, marker],
        }),
      }),
      this.fitMapToPOIs,
    );
  };

  fitMapToPOIs = () => {
    const { poiCoordinates } = this.state;
    if (!this.mapRef || poiCoordinates.length === 0) return;

    const bounds = poiCoordinates.reduce(
      (b, coord) => b.extend(coord),
      new maplibregl.LngLatBounds(poiCoordinates[0], poiCoordinates[0]),
    );

    this.mapRef.fitBounds(bounds, {
      padding: 60,
      maxZoom: 16,
      duration: 800,
    });
  };
  selectGeofence = async (e) => {
    const value = e.target.value;

    if (value == this.context.translate("_FLEET_DASHBORD_NAVIRIGHT_DROWGEO_")) {
      this.setState({ drawGeoLocation: "" });
      await this.SearchMenuItemClick("drawGeofence");
      // await this.toggleEditing();
      this.setState({ editing: true });
      // } else if (value === "Show Geofence") {
    } else if (
      value === this.context.translate("_FLEET_DASHBORD_NAVIRIGHT_SHOWGEO_")
    ) {
      await this.SearchMenuItemClick("showGofence");
    } else if (value === this.context.translate("_IMPORT_EXPORT_EXCEL_")) {
      //  await this.setState({ showImportExcelModal: true });
      await this.SearchMenuItemClick("showImportExcelModal");
    }

    await this.setState({ update: 1 });
  };

  onEdited = (event) => {
    const layers = event.layers;
    let updatedDrawingBounds = "";
    let updatedRadius = null;
    let shapeType = null;

    layers.eachLayer((layer) => {
      if (layer instanceof L.Circle) {
        const center = layer.getLatLng();
        updatedDrawingBounds = `${center.lat},${center.lng}`;
        updatedRadius = layer.getRadius();
        shapeType = "circle";
      } else if (layer instanceof L.Rectangle) {
        const bounds = layer.getLatLngs()[0];
        updatedDrawingBounds = bounds
          .map(({ lat, lng }) => `${lat},${lng},0`)
          .join(",");
        shapeType = "rectangle";
      } else if (layer instanceof L.Polygon) {
        const points = layer.getLatLngs()[0];
        updatedDrawingBounds = points
          .map(({ lat, lng }) => `${lat},${lng},0`)
          .join(",");
        shapeType = "polygon";
      }
    });

    this.setState({
      drawingBounds: updatedDrawingBounds,
      radius: updatedRadius,
      GeofancenType:
        shapeType === "circle" ? 2 : shapeType === "rectangle" ? 1 : 3,
    });
  };

  onCreated = async (event) => {
    const { layerType, layer } = event;

    if (
      layerType === "circle" ||
      layerType === "rectangle" ||
      layerType === "polygon"
    ) {
      layer.setStyle({
        color: "red",
        fillColor: "red",
        // fillOpacity: 0.6,
      });
    }

    const shape = {
      type: layerType,
      coordinates: [],
      radius: null,
    };

    const latLangs = layer._latlngs;

    let boundString;
    if (layerType === "circle") {
      boundString = `${layer._latlng.lat},${layer._latlng.lng}`;
    } else {
      boundString = latLangs[0]
        .map(({ lat, lng }) => `${lat},${lng},0`)
        .join(",");
    }

    this.setState({ drawingBounds: boundString });

    if (layerType === "rectangle") {
      shape.coordinates = [
        layer.getBounds().getNorthEast(),
        layer.getBounds().getSouthWest(),
      ];
    } else if (layerType === "circle") {
      shape.coordinates = [layer.getLatLng()];
      shape.radius = layer.getRadius();
    } else if (layerType === "polygon") {
      shape.coordinates = layer
        .getLatLngs()[0]
        .map((latLng) => [latLng.lat, latLng.lng]);
    }

    // Get the center and radius of the circle or the center of the bounding box for rectangles
    await this.setState({ radius: shape.radius });

    let centerLatLng;
    if (layerType === "circle") {
      centerLatLng = layer.getLatLng();
      this.setState({ GeofancenType: 2 });
    } else if (layerType === "rectangle") {
      this.setState({ GeofancenType: 1 });
      centerLatLng = layer.getBounds().getCenter();
    } else if (layerType === "polygon") {
      this.setState({ GeofancenType: 3 });
      const bounds = layer.getBounds();
      centerLatLng = bounds.getCenter();
    }

    const centerLat = centerLatLng.lat;
    const centerLng = centerLatLng.lng;

    // Reverse geocode the center coordinates to get the address

    const address = await this.liveTrackingStore.getAddressUsingLatLong(
      layerType,
      centerLat,
      centerLng,
      shape.radius,
    );

    await this.formRef.current.setFieldsValue({
      address: address,
    });

    this.setState((prevState) => ({
      drawnShapes: [...prevState.drawnShapes, shape],
    }));

    console.log("layer in hook", layer);
    this.drawnItemsRef.current.addLayer(layer);
  };

  getInformationOfVehicle = ({ vehicleId, latLong }) => {
    let latitude;
    let longitude;
    if (vehicleId) {
      const { vehiclePositionArray } = this.liveTrackingStore;
      const vehicleInfoLatLong = vehiclePositionArray.find(
        (val) => val.vehicleId === vehicleId,
      );

      latitude = vehicleInfoLatLong?.latitude;
      longitude = vehicleInfoLatLong?.longitude;

      // Create custom marker element
      const el = document.createElement("div");
      el.style.backgroundImage = `url(${require("../assets/images/location-pin.png")})`;
      el.style.width = "38px";
      el.style.height = "38px";
      el.style.backgroundSize = "contain";
      el.style.backgroundRepeat = "no-repeat";

      // Create marker
      this.locationMarker = new maplibregl.Marker({
        element: el,
        draggable: true,
      })
        .setLngLat([longitude, latitude])
        .addTo(this.mapRef);

      // Optional: zoom to marker
      this.mapRef.flyTo({
        center: [longitude, latitude],
        zoom: 14,
      });
    } else {
      if (this.locationMarker) {
        this.locationMarker.remove();
        this.locationMarker = null;
      }

      latitude = latLong.latitude;
      longitude = latLong.longitude;
      // Create custom marker element
      const el = document.createElement("div");
      el.style.backgroundImage = `url(${require("../assets/images/location-pin.png")})`;
      el.style.width = "38px";
      el.style.height = "38px";
      el.style.backgroundSize = "contain";
      el.style.backgroundRepeat = "no-repeat";

      // Create marker
      this.locationMarker = new maplibregl.Marker({
        element: el,
        draggable: true,
      })
        .setLngLat([longitude, latitude])
        .addTo(this.mapRef);

      // Optional: zoom to marker
      this.mapRef.flyTo({
        center: [longitude, latitude],
        zoom: 14,
      });
    }
    // else {
    //   // const { latitude, longitude } = latLong;
    //   latitude = latLong.latitude;
    //   longitude = latLong.longitude;

    //   this.mapRef.current.eachLayer((layer) => {
    //     if (layer instanceof L.Marker) {
    //       this.mapRef.current.removeLayer(layer);
    //     }
    //   });

    //   const marker = L.marker([latitude, longitude], {
    //     icon: new Icon({
    //       // iconUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
    //       iconUrl: require("../assets/images/location-pin.png"),
    //       iconSize: [38, 38], // size of the icon
    //     }),
    //     draggable: true,
    //   }).addTo(this.mapRef.current);

    //   marker.on("dragend", (event) => {
    //     const newLatLng = event.target.getLatLng();
    //     const newLatitude = newLatLng.lat;
    //     const newLongitude = newLatLng.lng;
    //   });

    //   this.mapRef.current.setView([latitude, longitude], 15);
    // }

    // this.mapRef.current.setView([latitude, longitude], 13);
  };

  handleChangeForDrawingGeofence = async (comp) => {
    await this.setState({ companyId: comp.value });
    await this.liveTrackingStore.getVehiclesUsingCompanyId({
      companyId: comp.value,
    });
    // await this.formRef.current.setFieldsValue({ companyId: comp.value });
    await this.liveTrackingStore.poiCurrentVehicleUsingCompanyId({
      companyId: comp.value,
    });
    await this.setState({ listUpdated: 1 });
  };

  handleChangeForCreatePoi = async (comp) => {
    const companyId = comp.value
    const poiVehicles = await this.liveTrackingStore.poiCurrentVehicleUsingCompanyId({ companyId: companyId })
    this.setState({ loadData: 1 })
  };

  timeOptions = () => {
    const timeArray = [];

    let startTime = new Date(2000, 0, 1, 0, 0); // 12:00 AM

    let endTime = new Date(2000, 0, 1, 23, 30);
    for (let time = startTime; time <= endTime; time = addMinutes(time, 30)) {
      // const formattedTime = format(time, 'h:mm aa');
      const formattedTime = format(time, "HH:mm:ss");
      var ob = {
        formattedTime: formattedTime,
        time: time,
      };
      timeArray.push(ob);
    }

    return timeArray.map((data) => {
      return (
        <Select.Option key={data.formattedTime} value={data.formattedTime}>
          {format(data.time, "h:mm aa")}
        </Select.Option>
      );
    });
  };

  onFinishDrawing = async (values) => {
    if (
      this.state.companyId &&
      // this.state.vehicleId &&
      this.state.drawingBounds
    ) {
      // const data = {...values,GeofancenType:this.state.GeofancenType,zoneId:-1,isactive:1,createdBy:1,bound:this.state.drawingBounds}
      const data = {
        ...values,
        GeofancenType: this.state.GeofancenType,
        zoneId: this.state.zoneId,
        isactive: 1,
        createdBy: 1,
        radius: this.state.radius,
        bound: this.state.drawingBounds,
        companyId: this.state.companyId,
        latitude: this.state.centerLatLng.lat,
        longitude: this.state.centerLatLng.lng
      };


      const response = await this.liveTrackingStore.addGeofenceDrawing(data);

      if (response?.data?.success === "S") {
        message.success("Geofence saved successfully");
        this.setState({
          selectGeofenceInList: [],
          selectGeofenceRows: [],
        });
        await this.liveTrackingStore.getGofenceList({
          companyId: this.state.companyId,
          offset: 0,
          limit: 50,
        });
        // this.handleCompanyChange()

        const singleData = await this.companyStore.getCompanyDataById(
          this.state.companyId,
        );

        await this.setState({ drawGeofence: false });
        await this.setState({ showGofence: true, company_value: singleData });

        // this.mapRef.current.eachLayer((layer) => {
        //   this.drawnItemsRef.current.clearLayers(layer);
        //   if (layer instanceof L.Marker) {
        //     this.mapRef.current.removeLayer(layer);
        //   }
        //   this.setState({
        //     position: [],
        //     drawGeoLocation: "",
        //     selectGeofenceObjects: [],
        //     geofenceData: [],
        //   });
        // });
        await this.clearFields();
      } else {
        message.error();
      }
    } else {
      Modal.warning({
        // title: "Alert",
        // content: "Please select Shape and draw fence",
        title: this.context.translate("_FLEET_ALERT_"),
        content: this.context.translate("_SELECT_SHAPE_DRAW_FENCE_"),
      });
    }
    await this.setState({ listUpdated: 1 });
  };

  LoadClick = async () => {
    await this.formRef.current.setFieldsValue({ stopIdlePoints: [] });
    if (!this.state.companyId) {
      Modal.warning({
        // title: "Alert",
        // content: "Please Enter Company Name",
        title: this.context.translate("_FLEET_ALERT_"),
        content: this.context.translate("_PLEASE_ENTER_COMPANY_NAME_"),
      });
    } else if (!this.state.vehicleId) {
      Modal.warning({
        // title: "Alert",
        title: this.context.translate("_FLEET_ALERT_"),
        content: this.context.translate("_PLEASE_SELECT_VEHICLE_"),
        // content: "Please Select Vehicle",
      });
    }
    if (this.state.companyId && this.state.vehicleId) {
      // console.log(this.state.toTime.format("hh:mm:ss"), dayjs(this.state.toTime).format("hh:mm:ss"), dayjs(this.state.toTime,"hh:mm A").format("hh:mm:ss"))
      const data = {
        companyId: this.state.companyId,
        vehicleId: this.state.vehicleId,
        fromDate:
          this.state.fromDate.format("YYYY-MM-DD") + " " + this.state.fromTime,

        toDate:
          this.state.toDate.format("YYYY-MM-DD") +
          " " +
          dayjs(this.state.toTime, "HH:mm A").format("HH:mm:ss"),
      };
      await this.liveTrackingStore.getstopidle(data);

      await this.setState({ listUpdated: 1 });
    }
  };

  clearFields = () => {
    this.setState({ radius: "", drawingBounds: [], selectedLatLng: null });
    this.formRef.current.setFieldsValue({
      speed: "",
      address: "",
      typeName: "",
      geosettingname: "",
      vehicleId: "",
      companyId: "",
    });

    // this.setState({ companyId: "", vehicleId: "" });
    this.setState({ vehicleId: "" });
  };

  clearGeofencesFromMap = async () => {
    console.log(this.mapRef, "this.drawRef");
    // 1. Clear MapboxDraw features
    if (this.drawRef) {
      this.drawRef.deleteAll();
    }

    // 2. Clear MapLibre layers/sources (if used)

    this.removeGeofenceSourceAndLayer();
  };
  removeGeofenceSourceAndLayer = () => {
    if (!this.mapRef) return;
    // Remove layer first
    if (this.mapRef.getLayer("geofence-layer")) {
      this.mapRef.removeLayer("geofence-layer");
    }

    // Then remove source
    if (this.mapRef.getSource("geofence-source")) {
      this.mapRef.removeSource("geofence-source");
    }
  };

  handleGetGofenceList = async (comp) => {
    this.setState({ loading: true });
    // this.setState({ company_value: comp.value });
    await this.setState({
      company_value: { label: comp.label, value: comp.value },
    });
    await this.liveTrackingStore.getGofenceList({
      companyId: comp.value,
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
    });

    await this.setState({ listUpdated: 1 });
    this.setState({ loading: false });
  };

  handleShowingGeofenceInMap = async ({ record, recordFormNearestAsset }) => {
    if (record) {
      let InfoObject = record;
      const pointsArray = record.points
        .split(",")
        .map(Number)
        .filter((_, index) => index % 3 !== 2);

      const formattedPoints = [];
      for (let i = 0; i < pointsArray.length; i += 2) {
        formattedPoints.push([pointsArray[i], pointsArray[i + 1]]);
      }
      const geofenceObj = { ...InfoObject, points: formattedPoints };

      if (geofenceObj.points.length === 1) {
        const [lat, lng] = geofenceObj.points[0];
        const bounds = [
          [lat, lng],
          [lat, lng],
        ];
        // this.mapRef.current.fitBounds(bounds);
        // this.mapRef.current.fitBounds(bounds, { maxZoom: 16 });
      } else if (geofenceObj.points.length > 1) {
        // this.mapRef.current.fitBounds(geofenceObj.points, { maxZoom: 16 });
      }
      await this.setState({ geofenceData: geofenceObj });
      await this.setState({ listUpdated: 1 });
    } else if (recordFormNearestAsset) {
      // this.mapRef.current.fitBounds(recordFormNearestAsset.points, {
      //   maxZoom: 18,
      // });
      await this.setState({ geofenceData: recordFormNearestAsset });
    }
  };

  deleteGeofence = async (val) => {
    let zoneId = [val?.zoneId];
    const zone = zoneId.join(",");
    let response;
    for (let i = 0; i < zoneId.length; i++) {
      response = await this.liveTrackingStore.deleteGeofence({
        zoneId: zoneId[i],
        companyId: val.companyId,
      });
    }
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      // this.mapRef.current.eachLayer((layer) => {
      // this.drawnItemsRef.current.clearLayers(layer);

      this.setState({ selectGeofenceObjects: [] });
      // });
      await this.liveTrackingStore.getGofenceList({
        companyId: val.companyId,
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
      });
      this.setState({ drawingBounds: [] });
    } else if (response?.data?.success === "F0") {
      message.error(response.data.errors[0].geodeleteerror);
    }
    await this.setState({ listUpdated: 1 });
  };

  deleteMultipleGeofence = async (val) => {
    let zoneId = val;

    const zone = val.join(",");
    let flag = 0;
    let response;

    zoneId.forEach(async (val, ind) => {
      flag++;
      response = await this.liveTrackingStore.deleteGeofence({
        zoneId: val,
        companyId: this.state.companyId,
      });

      if (response?.data?.success === "S") {
        if (ind === 0) {
          message.success(response.data.message);
        }
        // if(flag===1){

        //   message.success(response.data.message);
        // }

        // this.mapRef.current.eachLayer((layer) => {
        // this.drawnItemsRef.current.clearLayers(layer);

        this.setState({ selectGeofenceObjects: [] });
        // });
        await this.liveTrackingStore.getGofenceList({
          companyId: this.state.companyId,
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
        });
        this.setState({ drawingBounds: [] });
      } else if (response?.data?.success === "F0") {
        message.error(response.data.errors[0].geodeleteerror);
      }
      await this.setState({ listUpdated: 1 });
    });
  };

  setPointsInArrayFormat = async (obj, editObj) => {
    const selectedRows = obj;

    let geofenceObj = [];
    for (let i = 0; i < selectedRows.length; i++) {
      const pointsArray = selectedRows[i].points
        .split(",")
        .map(Number)
        .filter((_, index) => index % 3 !== 2);

      const formattedPoints = [];
      for (let i = 0; i < pointsArray.length; i += 2) {
        formattedPoints.push([pointsArray[i], pointsArray[i + 1]]);
      }
      geofenceObj.push({
        ...selectedRows[i],
        points: formattedPoints,
      });
      let shapeType = null;

      if (formattedPoints.length === 1) {
        shapeType = "circle";
      } else if (formattedPoints.length === 2) {
        shapeType = "rectangle";
      } else if (formattedPoints.length > 2) {
        shapeType = "polygon";
      }
      let layer;
      if (shapeType === "polygon") {
        layer = L.polygon(formattedPoints, {
          color: "red",
          fillColor: "red",
          fillOpacity: 0.4,
        });
      } else if (shapeType === "rectangle") {
        // Rectangle is defined by southWest and northEast corners
        const bounds = L.latLngBounds(formattedPoints);
        layer = L.rectangle(bounds, {
          color: "red",
          fillColor: "red",
          fillOpacity: 0.4,
        });
      } else if (shapeType === "circle") {
        // For circle, you need a center and a radius
        const center = L.latLng(formattedPoints[0]);
        const radius = selectedRows[i].radius || 100; // fallback radius if not present
        layer = L.circle(center, {
          radius,
          color: "red",
          fillColor: "red",
          fillOpacity: 0.4,
        });
      }

      if (this.drawnItemsRef.current) {
        this.drawnItemsRef.current.addLayer(layer);
      }

      this.mapRef.current.fitBounds(formattedPoints);
    }
    if (editObj) {
      let zoneId = obj[0].zoneId;
      let ans = this.state.selectGeofenceObjects?.some(
        (item) => item.zoneId === zoneId,
      );

      let data = this.state.selectGeofenceObjects;
      // if (!ans) {
      //   data = this.state.selectGeofenceObjects;
      //   data.push(geofenceObj[0]);
      // }

      await this.setState({ selectGeofenceObjects: data });
    } else {
      await this.setState({ selectGeofenceObjects: geofenceObj });
    }
  };
  onEditGeofence = async (val) => {
    this.pendingGeofence = val;

    this.setState({
      selectGeofenceObjects: [],
      drawGeofence: true,
      editing: true,
      zoneId: val.zoneId,
    });
    await this.liveTrackingStore.poiCurrentVehicleUsingCompanyId({
      companyId: val.companyId,
    });
    await this.liveTrackingStore.getVehiclesUsingCompanyId({
      companyId: val.companyId,
    });

    const singleData = await this.companyStore.getCompanyDataById(
      val.companyId,
    );
    await this.setState({
      companyId: val.companyId,
      drawGeoLocation: val.address,
      drawingBounds: val.points,
    });

    await this.formRef.current.setFieldsValue({
      typeName: val?.typeName ? parseInt(val?.typeName) : null,
      geosettingname: val?.name,
      companyId: singleData,
      address: val?.address,
      speed: val?.speed,
      bigPrice: val?.bigPrice,
      bigNeightPrice: val?.bigNeightPrice,
      neightPrice: val?.neightPrice,
      special: val?.special,
      speedDuration: val?.spdur,
      vendorId: val?.vendorId,
      price: val?.price,
      // type: val?.type,

      // drawGeoLocation:val.address
    });

    await this.setState({
      company_value: singleData,
      GeofancenType: val?.type,
      radius: val?.radius,
    });
  };
  // async SearchAssetFunc() {
  //   // if (!this.state.companyId || !this.state.selectedVehicles){
  //   //   return;
  //   // }
  //   if (this.state.SearchAssetPopup && this.state.selectedVehicles) {
  //     await this.liveRootPathStore.loadVehiclePosition(
  //       this.state.selectedVehicles
  //     );

  //     if (this.state.SearchAssetPopup) {
  //       this.mapRef.current.eachLayer((layer) => {
  //         if (layer instanceof L.Marker) {
  //           this.mapRef.current.removeLayer(layer);
  //         }
  //       });
  //     }
  //     if (this.liveRootPathStore.vehiclePosition?.length === 0) {
  //       Modal.warning({
  //         title: this.context.translate("_FLEET_ALERT_"),

  //         content: this.context.translate("_VEHICLE_NOT_AVAILABLE_"),
  //       });
  //     }

  //     this.liveRootPathStore.vehiclePosition?.map((v) => {
  //       var popup = L.popup().setContent("vehicleNo =" + v.vehicleNo);
  //       const marker = L.marker([v.latitude, v.longitude], {
  //         icon: this.customIconFunc(v),
  //       })
  //         .bindTooltip(
  //           "<div style='background:#00ff00;border:solid 1px #000;text-align:center;padding:0'><b>" +
  //             v.vehicleNo +
  //             "/" +
  //             v.name +
  //             "</b></div>",
  //           {
  //             permanent: true,
  //             direction: "bottom",
  //             // className: "my-labels"
  //           }
  //         )
  //         .addTo(this.mapRef.current);
  //     });
  //     if (this.liveRootPathStore.vehiclePosition?.length > 0) {
  //       this.mapRef.current.setView(
  //         [
  //           this.liveRootPathStore.vehiclePosition[0]?.latitude,
  //           this.liveRootPathStore.vehiclePosition[0]?.longitude,
  //         ],
  //         13
  //       );
  //     }
  //   } else if (this.state.SearchDriverPopup && this.state.selectedDriver) {
  //     var data = {
  //       companyId: parseInt(this.state.companyId),
  //       driverId: this.state.selectedDriver,
  //     };
  //     var DriverList = await this.driverStore.getSearchedDriver(data);

  //     if (DriverList) {
  //       this.mapRef.current.eachLayer((layer) => {
  //         if (layer instanceof L.Marker) {
  //           this.mapRef.current.removeLayer(layer);
  //         }
  //       });
  //     }
  //     if (DriverList.length === 0) {
  //       Modal.warning({
  //         title: this.context.translate("_FLEET_ALERT_"),
  //         content: this.context.translate("_DRIVER_NOT_AVAILABLE_"),
  //       });
  //     }
  //     DriverList?.map((d) => {
  //       var popup = L.popup().setContent("vehicleNo =" + d.vehicleNo);
  //       // const marker = L.marker([v.latitude, v.longitude], {
  //       //   icon: this.customIcon,
  //       // }).bindPopup(popup).openPopup().addTo(this.mapRef.current);

  //       const marker = L.marker([d.latitude, d.longitude], {
  //         icon: this.customIconFunc(d),
  //       })
  //         .bindTooltip(
  //           "<div style='background:#00ff00;border:solid 1px #000;text-align:center;padding:0'><b>" +
  //             d.driverName +
  //             "/" +
  //             d.vehicleNo +
  //             "</b></div>",
  //           {
  //             permanent: true,
  //             direction: "bottom",
  //             // className: "my-labels"
  //           }
  //         )
  //         .addTo(this.mapRef.current);
  //     });
  //     if (DriverList?.length > 0) {
  //       this.mapRef.current.setView(
  //         [DriverList[0]?.latitude, DriverList[0]?.longitude],
  //         13
  //       );
  //     }
  //   }
  // }

  clearMarkers = (type) => {
    const markers =
      type === "vehicle" ? this.state.vehicleMarkers : this.state.driverMarkers;

    markers.forEach((m) => m.remove());

    if (type === "vehicle") {
      this.setState({ vehicleMarkers: [] });
    } else {
      this.setState({ driverMarkers: [] });
    }
  };

  loadSearchVehicleIcon = async () => {
    const vehicleData = this.state.ShowNearAssetPopup
      ? this.liveTrackingStore.NearVeicleList
      : this.state.SearchAssetPopup
        ? this.liveRootPathStore.vehiclePosition
        : this.driverStore.driverSearchData || [];
    //  console.log(vehicleData)
    const uniqueImages = [...new Set(vehicleData.map((v) => v.mapImage))];

    const imagePromises = uniqueImages.map((imgName) => {
      return new Promise((resolve) => {
        const url = `/vehicle-icons/${imgName}`; // Absolute path to your public folder
        // console.log(url);
        this.mapRef.loadImage(url, (error, image) => {
          if (!error && image && !this.mapRef.hasImage(imgName)) {
            this.mapRef.addImage(imgName, image);
          }
          resolve();
        });
      });
    });

    await Promise.all(imagePromises);
  };

  async SearchAssetFunc() {
    if (!this.mapRef) return;

    /** ================= VEHICLE SEARCH ================= */
    if (this.state.SearchAssetPopup && this.state.selectedVehicles) {
      await this.liveRootPathStore.loadVehiclePosition(
        this.state.selectedVehicles,
      );

      // Clear old vehicle markers
      this.clearMarkers("vehicle");

      const positions = this.liveRootPathStore.vehiclePosition || [];

      if (positions.length === 0) {
        Modal.warning({
          title: this.context.translate("_FLEET_ALERT_"),
          content: this.context.translate("_VEHICLE_NOT_AVAILABLE_"),
        });
        return;
      }

      const bounds = new maplibregl.LngLatBounds();

      positions.forEach((v) => {
        bounds.extend([v.longitude, v.latitude]);
      });

      // this.setState({ vehicleMarkers: markers });

      // Zoom to vehicles
      this.mapRef.fitBounds(bounds, {
        padding: 80,
        maxZoom: 15,
        duration: 800,
      });
    } else if (this.state.SearchDriverPopup && this.state.selectedDriver) {
      /** ================= DRIVER SEARCH ================= */
      const data = {
        companyId: parseInt(this.state.companyId),
        driverId: this.state.selectedDriver,
      };

      const DriverList = await this.driverStore.getSearchedDriver(data);

      // Clear old driver markers
      this.clearMarkers("driver");

      if (!DriverList || DriverList.length === 0) {
        Modal.warning({
          title: this.context.translate("_FLEET_ALERT_"),
          content: this.context.translate("_DRIVER_NOT_AVAILABLE_"),
        });
        return;
      }

      const bounds = new maplibregl.LngLatBounds();
      const markers = [];

      DriverList.forEach((d) => {
        bounds.extend([d.longitude, d.latitude]);
      });

      this.setState({ driverMarkers: markers });

      // Zoom to drivers
      this.mapRef.fitBounds(bounds, {
        padding: 80,
        maxZoom: 15,
        duration: 800,
      });
    }
  }

  async handleCancel(val) {
    if (val === "searchAddressWindowShow") {
      this.setState({ searchAddressWindowShow: false });
    } else if (val === "SearchAssetPopup") {
      this.setState({
        SearchAssetPopup: false,
        SearchDriverPopup: false,
      });
    } else if (val === "showNearVehiclePopup") {
      this.liveTrackingStore.setShowNearVehiclePopup(false);
      this.setState({
        ShowNearAssetPopup: false,
        selectGeofenceObjects: [],
        geofenceData: [],
      });
    }
    // this.mapRef.current.eachLayer((layer) => {
    //   if (layer instanceof L.Marker) {
    //     this.mapRef.current.removeLayer(layer);
    //   }
    // });
  }

  clearLocationMarker = () => {
    if (this.locationMarker) {
      this.locationMarker.remove();
      this.locationMarker = null;
    }

    // this.mapRef.flyTo({
    //   center: config.mapCenter, // your default center
    //   zoom: config.mapZoom || 10,
    // });
  };

  async handleVehicleChange(a) {
    this.setState({ selectedVehicles: a });
    // this.liveRootPathStore.setSelectesVehicle(a);
  }
  async selectedSearchFunc(e) {
    if (e.target.value === 1) {
      this.setState({
        SearchAssetPopup: true,
        SearchDriverPopup: false,
      });
    } else if (e.target.value === 2) {
      this.setState({
        SearchAssetPopup: false,
        SearchDriverPopup: true,
      });
    }
  }

  async handleDriverChange(val) {
    this.setState({
      selectedDriver: val,
    });
    // this.liveRootPathStore.setSelectesVehicle(a);
  }
  getDistance = (val) => {
    if (val?.distance) {
      this.setState({ distance: val.distance });
    }
  };
  searchInput = async (e) => {
    const value = e.target.value;
    if (value.length > 2 || value.length === 0) {
      if (this.state.companyId) {
        await this.liveTrackingStore.getGofenceList({
          companyId: this.state.companyId,
          searchField: value,
          offset: 0,
          limit: this.state.pageSize,
        });
        await this.setState({ loadList: 1 });
      }
    }
  };

  getUploadData = async (fileUp) => {
    let fileinfo = fileUp.file.response;

    console.log(fileUp, "fileUp")
    if (fileinfo?.success == "S") {
      // console.log(fileinfo.data)

      await this.setState({ excelFile: fileinfo.data });
    }

    this.setState({ update: 1 });
  };

  getUploadPhoto = async (fileUp) => {
    let fileinfo = fileUp.file.response;

    console.log(fileUp, "fileUp")
    if (fileinfo?.success == "S") {
      // console.log(fileinfo.data)

      await this.setState({ Photo: fileinfo.data });
    }

    this.setState({ update: 1 });
  };
  onImportExcelSubmit = async (fieldsValue) => {
    const data = {
      ...fieldsValue,
      companyId: this.state.excelCompanyId,
      excelFile: this.state.excelFile,
    };

    const resp = await this.liveTrackingStore.addGeofenceByExcel(data);

    if (resp?.success === "S" && resp?.insertedCount > 0) {
      Modal.success({
        title: "Excel Import",
        content: resp.message,
      });

      this.setState({ excelFile: "" });
    } else {
      Modal.error({
        title: "Excel Import Failed",
        content:
          resp?.message ||
          "No valid geofence records were found to import.",
      });
    }
    // if (resp?.success === "S") {
    //   message.success(resp.message);

    //   if (resp.errorCount > 0 && resp.errors?.length > 0) {
    //     resp.errors.forEach((error) => {
    //       message.error(`Row ${error.row}: ${error.message}`);
    //     });
    //   }
    //   this.setState({ excelFile: "" });
    // } else {
    //   console.log(resp.message, "resp.message")
    //   message.error(resp.message || "Excel import failed");
    //   // this.setState({ showImportExcelModal: false });
    //   // this.formRef.current?.resetFields();
    // }
  };

  rotateIcon = (iconUrl, rotation) => {
    const icon = L.divIcon({
      iconAnchor: [10, 20],
      // iconSize: [15, 20],
      // iconAnchor: [0, 0],
      iconSize: [0, 0],
      html: `<img src=${require(`../assets/images/livetracking/${iconUrl}`)} class="icon-image" style="transform: rotate(${rotation}deg); width: 20px; height: 35px;">`,
    });

    return icon;
  };

  handleMarkerClusterGroup = async (event) => {
    const clickedCluster = event.layer;
    const clusterMarkers = clickedCluster.getAllChildMarkers();
    let vehicleObj = [];
    let vehicleIds = [];
    clusterMarkers.forEach((marker) => {
      vehicleIds.push(marker.options?.options?.obj.vehicleId);
      vehicleObj.push(marker.options?.options?.obj);
    });

    const resp = await this.liveTrackingStore.getClusterVehicleData({
      vehicleId: vehicleIds,
      companyId: this.state.companyId,
    });
    if (resp) {
      this.setState({
        markerClusterGroupPopup: {
          vehicleFeature: resp,
          vehicleObj: vehicleObj,
          This: this,
        },
      });
    }
  };

  getCenterOfCoordinates = (coordinates) => {
    if (coordinates.length === 0) {
      return null;
    }
    let sumLat = 0;
    let sumLng = 0;
    for (const coordinate of coordinates) {
      sumLat += coordinate[0]; // Latitude is the first element of each coordinate pair
      sumLng += coordinate[1]; // Longitude is the second element of each coordinate pair
    }
    const avgLat = sumLat / coordinates.length;
    const avgLng = sumLng / coordinates.length;
    return [avgLat, avgLng];
  };

  timeOptionsForLiveLocation = () => {
    const timeArray = [];

    let startTime = new Date(2000, 0, 1, 0, 0); // 12:00 AM

    let endTime = new Date(2000, 0, 1, 24, 0);
    for (let time = startTime; time < endTime; time = addMinutes(time, 15)) {
      // const formattedTime = format(time, 'h:mm aa');
      const formattedTime = format(time, "HH:mm");
      var ob = {
        formattedTime: formattedTime,
        time: time,
      };
      timeArray.push(ob);
    }

    return timeArray.map((data) => {
      return (
        <Select.Option key={data.formattedTime} value={data.formattedTime}>
          {format(data.time, "H:mm")}
        </Select.Option>
      );
    });
  };

  onLiveLocationFormSubmit = async (value) => {
    // console.log(value);

    const data = {
      ...value,
      expiryDate: value.expiryDate.format("YYYY-MM-DD"),
      vehicleId: this.state.vehicleOtherInfo.vehicleId,
      companyId: this.state.vehicleOtherInfo.companyId,
      locationUrl: this.state.locationUrl?.locationUrl,
      status: 1,
      Id: -1,
    };

    const resp = await this.liveTrackingStore.addLiveLocation(data);

    // this.setState({linkResponse:resp.data.success == "S"})
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      // this.livelocationFormRef.current.setFieldsValue({
      //   locationUrl:resp.locationUrl,
      // });
      // await this.setState({ openLiveLocationModal: false });
    } else if (resp.data.success == "F0") {
      resp.data.errors.map((value) => {
        message.error(value["vehicleNo"]);
        // message.error(resp.data.message);
      });
    }
  };

  getLiveLocationUrl = async () => {
    const data = {
      vehicleId: this.state.vehicleOtherInfo.vehicleId,
    };
    const response = await this.liveTrackingStore.getLocationUrl(data);

    this.setState({ locationUrl: response });

    if (response.Id !== -1) {
      this.livelocationFormRef.current.setFieldsValue({
        locationUrl: response.locationUrl,
        expiryDate: dayjs() ? dayjs(response.expiryDate) : "",
        startTime: response.startTime,
        endTime: response.endTime,
      });
    }
  };

  async startVehiclePosition() {
    const vehiclePositionData = this.liveTrackingStore.selectedVehicles;
    const map = this.mapRef;
    if (!map || !Array.isArray(vehiclePositionData)) return;

    // const validVehicles = vehiclePositionData.filter(
    //   (v) => v.latitude != null && v.longitude != null,
    // );

    const validVehicles = vehiclePositionData.filter((v) => {
      const lat = Number(v.latitude);
      const lng = Number(v.longitude);

      return (
        v.latitude != null &&
        v.longitude != null &&
        v.latitude !== "" &&
        v.longitude !== "" &&
        Number.isFinite(lat) &&
        Number.isFinite(lng) &&
        lat >= -90 &&
        lat <= 90 &&
        lng >= -180 &&
        lng <= 180 &&
        !(lat === 0 && lng === 0)
      );
    });
    const bounds = new maplibregl.LngLatBounds();
    validVehicles.forEach((v) => {
      bounds.extend([Number(v.longitude), Number(v.latitude)]);
    });

    if (!bounds.isEmpty()) {
      if (this.state.isLocked) {

        const zoom = this.state.lockedZoom ?? map.getZoom();
        const savedCenter = this.state.lockedCenter;
        const center = savedCenter
          ? [savedCenter.lng, savedCenter.lat]
          : [map.getCenter().lng, map.getCenter().lat];
        map.easeTo({
          center: center,
          zoom: zoom, // use saved zoom
          duration: 800,
        });
        map.once('moveend', () => {
          this.isProgrammaticMove = false;
        });
      } else {
        // 🔓 Unlocked: fit all vehicles in view
        map.fitBounds(bounds, {
          padding: 60,
          duration: 800,
        });
      }
    }
  }

  addArrowheads(polyline) {
    // console.log(polyline)
    if (polyline && polyline.arrowheads) {
      polyline.arrowheads({ size: "10px" }); // Customize as needed
    } else {
      console.error("Arrowheads plugin or polyline is not available.");
    }
  }

  handleAddVersionForm = async (values) => { };

  handleAddVersionModal = async () => {
    this.setState({ openAddVersionModal: true });
  };

  updateSelectedVehicles = (selectedVehicleIds) => {
    this.setState({ selectedVehicleIds });
  };

  handleVideoMonitoringData = async (channelId) => {
    const data = { vehicleId: this.state.vehicleOtherInfo?.vehicleId };
    const response = await this.videoMonitoringStore.getDevices(data);

    this.setState({ videoMonitoringData: response[0] });

    if (response) {
      this.loadVideos(channelId, response[0]);
    }

    // if (response[0].MDVR == "JT1078") {
    //   await this.videoMonitoringStore.bsjVideoMonitoring(
    //     channelId,
    //     response[0]
    //   );
    // }
  };

  loadVideos = async (channelId, vehicleData) => {
    var username = vehicleData.cmsvssUserName;
    var host = vehicleData.cmsvssWebHost;
    var port = vehicleData.cmsvssWebPort;
    var imei = vehicleData.full_imei;
    var deviceId = vehicleData.deviceId;
    var token = vehicleData.token;
    var MDVR = vehicleData.MDVR;
    var password = vehicleData.cmsvssPassword;

    let iframeUrl = "";
    if (MDVR == "JT1078") {
      const data = {
        channelId: channelId,
        vehicleId: vehicleData.vehicleId,
        full_imei: imei,
      };
      await this.videoMonitoringStore.bsjVideoMonitoring(data);

      iframeUrl =
        "https://samedia.trackeazy.com/test/multimedia#" +
        imei +
        "-" +
        channelId;
    } else if (MDVR == "CMS") {
      iframeUrl = `${host}/808gps/open/player/video.html?lang=en&devIdno=${imei}&account=${username}&password=${password}&channel=1&chns=${channelId - 1
        }`;
    } else if (MDVR === "H-Protocol") {
      const mdvrdata = {
        vehicleId: vehicleData.vehicleId,
        channelId: channelId,
        deviceId: deviceId,
        full_imei: imei,
      };

      const howenMDVR =
        await this.videoMonitoringStore.howenMDVRSocket(mdvrdata);
      console.log(howenMDVR);
      // iframeUrl =
      //   "https://samedia.trackeazy.com/howen/test/multimedia#live_" +
      //   imei +
      //   "_0" +
      //   channelId +
      //   "_00";

      iframeUrl =
        "https://samedia.trackeazy.com/m3u8/live_" +
        imei +
        "_0" +
        channelId +
        "_00.m3u8?ts=" +
        Date.now();
    } else {
      if (port != null) {
        iframeUrl = `${host}:${port}/vss/apiPage/RealVideo.html?token=${token}&deviceId=${imei}&chs=${channelId - 1
          }&stream=0&wnum=0&buffer=0&panel=1`;
      } else {
        iframeUrl = `${host}/vss/apiPage/RealVideo.html?token=${token}&deviceId=${imei}&chs=${channelId}&stream=0&wnum=0&buffer=0&panel=1`;
      }
    }

    // this.setState({ iframeUrl: iframeUrl });

    this.setState((prevState) => ({
      videoMonitoringUrl: {
        ...prevState.videoMonitoringUrl,
        [channelId]: iframeUrl,
      },
    }));
  };

  handleCloseChannel = (channelId) => {
    this.setState((prevState) => {
      const updatedUrls = { ...prevState.videoMonitoringUrl };
      delete updatedUrls[channelId];
      return { videoMonitoringUrl: updatedUrls };
    });
  };

  closeModal = () => {
    this.setState({ openVideoModal: null });
  };

  genExtra = (val, groupId) => {
    return (
      <div
        className="collapse-count-style"
        onClick={async (event) => {
          let allVehicles = this.state.vehicleGroupData?.[groupId];

          // event.stopPropagation();
          if (!allVehicles) {
            const fetchedVehicles = await this.handleSearch(groupId);

            allVehicles = fetchedVehicles || [];

            this.setState((prevState) => ({
              vehicleGroupData: {
                ...prevState.vehicleGroupData,
                [groupId]: allVehicles,
              },
            }));
          }

          // const newSelectAllGrpChecked = {};
          // Object.keys(this.state.selectAllGrpChecked || {}).forEach((key) => {
          //   newSelectAllGrpChecked[key] = false;
          // });
          // newSelectAllGrpChecked[groupId] = true;

          this.setState({
            // selectAllGrpChecked: newSelectAllGrpChecked,
            selectedCardsData: allVehicles,
          });

          this.liveTrackingStore.selectedVehicles = allVehicles;

          if (allVehicles.length && this.mapRef?.current) {
            const bounds = allVehicles
              .filter((v) => v.latitude !== null && v.longitude !== null)
              .map((v) => [v.latitude, v.longitude]);

            if (bounds.length > 0) {
              this.mapRef.current.fitBounds(bounds, { padding: [50, 50] });
            }
          }
        }}
      >
        <span className="collapse-count">{val?.vehicleCount}</span>
      </div>
    );
  };

  getStatusColorClass = (status) => {
    switch (status) {
      case "No Data":
        return "status-no-data";
      case "Running":
        return "status-running";
      case "Stopped":
        return "status-stopped";
      case "Idle":
        return "status-idle";
      default:
        return "status-no-data";
    }
  };

  toggleVehicleSelection = (val, fromCheckbox = false) => {
    this.setState((prevState) => {
      const isSelected = prevState.selectedCardsData.some(
        (card) => card.vehicleId === val.vehicleId,
      );

      let selectedCardsData = [...prevState.selectedCardsData];
      let focusedVehicleId = prevState.focusedVehicleId;

      // Checkbox behavior (select / deselect)
      if (fromCheckbox) {
        if (isSelected) {
          selectedCardsData = selectedCardsData.filter(
            (card) => card.vehicleId !== val.vehicleId,
          );
        } else {
          selectedCardsData.push(val);
        }
      } else {
        if (!isSelected) {
          selectedCardsData.push(val);
          focusedVehicleId = null;
          this.clearFocusedVehicleFromMap();
        } else {
          if (focusedVehicleId === val.vehicleId) {
            focusedVehicleId = null;
            this.clearFocusedVehicleFromMap();
          } else {
            focusedVehicleId = val.vehicleId;
          }
        }
      }

      // CHANGE 1: only push to the store (which drives the map) when the
      // selection really changed. Focusing an already selected card must not
      // touch it. This was the old unconditional line:
      // this.liveTrackingStore.selectedVehicles = selectedCardsData;
      const selectionChanged = fromCheckbox || !isSelected;
      if (selectionChanged) {
        // this.liveTrackingStore.selectedVehicles = selectedCardsData;
        this.liveTrackingStore.selectedVehicles = selectedCardsData.filter((v) =>
          this.isValidLatLng(v.latitude, v.longitude),
        );
      }

      const isAllSelected =
        !!this.liveTrackingStore?.allVehicleCount &&
        this.liveTrackingStore.allVehicleCount === selectedCardsData.length;

      // CHANGE 2: new variable. Recompute select-all only when the selection
      // changed, otherwise keep the previous value (so focusing never unchecks).
      const selectAllChecked = selectionChanged
        ? isAllSelected
        : prevState.selectAllChecked;

      if (this.mapRef && selectedCardsData.length > 0) {
        const map = this.mapRef;

        if (!fromCheckbox && focusedVehicleId) {
          const focusedVehicle = selectedCardsData.find(
            (v) => v.vehicleId === focusedVehicleId,
          );

          if (focusedVehicle) {
            this.setFocusedVehicleOnMap(focusedVehicle);
            this.updateVehiclePositions(focusedVehicle);
          }

          // CHANGE 3: removed the dead block here:
          // if (this.state.focusedVehicleId === val.vehicleId && isSelected) {
          //   focusedVehicleId = null;
          //   this.clearFocusedVehicleFromMap();
          // }
          // (focusedVehicleId is already handled in the if/else above)

          if (
            focusedVehicle &&
            this.isValidLatLng(focusedVehicle.latitude, focusedVehicle.longitude)
          ) {
            map.jumpTo({
              center: [Number(focusedVehicle.longitude), Number(focusedVehicle.latitude)],
              zoom: 19,
            });
            this.setState({ lockedZoom: 19 });
          }
          return {
            selectedCardsData,
            focusedVehicleId,
            selectAllChecked, // CHANGE 4a: was `selectAllChecked: isAllSelected`
            focusedVehicle,
          };
        }

        if (selectedCardsData.length === 1) {
          const v = selectedCardsData[0];
          // if (v.latitude != null && v.longitude != null) {
          //   map.jumpTo({ center: [v.longitude, v.latitude], zoom: 15 });
          //   this.setState({ lockedZoom: 15 });
          // }
          if (this.isValidLatLng(v.latitude, v.longitude)) {
            map.jumpTo({ center: [Number(v.longitude), Number(v.latitude)], zoom: 15 });
            this.setState({ lockedZoom: 15 });
          }
        } else if (!focusedVehicleId) {
          const bounds = new maplibregl.LngLatBounds();
          // selectedCardsData.forEach((v) => {
          //   if (v.latitude != null && v.longitude != null) {
          //     bounds.extend([v.longitude, v.latitude]);
          //   }
          // });
          selectedCardsData.forEach((v) => {
            if (this.isValidLatLng(v.latitude, v.longitude)) {
              bounds.extend([Number(v.longitude), Number(v.latitude)]);
            }
          });
          if (!bounds.isEmpty()) {
            map.fitBounds(bounds, { padding: 60, duration: 800 });
          }
        }
      }

      return {
        selectedCardsData,
        focusedVehicleId,
        selectAllChecked, // CHANGE 4b: was `selectAllChecked: isAllSelected`
      };
    });

    this.setState({ vehicleOtherInfo: false, selectedVehicleId: null });
  };

  cancelAllAnimations = () => {
    Object.values(this.activeAnimations).forEach((id) =>
      cancelAnimationFrame(id),
    );
    this.activeAnimations = {};

    if (this.focusedAnimationFrame) {
      cancelAnimationFrame(this.focusedAnimationFrame);
      this.focusedAnimationFrame = null;
    }
  };

  clearFocusedVehicleFromMap = () => {
    if (!this.mapRef) return;

    // if (this.focusedAnimationFrame) {
    //   cancelAnimationFrame(this.focusedAnimationFrame);
    //   this.focusedAnimationFrame = null;
    // }
    const source = this.mapRef.getSource("focusedVehicle");
    if (!source) return;

    // source.setData({
    //   type: "Feature",
    //   geometry: {
    //     type: "Point",
    //     coordinates: [0, 0],
    //   },
    //   properties: {},
    // });
    source.setData({
      type: "FeatureCollection",
      features: [], // better than [0,0]
    });
  };
  showVehicleInfoCard = (val, index) => {
    const isFocused = this.state.focusedVehicleId === val.vehicleId;

    const card = (
      <Card
        className={`liveTrackingInfoCard
      ${this.state.focusedVehicleId === val.vehicleId
            ? "focused-card" //  ORANGE
            : this.state.selectedCardsData.some(
              (card) => card.vehicleId === val.vehicleId,
            )
              ? "selected-card"
              : ""
          }
    `}
        key={index}
        onClick={() => this.toggleVehicleSelection(val)}
      >
        <div className="card1stRow">
          <div className="vehicleInfoRow">
            <Checkbox
              checked={this.state.selectedCardsData.some(
                (card) => card.vehicleId === val.vehicleId,
              )}
              onClick={(e) => e.stopPropagation()}
              onChange={() => this.toggleVehicleSelection(val, true)}
            />

            <Image
              style={{
                width: "40px",
                height: "20px",
              }}
              src={
                val.listImage
                  ? require("../assets/images/detailtracking/" + val.listImage)
                  : carIcon
              }
            ></Image>
            <span className="vehicleNoStyle">
              <AntTooltip title={val.vehicleNo} position="topLeft">
                <Link
                  onClick={async (e) => {
                    e.stopPropagation(); // Prevent card onClick from firing
                    this.setState(
                      {
                        selectedVehicleId: val.vehicleId,
                        vehicleOtherInfo: val, // immediate data
                      },
                      () => {
                        this.getVehicleOtherInfo(val.vehicleId);
                      },
                    );
                  }}
                >
                  {" "}
                  {val.vehicleNo}
                </Link>
              </AntTooltip>
            </span>
          </div>
          <div className="power-icon-col">
            <Image
              style={{
                width: "16px",
                height: "16px",
              }}
              src={
                val.power === 0
                  ? powerIconGreen
                  : val.power === 1
                    ? powerIconRed
                    : powerIconGray
              }
            ></Image>
          </div>
          <div className="speed-icon-col">
            <Image
              style={{
                width: "16px",
                height: "16px",
                flexShrink: 0,
              }}
              src={odometerIcon}
            ></Image>

            <span className="speedStyle">{val?.speed}Kmph</span>
          </div>
        </div>

        <div className="card2ndRow">
          <span className="date-time-class">
            {config.pythonReport === 1
              ? dayjs.utc(val.updatedate).format("DD-MM-YYYY | hh:mm:ss A")
              : dayjs(val.updatedate).format("DD-MM-YYYY | hh:mm:ss A")}
          </span>

          {val.name && (
            <AntTooltip title={val.driverphone ? `Mob : ${val.driverphone}` : "Mob : -"}
              position="topLeft">
              <span className="driver-info-class">
                {val.name}
                {/* {val.driverphone ? ` (${val.driverphone})` : ""} */}
              </span>
            </AntTooltip>
          )}
        </div>
        <div className="card3rdRow">
          <div
            style={{
              display: "flex",
              width: "90%",
              gap: "5px",
            }}
          >
            <Image
              style={{
                width: "16px",
                height: "16px",
                flexShrink: 0,
              }}
              src={locationIcon}
            ></Image>
            <span className="location-class">
              <AntTooltip title={val.formatted_address} position="topLeft">
                {" "}
                {val.formatted_address}
              </AntTooltip>
            </span>
          </div>

          <AntTooltip
            color="white"
            placement="left"
            title={
              <div>
                <div className="show-info-cls">
                  {this.context.translate('_LOAD_VOLTAGE_')}
                  <span className="show-info-fields-cls">
                    {val.loadVoltage ? val.loadVoltage : "-"}
                  </span>
                </div>
                <div className="show-info-cls">
                  {this.context.translate('_TEMPERATURE_')}
                  <span className="show-info-fields-cls">
                    {val.temperature ? val.temperature : "-"}
                  </span>
                </div>
                <div className="show-info-cls">
                  {this.context.translate('_TOTAL_WEIGHT_')}
                  <span className="show-info-fields-cls">
                    {val.emptyWeight ? val.emptyWeight : "-"}
                  </span>
                </div>
              </div>
            }
          >
            <Image
              style={{
                width: "14.7px",
                height: "14.7px",
                aspectRatio: 14.7 / 14.7,
              }}
              src={kebabIcon}
            />
          </AntTooltip>
          {/* <AntTooltip
            color="white"
            overlayClassName="driverInfoTooltip"
            placement="left"
            title={
              <div>
                <div>
                  <Image
                    src={motionIcon}
                    style={{ width: 16, marginRight: 4 }}
                  />{" "}
                  <span
                    className={`motionIconStyle ${this.getStatusColorClass(
                      val.currentStatus,
                    )}`}
                  >
                    {val.currentStatus}
                  </span>
                </div>
                <div>
                  <Image
                    src={personIconTooltip}
                    style={{ width: 16, marginRight: 4 }}
                  />{" "}
                  <span className="personIconStyle">
                    {val.name ? val.name : "-"}
                  </span>
                </div>
                <div>
                  <Image
                    src={telephone}
                    style={{ width: 16, marginRight: 4 }}
                  />{" "}
                  <span className="telephoneIconStyle">
                    {val.driverphone ? val.driverphone : "-"}
                  </span>
                </div>
              </div>
            }
          >
            <Image
              style={{
                width: "14.7px",
                height: "14.7px",
                aspectRatio: 14.7 / 14.7,
              }}
              src={personIcon}
            ></Image>
          </AntTooltip> */}
        </div>
      </Card>
    )
    return isFocused ? (
      card
    ) : (
      <AntTooltip title="Double click card to focus vehicle">
        {card}
      </AntTooltip>
    );
  };

  getAllVehicleGroups = async () => {
    const groups = await this.liveTrackingStore.getAllDeviceGroups({
      companyId: this.props.getUserData().userCompanyId,
    });

    this.setState({ vehicleGroups: groups.data.data });
  };

  handleGrpCheckboxChange = (e, groupId) => {
    const { checked } = e.target;
    const allVehicles = this.state.vehicleGroupData?.[groupId] || [];

    const newSelectAllGrpChecked = {};

    // Uncheck all groups first
    Object.keys(this.state.selectAllGrpChecked || {}).forEach((key) => {
      newSelectAllGrpChecked[key] = false;
    });

    // Only check current group if checked is true
    if (checked) {
      newSelectAllGrpChecked[groupId] = true;
    }

    const updatedVehicles = checked ? allVehicles : [];

    this.setState({
      selectAllGrpChecked: newSelectAllGrpChecked,
      selectedCardsData: updatedVehicles,
    });

    this.liveTrackingStore.selectedVehicles = updatedVehicles;

    if (checked && this.mapRef?.current) {
      const bounds = updatedVehicles
        .filter((v) => v.latitude !== null && v.longitude !== null)
        .map((v) => [v.latitude, v.longitude]);

      if (bounds.length > 0) {
        this.mapRef.current.fitBounds(bounds, { padding: [50, 50] });
      }
    }
  };

  isValidLatLng = (lat, lng) => {
    const la = Number(lat);
    const ln = Number(lng);
    return (
      lat != null && lng != null && lat !== "" && lng !== "" &&
      Number.isFinite(la) && Number.isFinite(ln) &&
      la >= -90 && la <= 90 && ln >= -180 && ln <= 180
    );
  };

  handleCheckboxChange = async (isChecked) => {

    // if (isChecked) {
    //   // fetch vehicles
    //   this.setState({ isPlottingVehicles: true, selectAllChecked: isChecked });

    //   try {
    //     await this.liveTrackingStore.getAllVehicles(this.state.companyId);

    //     // const allVehicles = this.liveTrackingStore?.plotAllVehicles || [];

    //     const allVehicles = (this.liveTrackingStore?.plotAllVehicles || []).filter(
    //       (v) => this.isValidLatLng(v.latitude, v.longitude),
    //     );

    //     const allVehicleData = this.liveTrackingStore?.liveTrackingData;
    //     // const allVehicleIds = allVehicles.map((v) => v.vehicleId);
    //     // const allVehicleIds = allVehicleData.map((v) => v.vehicleId);

    //     this.setState({
    //       // selectedCheckboxes: allVehicleIds,
    //       // selectedCardsData: isChecked ? allVehicles : [],
    //       // selectedCardsData: isChecked ? allVehicleData : [],
    //       selectedCardsData: allVehicleData,
    //     });

    //     // this.liveTrackingStore.selectedVehicles = isChecked ? allVehicles : [];

    //     // set vehicles to plot
    //     this.liveTrackingStore.selectedVehicles = allVehicles;

    //     const map = this.mapRef;
    //     // fit bounds
    //     if (map) {
    //       const bounds = new maplibregl.LngLatBounds();
    //       allVehicles.forEach((v) => {
    //         if (v.latitude != null && v.longitude != null) {
    //           bounds.extend([v.longitude, v.latitude]);
    //         }
    //       });

    //       if (!bounds.isEmpty()) {
    //         map.fitBounds(bounds, { padding: 60, duration: 800 });
    //       }
    //     }
    //     // this.setState({ isPlottingVehicles: false });
    //     this.waitForMapIdle();
    //   } finally {
    //     this.setState({ isPlottingVehicles: false });
    //   }
    // }
    if (isChecked) {
      this.setState({ isPlottingVehicles: true, selectAllChecked: true });

      try {
        await this.liveTrackingStore.getAllVehicles(this.state.companyId);

        const fullFleet = this.liveTrackingStore?.plotAllVehicles || [];
        const plottable = fullFleet.filter((v) =>
          this.isValidLatLng(v.latitude, v.longitude),
        );

        // state keeps the whole fleet, the map gets only vehicles with valid coordinates
        this.setState({ selectedCardsData: fullFleet });
        this.liveTrackingStore.selectedVehicles = plottable;

        const map = this.mapRef;
        if (map && plottable.length) {
          const bounds = new maplibregl.LngLatBounds();
          plottable.forEach((v) =>
            bounds.extend([Number(v.longitude), Number(v.latitude)]),
          );
          if (!bounds.isEmpty()) {
            map.fitBounds(bounds, { padding: 60, duration: 800 });
          }
        }

        this.waitForMapIdle();
      } finally {
        this.setState({ isPlottingVehicles: false });
      }
    } else {
      const allVehicles = this.liveTrackingStore?.plotAllVehicles || [];
      this.liveTrackingStore.selectedVehicles = [];

      this.setState({
        selectAllChecked: isChecked,
        selectedCardsData: isChecked ? allVehicles : [],
        selectedCheckboxes: [],
        isPlottingVehicles: false,
        focusedVehicleId: null,
      });

      this.clearFocusedVehicleFromMap();
    }
  };

  waitForMapIdle = () => {
    const map = this.mapRef;

    if (!map) return;

    map.once("idle", () => {
      this.setState({ isPlottingVehicles: false });
    });
  };

  getColor = (status) => {
    if (status === "Stopped") {
      return "tooltip-status-stopped";
    } else if (status === "Running") {
      return "tooltip-status-running";
    } else if (status === "Idle") {
      return "tooltip-status-Idle";
    } else if (status === "No Data") {
      return "tooltip-status-no-data";
    }
  };

  clearTrackingPolyline = () => {
    this.setState({ trackingPolylineData: null });
  };

  clearPolyline = () => {
    this.setState({ polylineData: null });
  };

  onGeofenceCreate = (data) => {
    console.log(data, "data")
    // shapeType === "circle" ? 2 : shapeType === "rectangle" ? 1 : 3
    this.setState({
      drawingBounds: data.drawingBounds,
      GeofancenType:
        data.type === "circle" ? 2 : data.type === "rectangle" ? 1 : 3,
      radius: data.radius,
      centerLatLng: data?.center
    });

    // optional auto-fill address
    this.formRef?.current?.setFieldsValue({
      address: data.address,
    });
  };

  onGeofenceUpdate = (data) => {
    console.log(data, "datta")
    this.setState({
      drawingBounds: data.drawingBounds,
      // GeofancenType:
      //   data.type === "circle" ? 2 : data.type === "rectangle" ? 1 : 3,

      radius: data.radius,
      centerLatLng: data?.center
    });
  };

  handleMapClick = (point) => {
    console.log(point, "point");

    const { lng, lat } = point;

    this.setState({
      clickedMarker: { lng, lat },
    });
  };

  runWhenMapReady = (cb) => {
    if (!this.mapRef) return;

    if (this.mapRef.isStyleLoaded()) {
      cb();
    } else {
      this.mapRef.once("styledata", cb);
    }
  };

  showGeofencesOnMap = (selectedRows) => {
    console.log(selectedRows, "selectedRows")
    if (!this.mapRef || !Array.isArray(selectedRows)) return;

    this.runWhenMapReady(() => {
      const map = this.mapRef;

      ["geofence-fill", "geofence-outline"].forEach((id) => {
        if (map.getLayer(id)) map.removeLayer(id);
      });

      if (map.getSource("geofence-source")) {
        map.removeSource("geofence-source");
      }

      const features = [];

      for (const row of selectedRows) {
        if (!row || typeof row.points !== "string" || !row.points.trim()) {
          continue;
        }
        // Convert "lat,lng,0,lat,lng,0" → [[lat,lng], ...]
        const nums = row.points
          .split(",")
          .map(Number)
          .filter((_, idx) => idx % 3 !== 2);

        const coords = [];
        for (let i = 0; i < nums.length; i += 2) {

          const lat = nums[i];
          const lng = nums[i + 1];

          // Skip invalid numbers
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) continue;
          // coords.push([nums[i + 1], nums[i]]); // [lng, lat]
          coords.push([lng, lat]);
        }

        //  Circle
        let geometry = null;

        if (coords.length === 1) {
          const radius = row.radius || 100;
          geometry = turf.circle(coords[0], radius / 1000, {
            steps: 64,
            units: "kilometers",
          }).geometry;
        }

        // Rectangle
        else if (coords.length === 2) {
          const bounds = turf.bboxPolygon([
            Math.min(coords[0][0], coords[1][0]),
            Math.min(coords[0][1], coords[1][1]),
            Math.max(coords[0][0], coords[1][0]),
            Math.max(coords[0][1], coords[1][1]),
          ]);
          geometry = bounds.geometry;
        }

        // Polygon
        else if (coords.length > 2) {
          // close polygon
          if (
            coords[0][0] !== coords[coords.length - 1][0] ||
            coords[0][1] !== coords[coords.length - 1][1]
          ) {
            coords.push(coords[0]);
          }

          geometry = {
            type: "Polygon",
            coordinates: [coords],
          };
        }

        if (!geometry) continue;

        features.push({
          type: "Feature",
          geometry,
          properties: {
            zoneId: row.zoneId,
            name: row.name,
          },
        });
      }

      if (!features.length) return;

      // Add GeoJSON source
      map.addSource("geofence-source", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features,
        },
      });

      //  Fill layer
      map.addLayer({
        id: "geofence-fill",
        type: "fill",
        source: "geofence-source",
        paint: {
          "fill-color": "#ff0000",
          "fill-opacity": 0.3,
        },
      });

      //  Outline layer
      map.addLayer({
        id: "geofence-outline",
        type: "line",
        source: "geofence-source",
        paint: {
          "line-color": "#ff0000",
          "line-width": 2,
        },
      });

      // Zoom to all geofences
      const bbox = turf.bbox({
        type: "FeatureCollection",
        features,
      });

      map.fitBounds(bbox, { padding: 60, duration: 800 });
    });
  };

  normalizeGeometry = (g) => {
    if (!g) return null;

    // Already valid
    if (g.type === "Polygon" || g.type === "MultiPolygon") {
      return g;
    }

    // If geometry is string
    if (typeof g === "string") {
      return JSON.parse(g);
    }

    return null;
  };

  removePlottedGeofences = () => {
    if (!this.mapRef) return;

    // Remove layers
    ["geofence-fill", "geofence-outline"].forEach((layerId) => {
      if (this.mapRef.getLayer(layerId)) {
        this.mapRef.removeLayer(layerId);
      }
    });

    // Remove source
    if (this.mapRef.getSource("geofence-source")) {
      this.mapRef.removeSource("geofence-source");
    }
  };

  setNearestAssetData = (data) => {
    // console.log("Parent received data:", data);
    this.setState({ nearestAssetData: data });
  };

  updateVehiclePositions = (newVehicles) => {
    // console.log(newVehicles, "newVehicles");
    if (!newVehicles) return;

    const vehicles = Array.isArray(newVehicles) ? newVehicles : [newVehicles];

    vehicles.forEach((v) => {
      const prev = this.previousVehiclePositions[v.vehicleId];

      // console.log(prev, "prev");
      this.previousVehiclePositions[v.vehicleId] = {
        latitude: v.latitude,
        longitude: v.longitude,
        prevLatitude: prev?.latitude ?? v.latitude,
        prevLongitude: prev?.longitude ?? v.longitude,
      };
    });
  };

  // animateVehicleMovement = (
  //   vehicle,
  //   vehicleId,
  //   fromLngLat,
  //   toLngLat,

  //   rotation,
  //   mapImage
  // ) => {
  //   if (!this.mapRef) return;

  //   const start = performance.now();

  //   const animate = (time) => {
  //     if (this.state.focusedVehicleId !== vehicleId) {
  //       cancelAnimationFrame(this.focusedAnimationFrame);
  //       return;
  //     }
  //     // const distance = this.calculateDistance(fromLngLat, toLngLat);

  //     const targetRotation = this.getBearing(fromLngLat, toLngLat);
  //     const startRotation = rotation ?? targetRotation;

  //     const speed = 10; // slow, realistic

  //     // console.log(distance, "distance");
  //     // let duration = (distance / speed) * 1000;
  //     // duration = Math.min(duration, 15000);

  //     // const elapsedTime = time - start;
  //     // const progress = Math.min(elapsedTime / duration, 1);

  //     // const progress = Math.min((time - start) / duration, 1);

  //     if (!this.lastFrameTime) this.lastFrameTime = time;

  //     console.log(this.lastFrameTime, "this.lastFrameTime");
  //     const deltaTime = (time - this.lastFrameTime) / 1000; // seconds
  //     this.lastFrameTime = time;

  //     const distance = this.calculateDistance(fromLngLat, toLngLat);
  //     console.log(distance, "distance");
  //     const moveDistance = speed * deltaTime; // meters to move this frame
  //     const progressStep = moveDistance / distance;

  //     this.currentProgress = (this.currentProgress || 0) + progressStep;

  //     const progress = Math.min(this.currentProgress, 1);

  //     const lng = fromLngLat[0] + (toLngLat[0] - fromLngLat[0]) * progress;
  //     const lat = fromLngLat[1] + (toLngLat[1] - fromLngLat[1]) * progress;

  //     // console.log(lng, lat, "lng, lat");
  //     const currentRotation =
  //       startRotation + (targetRotation - startRotation) * progress;

  //     // console.log(currentRotation, "currentRotation");

  //     const source = this.mapRef.getSource("focusedVehicle");
  //     if (!source) return;
  //     // Update marker source (GeoJSON)
  //     source.setData({
  //       type: "Feature",
  //       geometry: {
  //         type: "Point",
  //         coordinates: [lng, lat],
  //       },
  //       properties: {
  //         ...vehicle,
  //         rotation: currentRotation,
  //         mapImage: vehicle.mapImage,
  //       },
  //     });

  //     // console.log(this.mapRef.getZoom(), " this.mapRef.getZoom()");
  //     if (this.state.focusedVehicleId === vehicleId && lat && lng) {
  //       this.mapRef.easeTo({
  //         center: [lng, lat],
  //         duration: 0, // small duration → smooth follow
  //         zoom: 16, // keep current zoom
  //         essential: true,
  //       });
  //     }

  //     if (progress < 1) {
  //       this.focusedAnimationFrame = requestAnimationFrame(animate);
  //     } else {
  //       this.currentProgress = 0;
  //       this.lastFrameTime = null;
  //     }
  //   };

  //   this.focusedAnimationFrame = requestAnimationFrame(animate);
  // };

  // Inside your class, initialize an object to track frames
  // this.activeAnimations = {};

  animateVehicleMovement = (
    vehicle,
    vehicleId,
    fromLngLat,
    toLngLat,
    rotation,
    mapImage,
  ) => {
    if (!this.mapRef) return;

    // 1. IMPORTANT: Cancel existing animation for THIS vehicle to stop the blinking
    if (this.activeAnimations[vehicleId]) {
      cancelAnimationFrame(this.activeAnimations[vehicleId]);
    }

    const distance = this.calculateDistance(fromLngLat, toLngLat);

    const speed = 20;
    const duration = (distance / speed) * 1000;

    // Skip animation if movement is negligible
    // if (distance < 0.5) {
    //   this.updateMarkerSource(toLngLat, vehicle, rotation);
    //   return;
    // }

    const start = performance.now();
    const targetRotation = this.getBearing(fromLngLat, toLngLat);
    const startRotation = rotation ?? targetRotation;

    const animate = (time) => {
      // 2. Stop if the user switched focus
      if (this.state.focusedVehicleId !== vehicleId) {
        delete this.activeAnimations[vehicleId];
        return;
      }

      const elapsedTime = time - start;
      const progress = Math.min(elapsedTime / duration, 1);

      const lng = fromLngLat[0] + (toLngLat[0] - fromLngLat[0]) * progress;
      const lat = fromLngLat[1] + (toLngLat[1] - fromLngLat[1]) * progress;

      const currentRotation =
        startRotation + (targetRotation - startRotation) * progress;

      const source = this.mapRef.getSource("focusedVehicle");
      if (source) {
        source.setData({
          type: "Feature",
          geometry: { type: "Point", coordinates: [lng, lat] },
          properties: {
            ...vehicle,
            rotation: currentRotation,
            mapImage: vehicle.mapImage,
          },
        });
      }

      const map = this.mapRef;
      if (
        this.state.focusedVehicleId === vehicleId &&
        Number.isFinite(lat) &&
        Number.isFinite(lng) &&
        !map.isMoving() // skips frames while the user is zooming, panning or rotating
      ) {
        map.easeTo({
          center: [lng, lat],
          duration: 0,
          essential: true,
        });
      }

      // if (this.state.focusedVehicleId === vehicleId && lat && lng) {
      //   this.mapRef.easeTo({
      //     center: [lng, lat],
      //     duration: 0,
      //     zoom: 16,
      //     essential: true,
      //   });
      // }

      if (progress < 1) {
        // Store the new frame ID
        this.activeAnimations[vehicleId] = requestAnimationFrame(animate);
      } else {
        delete this.activeAnimations[vehicleId];
      }
    };

    // Start the initial frame
    this.activeAnimations[vehicleId] = requestAnimationFrame(animate);
  };

  setFocusedVehicleOnMap = (vehicle) => {
    if (!this.mapRef || !vehicle) return;

    const source = this.mapRef.getSource("focusedVehicle");
    if (!source) return;

    source.setData({
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [vehicle.longitude, vehicle.latitude],
      },
      properties: {
        ...vehicle,
        rotation: parseFloat(vehicle.direction),
        mapImage: vehicle.mapImage,
      },
    });
  };

  getBearing = (from, to) => {
    const [lng1, lat1] = from.map((v) => (v * Math.PI) / 180);
    const [lng2, lat2] = to.map((v) => (v * Math.PI) / 180);

    const y = Math.sin(lng2 - lng1) * Math.cos(lat2);
    const x =
      Math.cos(lat1) * Math.sin(lat2) -
      Math.sin(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1);

    let bearing = (Math.atan2(y, x) * 180) / Math.PI;
    return (bearing + 360) % 360; // normalize
  };

  // toggleTraffic(mapRef) {
  //   const map = mapRef;

  //   const currentVisibility = map.getLayoutProperty(
  //     "google-traffic-layer",
  //     "visibility"
  //   );

  //   const newVisibility = currentVisibility === "visible" ? "none" : "visible";

  //   map.setLayoutProperty("google-traffic-layer", "visibility", newVisibility);
  // }

  toggleTraffic = (mapRef) => {
    const map = mapRef;

    if (!map) return;
    if (!map.getLayer("google-traffic-layer")) return;

    const currentVisibility =
      map.getLayoutProperty("google-traffic-layer", "visibility") || "none";

    const isVisible = currentVisibility === "visible";

    map.setLayoutProperty(
      "google-traffic-layer",
      "visibility",
      isVisible ? "none" : "visible",
    );
  };

  createNewPoi = async (values) => {
    const vehicle = this.state.selectedPoiVehicleData;
    console.log(this.state.updateClickedPoi)
    const data = {
      ...values,
      companyId: this.state.createPoiCompanyId,
      latitude: this.state.drawGeoLocationLatLng.latitude,
      longitude: this.state.drawGeoLocationLatLng.longitude,
      // latitude: this.state.updateClickedPoi.latitude ? this.state.updateClickedPoi.latitude : vehicle.latitude,
      // longitude: this.state.updateClickedPoi.longitude ? this.state.updateClickedPoi.longitude : vehicle.longitude,
      poiId: this.state.poiId,
      Photo: this.state.Photo
    }
    // debugger
    const response = await this.liveTrackingStore.addPoiData(data)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ showNewPoiPopup: false });
      if (this.vehicleMarker) {
        this.vehicleMarker.remove();
      }
    } else {
      message.error(response.data.message);
    }
  };

  // toggleTraffic = (mapRef) => {
  //   const map = mapRef;
  //   if (!map || !map.getLayer("google-traffic-layer")) return;

  //   const currentVisibility =
  //     map.getLayoutProperty("google-traffic-layer", "visibility") || "none";
  //   const nextVisibility = currentVisibility === "visible" ? "none" : "visible";

  //   console.log("first", currentVisibility, nextVisibility);
  //   if (nextVisibility === "visible") {
  //     // Move the traffic layer to the very top so it's not hidden by base maps
  //     map.moveLayer("google-traffic-layer");
  //   }

  //   map.setLayoutProperty("google-traffic-layer", "visibility", nextVisibility);
  // };
  showAllPoiData = async () => {
    if (this.state.showPoicompanyId) {
      const data = await this.liveTrackingStore.showAllPois(this.state.showPoicompanyId)
      this.setState({ showAllPoiData: data, showAllPoi: false })
    }

  }

  searchPoiData = async () => {
    if (this.state.searchPoicompanyId && this.state.selectedPoiId) {
      const response = await this.liveTrackingStore.searchPoiData(this.state.searchPoicompanyId, this.state.selectedPoiId)
      console.log(response, "response")
      this.setState({ showSearchPoiData: response, searchPoi: false })
    }

  }
  plotSelectedVehicle = () => {
    const map = this.mapRef;
    const vehicle = this.state.selectedPoiVehicleData;
    if (!map || !vehicle?.latitude || !vehicle?.longitude) return;

    const coords = [
      Number(vehicle.longitude),
      Number(vehicle.latitude),
    ];

    // Remove old marker if exists
    if (this.vehicleMarker) {
      this.vehicleMarker.remove();
    }

    // Add new marker
    this.vehicleMarker = new maplibregl.Marker()
      .setLngLat(coords)
      .setPopup(
        new maplibregl.Popup().setText(vehicle.vehicleNo || "Vehicle")
      )
      .addTo(map);

    // Zoom to vehicle
    map.flyTo({
      center: coords,
      zoom: 15,
      duration: 800,
    });
  };

  fillPoiData = async (poiData) => {

    this.setState({ createPoiCompanyId: poiData?.companyId, poiId: poiData?.poiId })
    const singleData = await this.companyStore.getCompanyDataById(
      poiData.companyId,
    );
    console.log(poiData, "poidata")
    await this.liveTrackingStore.poiCurrentVehicleUsingCompanyId({ companyId: poiData.companyId })
    this.setState({ loadData: 1 })
    this.formRef.current.setFieldsValue({
      companyId: singleData,
      Address: poiData.Address,
      poiText: poiData.poiText,
      Customer: poiData.Customer,
      Phoneno: poiData.Phoneno,
      Type: Number(poiData.Type),
      poiId: poiData.poiId,
      latitude: poiData.latitude,
      longitude: poiData.longitude
    })
  }
  onDeletePoi = async () => {
    const response = await this.liveTrackingStore.deletePoiData(this.state.poiId)

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ showAlertPoiPopup: false, showNewPoiPopup: false, showSearchPoiData: [], showAllPoiData: [] });

    } else {
      message.error(response.data.message);
    }
  }

  onImportPoiExcelSubmit = async () => {
    const data = {
      companyId: this.state.excelPoiCompanyId,
      excelFile: this.state.excelFile
    }


    if (data.excelFile) {
      const resp = await this.liveTrackingStore.addPOIByExcel(data)


      if (resp?.success == "S") {
        message.success(resp.message);

        this.setState({ importExcelFromPoi: false });
        this.setState({ excelFile: "" });
        this.formRef.current?.resetFields();
      } else {
        message.error(resp.message);
      }
    } else {
      message.error("Please Upload Excel File");
    }
  }

  getUploadPoiData = async (fileUp) => {
    let fileinfo = fileUp.file.response;

    if (fileinfo?.success == "S") {
      // console.log(fileinfo.data)

      await this.setState({ excelFile: fileinfo.data });
    }

    this.setState({ update: 1 });
  };

  uploadPOIFunction = async ({ file, onSuccess, onError, onProgress }) => {
    try {
      const formData = new FormData();
      formData.append("excelFile", file);
      formData.append("fileType", "accountimport");
      formData.append("fieldName", "excelFile");

      const response = await axios.post(
        // config.baseURL + this.companyStore.fileUploadUrl,
        config.NodeUrl + "/pointOfInterest/uploadExcel",
        formData,
        {
          headers: {
            token: this.state.token,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (event) => {
            const percent = Math.round((event.loaded * 100) / event.total);
            onProgress({ percent });
          },
        }
      );

      onSuccess(response.data);
    } catch (error) {
      onError(error);
    }
  };

  uploadFunction = async ({ file, onSuccess, onError, onProgress }) => {
    try {

      console.log(file, onSuccess, onError, onProgress, "uploadFunction")
      const formData = new FormData();
      formData.append("photo", file);
      formData.append("fileType", "photo");
      formData.append("fieldName", "photo");

      const response = await axios.post(
        // config.baseURL + this.companyStore.fileUploadUrl,
        config.NodeUrl + "/pointOfInterest/filePoiUpload",
        formData,
        {
          headers: {
            token: this.state.token,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (event) => {
            const percent = Math.round((event.loaded * 100) / event.total);
            onProgress({ percent });
          },
        }
      );

      onSuccess(response.data);
    } catch (error) {
      onError(error);
    }
  };

  setAddressFromLatLng = async (lat, lng) => {
    if (!lat || !lng) return;

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
      );
      const data = await response.json();

      const address = data.display_name;

      this.formRef?.current?.setFieldsValue({ Address: address });
      this.setState({ drawGeoLocation: address });
    } catch (err) {
      console.error("Reverse geocode error:", err);
    }
  };

  // setAddressFromLatLng = async (lat, lng) => {

  //   console.log(lat, lng, "sdfghjsdfghjkheghgfdsdhgfdsdf")
  //   if (!lat || !lng) return;

  //   const geocoder = new window.google.maps.Geocoder();

  //   console.log(geocoder, "geocoder")
  //   geocoder.geocode({ location: { lat, lng } }, (results, status) => {

  //     console.log("first", results, status)
  //     if (status === "OK" && results[0]) {
  //       // Update your form field
  //       this.formRef?.current?.setFieldsValue({
  //         Address: results[0].formatted_address,
  //       });

  //       console.log(results[0].formatted_address, "results[0].formatted_address")
  //       // Optional: store in state
  //       this.setState({ drawGeoLocation: results[0].formatted_address });
  //     } else {
  //       console.error("Geocoder failed:", status);
  //     }
  //   });
  // };

  getAddressUsingLatLng = async (address) => {
    // console.log(address, "address");
    // this.setState({ markersAddress: address });
    this.setState((prev) => ({
      markersAddress: [
        ...prev.markersAddress,
        {
          key: prev.markersAddress.length + 1,
          address,
        },
      ],
    }));
  };

  removeRouteAndMarkers = () => {
    if (this.mapRef.getSource("route")) {
      this.mapRef.removeLayer("route-line");
      this.mapRef.removeSource("route");
    }

    this.originMarker?.remove();
    this.destMarker?.remove();

    this.originMarker = null;
    this.destMarker = null;
  };

  fitRouteToMap = (coordinates) => {
    const map = this.mapRef;

    if (!map || !coordinates || !coordinates.length) return;

    const bounds = new maplibregl.LngLatBounds();

    coordinates.forEach((coord) => {
      bounds.extend(coord);
    });

    map.fitBounds(bounds, {
      padding: 80,
      duration: 800,
      maxZoom: 15,
    });
  };

  drawRoute = async (origin, destination) => {
    if (!window.google || !window.google.maps) {
      console.error("Google Maps JS API not loaded");
      return;
    }

    const directionsService = new window.google.maps.DirectionsService();

    const request = {
      origin: { lat: origin.lat, lng: origin.lng },
      destination: { lat: destination.lat, lng: destination.lng },
      travelMode: window.google.maps.TravelMode.DRIVING,
    };

    directionsService.route(request, (result, status) => {
      if (status !== "OK" || !result.routes.length) {
        console.error("Directions failed:", status);
        return;
      }

      const route = result.routes[0];
      const leg = route.legs[0];

      // ✅ Distance
      const distanceMeters = leg.distance.value;
      const distanceKm = (distanceMeters / 1000).toFixed(2);

      this.setState({
        distance: distanceKm,
        showCalculatedDist: distanceKm,
      });

      // ✅ Convert path → MapLibre format
      const coordinates = route.overview_path.map((p) => [
        p.lng(),
        p.lat(),
      ]);

      const map = this.mapRef;

      // cleanup old route
      if (map.getSource("route")) {
        map.removeLayer("route-line");
        map.removeSource("route");
      }

      // add new route
      map.addSource("route", {
        type: "geojson",
        data: {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates,
          },
        },
      });

      map.addLayer({
        id: "route-line",
        type: "line",
        source: "route",
        paint: {
          "line-color": "#1e90ff",
          "line-width": 5,
        },
      });

      // markers
      this.originMarker?.remove();
      this.destMarker?.remove();

      this.originMarker = new maplibregl.Marker({ color: "red" })
        .setLngLat([origin.lng, origin.lat])
        .addTo(map);

      this.destMarker = new maplibregl.Marker({ color: "red" })
        .setLngLat([destination.lng, destination.lat])
        .addTo(map);

      this.fitRouteToMap(coordinates);
    });
  };
  // drawRoute = async (origin, destination) => {
  //   // const url = `https://router.project-osrm.org/route/v1/driving/${origin.lng},${origin.lat};${destination.lng},${destination.lat}?overview=full&geometries=geojson`;
  //   // const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${origin.lat},${origin.lng}&key=${config.googleMapKey}`;
  //   // const url = `http://44.232.69.150/reverse.php?lat=${origin.lat}&lon=${origin.lng}&format=jsonv2&accept-language=en`;

  //   const url = `https://maps.googleapis.com/maps/api/directions/json?origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&key=${config.googleMapKey}`;
  //   const res = await fetch(url);
  //   const data = await res.json();

  //   if (!data.routes || !data.routes.length) return;

  //   const encodedPolyline = data.routes[0].overview_polyline.points;

  //   const decoded = polyline.decode(encodedPolyline);

  //   const coordinates = decoded.map((coord) => [coord[1], coord[0]]);

  //   // console.log(coordinates, "coordinates");
  //   // console.log(data, "data", url, res, "res");
  //   // const distanceMeters = data?.routes[0].distance;
  //   // const distanceKm = (distanceMeters / 1000).toFixed(2);

  //   const distanceMeters = data.routes[0].legs[0].distance.value;

  //   const distanceKm = (distanceMeters / 1000).toFixed(2);

  //   this.setState({ distance: distanceKm, showCalculatedDist: distanceKm });
  //   // const route = data.routes[0].geometry;

  //   const map = this.mapRef;

  //   // cleanup old route
  //   if (map.getSource("route")) {
  //     map.removeLayer("route-line");
  //     map.removeSource("route");
  //   }

  //   const geojson = {
  //     type: "Feature",
  //     geometry: {
  //       type: "LineString",
  //       coordinates: coordinates,
  //     },
  //   };

  //   //     map.addSource("route", {
  //   //   type: "geojson",
  //   //   data: {
  //   //     type: "Feature",
  //   //     geometry: route,
  //   //   },
  //   // });
  //   map.addSource("route", {
  //     type: "geojson",
  //     data: geojson,
  //   });

  //   map.addLayer({
  //     id: "route-line",
  //     type: "line",
  //     source: "route",
  //     paint: {
  //       "line-color": "#1e90ff",
  //       "line-width": 5,
  //     },
  //   });

  //   this.originMarker?.remove();
  //   this.destMarker?.remove();

  //   // markers
  //   this.originMarker = new maplibregl.Marker({ color: "red" })
  //     .setLngLat([origin.lng, origin.lat])
  //     .addTo(map);

  //   this.destMarker = new maplibregl.Marker({ color: "red" })
  //     .setLngLat([destination.lng, destination.lat])
  //     .addTo(map);

  //   this.fitRouteToMap(coordinates);
  // };

  handleDeleteMarker = (key) => {
    const index = Number(key);
    this.setState(
      (prev) => ({
        markersAddress: prev.markersAddress
          .filter((_, i) => i !== index)
          .map((item, i) => ({ ...item, key: i })),
      }),
      () => {
        this.liveTrackingMapRef.current?.onDeleteMarkerkey(index);
      }
    );
  };

  handleAddAfterRow = (rowIndex) => {
    this.setState((prev) => {
      const newRow = {
        key: Date.now(),
        address: "",
        isNew: true,
      };

      const updated = [...prev.markersAddress];

      // insert AFTER current row
      updated.splice(rowIndex + 1, 0, newRow);

      return {
        markersAddress: updated,
      };
    });
  };

  // Add this handler
  handleLocationSearch = async () => {
    const input = this.state.selectedLatLng

    // Check if input is lat,lng format
    const latLngRegex = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;

    if (latLngRegex.test(input?.trim())) {
      const [lat, lng] = input.split(",").map((v) => parseFloat(v.trim()));

      await this.setState({
        selectedLatLng: { latitude: lat, longitude: lng },
      });

      await this.getInformationOfVehicle({
        latLong: { latitude: lat, longitude: lng },
      });

      // Pan map to that location
      if (this.mapRef) {
        this.mapRef.flyTo({
          center: [lng, lat],
          zoom: 15,
          duration: 800,
        });
      }
    } else {
      // Not lat,lng — handle as normal address search
      message.warning("Not a lat,lng input");
    }
  };

  handleMinimize = () => {
    this.setState((prev) => ({ minimized: !prev.minimized }));
  };


  render() {
    const formItemStyle = { marginBottom: "2px", marginTop: "2px" };

    const chatStore = this.context?.chatDriverStore;

    const hasUnread = chatStore?.hasUnreadMessages || false;

    const { minimized } = this.state;


    return (
      <div>
        {!this.state.showSlider && (
          <FloatButton.Group
            className={
              this.state.liveTrackingMainModal && this.state.closeCard
                ? "right-panel-btn-group floatBtnGroup"
                : "right-panel-btn-group-old floatBtnGroup"
            }
            shape="square"
          >
            <AntTooltip
              title={
                <span style={{ color: "#000" }}>
                  {this.context.translate("_FLEET_TRACKING_")}
                </span>
              }
              // title={this.context.translate("_FLEET_TRACKING_")}
              placement={
                this.context.locale.language === "arabic" ? "right" : "left"
              }
              color="white"
            >
              <FloatButton
                icon={
                  <Image
                    src={require("../assets/images/NewDesign/livetracking/map-fill.png")}
                  />
                }
                onClick={() => {
                  this.setState(
                    (prev) => {
                      const isOpen = prev.liveTrackingMainModal;

                      return {
                        liveTrackingMainModal: !isOpen,
                        showGeofenceWindow: !isOpen,
                        closeCard: !isOpen,
                      };
                    },
                    () => {
                      this.resizeAndCenterMap();

                      if (this.state.liveTrackingMainModal) {
                        this.setIntervals();
                        this.SearchMenuItemClick("liveTrackingMainModal");
                      }
                    },
                  );
                }}
              />
            </AntTooltip>

            <AntTooltip label="fererrre">
              <Popover
                content={
                  <Radio.Group
                    options={this.geofenceOptions}
                    value={this.state.drawGeofence}
                    onChange={(e) => {
                      this.selectGeofence(e);
                    }}
                    optionType="button"
                    buttonStyle="solid"
                  />
                }
                placement={
                  this.context.locale.language === "arabic" ? "right" : "left"
                }
              >
                <FloatButton.BackTop
                  icon={
                    <Image
                      src={require("../assets/images/NewDesign/livetracking/hurricane.png")}
                      onClick={async () => {
                        if (this.props.getUserData().isadmin === 1) {
                          await this.liveTrackingStore.getGofenceList({
                            companyId: this.props.getUserData().userCompanyId,

                            offset:
                              (this.state.currentPage - 1) *
                              this.state.pageSize,

                            limit: 50,
                          });
                          this.setState({ loadData: 1 });
                        }
                        // await this.setState({ showGofence: true });

                        this.setState({ showGeofenceWindow: false }, () => {
                          console.log(
                            this.state.showGeofenceWindow,
                            "showGeofenceWindow",
                          );
                        });
                        await this.SearchMenuItemClick("showGofence");
                      }}
                    />
                  }
                  visibilityHeight={0}
                />
              </Popover>
            </AntTooltip>

            <Popover
              content={
                <Space className="site-button-ghost-wrapper" wrap>
                  <Menu>
                    {this.poiMenus.map((s) => {
                      return (
                        <Menu.Item
                          icon={s.icon}
                          onClick={() => {
                            this.SearchMenuItemClick(s.key);
                          }}
                        >
                          {s.label}
                        </Menu.Item>
                      );
                    })}
                  </Menu>
                </Space>
              }
              placement={
                this.context.locale.language === "arabic" ? "right" : "left"
              }
            >
              <FloatButton
                icon={
                  <Image
                    src={require("../assets/images/NewDesign/livetracking/geo-alt-fill.png")}
                  />
                }
              />
            </Popover>


            <Popover
              content={
                <Space className="site-button-ghost-wrapper" wrap>
                  <Menu
                    style={{
                      width: 170,
                    }}
                    mode="vertical"
                  >
                    {this.searchMenu.map((s) => {
                      const showCheckbox =
                        s.key === "gas_station" ||
                        s.key === "hospital" ||
                        s.key === "policestation" ||
                        s.key === "garage";

                      return (
                        <Menu.Item key={s.key} icon={s.icon}>
                          {showCheckbox ? (
                            <Checkbox
                              checked={this.state.selectedPlaces?.includes(
                                s.key,
                              )}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                const { selectedPlaces } = this.state;

                                const updatedPlaces = checked
                                  ? [...selectedPlaces, s.key]
                                  : selectedPlaces.filter((k) => k !== s.key);
                                this.setState(
                                  { selectedPlaces: updatedPlaces },
                                  () => {
                                    if (checked) {
                                      this.SearchMenuItemClick(s.key, true);
                                    } else {
                                      // this.removePlacesFromMap(s.key);
                                      this.clearPOIMarkers(s.key);
                                    }
                                  },
                                );
                              }}
                            >
                              {s.label}
                            </Checkbox>
                          ) : (
                            // For other menu items (without checkbox)
                            <span
                              onClick={() => this.SearchMenuItemClick(s.key)}
                              style={{ cursor: "pointer" }}
                            >
                              {s.label}
                            </span>
                          )}
                        </Menu.Item>
                      );
                    })}

                    {/* {this.searchMenu.map((s) => {
                      return (
                        <Menu.Item
                          icon={s.icon}
                          onClick={() => {
                            this.SearchMenuItemClick(s.key);
                          }}
                        >
                          {s.label}
                        </Menu.Item>
                      );
                    })} */}
                  </Menu>
                </Space>
              }
              placement={
                this.context.locale.language === "arabic" ? "right" : "left"
              }
            >
              <FloatButton icon={<SearchOutlined />} />
            </Popover>
            <Popover
              content={
                <Spin spinning={this.state.loadingCheckbox}>
                  <Radio.Group
                    options={this.mapOptions}
                    onChange={async (v) => {
                      await this.setState({ loadingCheckbox: true });
                      setTimeout(() => {
                        this.setState({ loadingCheckbox: false });
                      }, 1000);
                      await this.handleMapTypeChange(v);
                    }}
                    value={this.state.mapType}
                    optionType="button"
                    buttonStyle="solid"
                  />
                </Spin>
              }
              placement={
                this.context.locale.language === "arabic" ? "right" : "left"
              }

            //   onOpenChange={handleOpenChange}
            >
              <FloatButton
                icon={
                  <Image
                    src={require("../assets/images/NewDesign/livetracking/geo-alt-fill.png")}
                  />
                }
              />
            </Popover>

            <Popover
              content={
                <Button onClick={() => this.props.navigate("/assigntriplist/")}>
                  {/* Create/Assign Trip */}
                  {this.context.translate(
                    "_FLEET_DASHBORD_NAVIRIGHT_CREATEROUTE_",
                  )}
                </Button>
              }
              placement={
                this.context.locale.language === "arabic" ? "right" : "left"
              }
            >
              <FloatButton.BackTop
                icon={
                  <Image
                    src={require("../assets/images/NewDesign/livetracking/pin-map-fill.png")}
                  />
                }
                visibilityHeight={0}
              />
            </Popover>

            {/* <FloatButton.BackTop
              icon={
                this.state.isLocked ? (
                  <Image
                    src={require("../assets/images/NewDesign/livetracking/UnlockIcon.png")}
                    onClick={async () => {
                      console.log("unlock map");
                      await this.setState((prevState) => ({
                        isLocked: !prevState.isLocked, // Toggle between true and false
                        lockedZoom: !prevState.isLocked ? this.mapRef.getZoom() : null,
                        lockedCenter: !prevState.isLocked ? this.mapRef.getCenter() : null,
                      }));
                      this.setIntervals();
                    }}
                  />
                ) : (
                  <Image
                    src={require("../assets/images/NewDesign/livetracking/LockIcon.png")}
                    onClick={async () => {
                      console.log("lock map");
                      await this.setState((prevState) => ({
                        isLocked: !prevState.isLocked, // Toggle between true and false
                      }));
                    }}
                  />
                )
              }
              visibilityHeight={0}
            /> */}

            <FloatButton.BackTop
              icon={
                this.state.isLocked ? (
                  <Image
                    src={require("../assets/images/NewDesign/livetracking/UnlockIcon.png")}
                    onClick={async () => {
                      console.log("unlock map");
                      await this.setState({
                        isLocked: false,
                        lockedZoom: null,   // 👈 clear on unlock
                        lockedCenter: null, // 👈 clear on unlock
                      });
                      this.setIntervals();
                    }}
                  />
                ) : (
                  <Image
                    src={require("../assets/images/NewDesign/livetracking/LockIcon.png")}
                    onClick={async () => {
                      console.log("lock map");
                      await this.setState({
                        isLocked: true,
                        lockedZoom: this.mapRef.getZoom(),   // 👈 save on lock
                        lockedCenter: this.mapRef.getCenter(), // 👈 save on lock
                      });
                      this.setIntervals();
                    }}
                  />
                )
              }
              visibilityHeight={0}
            />

            {/* <FloatButton.BackTop
              // className={
              //   this.state.mapType === "satellite" ? "re" : ""
              // }
              style={{ color: this.state.mapType === "satellite" ? "red" : "" }}
              onClick={() => {
                this.setState((prev) => ({
                  mapType:
                    prev.mapType === "satellite" ? "google" : "satellite",
                }));
              }}
              icon={
                <FaSatellite
                  style={{
                    color: this.state.mapType === "satellite" ? "blue" : "",
                  }}
                />
              }
              visibilityHeight={0}
            /> */}

            {/* <FloatButton
              description={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <Select
                    value={this.state.refreshTime}
                    style={{ width: 70 }}
                    onChange={this.setRefreshTime}
                    options={[
                      { value: "5", label: "05" },
                      { value: "30", label: "30" },
                      { value: "45", label: "45" },
                      { value: "60", label: "60" },
                    ]}
                  />

                  {this.state.timerPause ? (
                    <PauseCircle
                      size={20}
                      onClick={this.timerPauseFun}
                      style={{ cursor: "pointer" }}
                    />
                  ) : (
                    <PlayCircle
                      size={20}
                      onClick={this.timerPauseFun}
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </div>
              }
            /> */}
            <Popover
              content={
                <Button
                  onClick={async () => {
                    await this.SearchMenuItemClick("measureDistModal");

                    // await this.setState({ measureDistModal: true });
                  }}
                >
                  {/* Distance Measurement */}
                  {this.context.translate("_DISTANCE_MEASUREMENT_")}
                </Button>
              }
              placement={
                this.context.locale.language === "arabic" ? "right" : "left"
              }
            >
              <FloatButton.BackTop
                icon={
                  <Image
                    src={require("../assets/images/NewDesign/livetracking/tag-fill.png")}
                  />
                }
                visibilityHeight={0}
              />
            </Popover>

            <Popover
              trigger="click"
              placement={
                this.context.locale.language === "arabic" ? "right" : "left"
              }
              content={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    minWidth: 180,
                  }}
                >
                  <Select
                    defaultValue={"30"}
                    className="live-tracking-timer"
                    value={this.state.refreshTime}
                    style={{ width: 60 }}
                    onChange={this.setRefreshTime}
                    options={[
                      { value: "5", label: "05" },
                      { value: "30", label: "30" },
                      { value: "45", label: "45" },
                      { value: "60", label: "60" },
                    ]}
                  />

                  <b style={{ minWidth: "20px", fontWeight: "normal" }}>
                    {" "}
                    {this.state.timerCount}
                  </b>

                  <p
                    style={{
                      padding: "0px",
                      margin: "0px",
                      // marginLeft: "5px",
                    }}
                  >
                    {this.context.translate("_REFRESH_")}
                  </p>
                  {this.state.timerPause ? (
                    <PauseCircle
                      size={20}
                      style={{ cursor: "pointer" }}
                      onClick={this.timerPauseFun}
                    />
                  ) : (
                    <PlayCircle
                      size={20}
                      style={{ cursor: "pointer" }}
                      onClick={this.timerPauseFun}
                    />
                  )}
                </div>
              }
            >
              <FloatButton
                icon={<FaClock />}
              />
            </Popover>

            <FloatButton.BackTop
              onClick={() => this.toggleTraffic(this.mapRef)}
              // icon={<FaTrafficLight />}
              icon={
                <img
                  src={trafficIcon}
                  alt="Traffic"
                  style={{
                    width: "19px",
                    height: "20px",
                    objectFit: "contain",
                  }}
                />
              }
              visibilityHeight={0}
            />

            {this.state.chatView && (
              <Popover
                content={
                  <Button
                    onClick={async () => {
                      this.setState({ showChatSystem: true });
                      this.setIntervals();
                    }}
                  >
                    {/* chat option */}
                    {this.context.translate("_CHAT_")}
                  </Button>
                }
                placement={
                  this.context.locale.language === "arabic" ? "right" : "left"
                }
              >
                <FloatButton.BackTop
                  className={hasUnread ? "chat-blink" : ""}
                  icon={
                    <WechatFilled
                      style={{
                        color: hasUnread ? "#e43c31" : "#6b6969",
                        "font-size": "20px",
                      }}
                    />
                  }
                  visibilityHeight={0}
                />
              </Popover>
            )}
          </FloatButton.Group>
        )}

        <div
          dir={this.context.locale.language === "arabic" ? "ltr" : "ltr"}
          className={
            this.context.locale.language === "arabic"
              ? "arabic-map-container"
              : ""
          }
        >
          {/* <MapContainer
            key={this.state.closeCard ? "selected" : "default"}
            ref={this.mapRef}
            zoom={config.mapZoom}
            center={config.mapCenter}
            preferCanvas={true}
            // zoom={13}
            // minZoom={3}
            // center={[24.7136, 46.6753]}
            // className="mapcontainerStyle"
            style={{
              position: "sticky",
              height: "92vh",
              // width: "100wh",
              width:
                this.state.closeCard === false
                  ? "100wh"
                  : this.state.liveTrackingMainModal
                    ? "73%"
                    : "100wh",
              float: this.state.liveTrackingMainModal
                ? this.context.locale.language === "arabic"
                  ? "right" // push map to right if drawer is on left
                  : "left" // push map to left if drawer is on right
                : "none",
            }}
            // style={{ position: "sticky", height: "100vh", width: 900 }}
            zoomControl={false}
          >
            {!this.state.measureDistModal && (
              <ZoomControl position="bottomright"></ZoomControl>
            )}

            {this.state.navigationWindow
              ? false
              : this.state.measureDistModal && (
                //  {this.state.DraggablePopup  &&
                <MeasureDist
                  closeFun={async (resp) =>
                    await this.setState({
                      measureDistModal: resp,
                      mapType: "google",
                    })
                  }
                  mapRef={this.mapRef}
                />
              )}

            {this.state.navigationWindow && (
              <RouteShowingMap
                getDistance={
                  this.state.origin &&
                    this.state.destination &&
                    this.state.navigationWindow
                    ? this.getDistance
                    : undefined
                }
                origin={
                  // this.state.getDirection &&
                  // this.state.navigationWindow &&
                  this.state.origin
                }
                destination={
                  // this.state.getDirection &&
                  // this.state.navigationWindow &&
                  this.state.destination
                }
                showCalculatedDist={this.state.showCalculatedDist}
              />
            )}

            {this.state.navigationWindow
              ? false
              : this.state.mapType === "google" && (

                <ReactLeafletGoogleLayer
                  key={`${this.state.type}-${this.state.traffic}`}
                  // key={this.state.type ? this.state.type : ""}
                  type={this.state.type ? this.state.type : "roadmap"}
                  googleMapsAddLayers={
                    this.state.traffic ? [{ name: "TrafficLayer" }] : []
                  }
                />
              )}


            {this.state.navigationWindow
              ? false
              : this.state.mapType == "openstreet" && (
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution="Map data © OpenStreetMap contributors"
                />
              )}

            {selectedGeofence[0]?.points?.length > 0 &&
              selectedGeofence?.map((selectedGeofence) => {
                return (
                  <>
                    {selectedGeofence.points.length === 1 && (
                      <Circle
                        center={selectedGeofence?.points[0]}
                        radius={selectedGeofence?.radius}
                        pathOptions={{ color: "red" }}
                      >
                        <Popup>{selectedGeofence.name}</Popup>
                      </Circle>
                    )}
                    {selectedGeofence?.points?.length === 4 && (
                      <Polygon
                        positions={selectedGeofence.points}
                        pathOptions={{ color: "red" }}
                      >
                        <Popup>{selectedGeofence.name}</Popup>
                      </Polygon>
                    )}
                    {selectedGeofence?.points?.length > 2 && (
                      <Polygon
                        positions={selectedGeofence.points}
                        pathOptions={{ color: "red" }}
                      >
                        <Popup>{selectedGeofence.name}</Popup>
                      </Polygon>
                    )}
                  </>
                );
              })}

            <div
              className="handle"
              style={{ display: "flex", flexDirection: "row", left: "10%" }}
            // className=""
            >
              {this.state.editing && this.state.drawGeofence && (
                <FeatureGroup ref={this.drawnItemsRef}>
                  <EditControl
                    position={
                      this.context.locale.language === "arabic"
                        ? "topleft"
                        : "topright"
                    }
                    onEdited={this.onEdited}
                    onCreated={this.onCreated}
                    onDeleted={() =>
                      this.mapRef.current.eachLayer((layer) => {
                        if (layer instanceof L.Marker) {
                          this.mapRef.current.removeLayer(layer);
                        }
                        this.setState({
                          position: [],
                          selectGeofenceObjects: [],
                          geofenceData: [],
                        });
                      })
                    }
                    draw={{
                      circle: true,
                      circlemarker: false,
                      polyline: false,
                      marker: false,
                      rectangle: true,
                      polygon: true,
                    }}
                    style={{
                      direction:
                        this.context.locale.language === "arabic"
                          ? "ltr"
                          : "ltr",
                    }}
                  />
                </FeatureGroup>
              )}
            </div>

            {this.state.navigationWindow ? (
              ""
            ) : (
              <AdditionalContentInMap
                This={this}
                size="small"
                position="bottomright"
              />
            )}
 </MapContainer> */}
          <LiveTrackingMap
            liveTrackingMapRef={this.liveTrackingMapRef}
            focusedVehicleId={this.state.focusedVehicleId}
            mapType={this.state.mapType}
            vehicles={this.liveTrackingStore.selectedVehicles}
            onVehicleClick={(vehicle) =>
            // this.setState({ vehicleOtherInfo: vehicle })
            {
              // console.log("Clicked vehicle:", vehicle);

              this.setState(
                {
                  vehicleOtherInfo: null,
                },
                () => {

                  // this.setState({
                  //   vehicleOtherInfo: vehicle,
                  // });
                  this.setState(
                    {
                      selectedVehicleId: vehicle.vehicleId,
                      vehicleOtherInfo: vehicle, // immediate data
                    },
                    () => {
                      this.getVehicleOtherInfo(vehicle.vehicleId);
                    },
                  );
                },
              )
            }
            }
            polylineData={this.state.polylineData}
            trackingPolylineData={this.state.trackingPolylineData}
            onMapLoad={(map) => {
              this.mapRef = map; // MapLibre instance
              map.on('zoomend', () => {
                if (this.state.isLocked && !this.isProgrammaticMove) {
                  console.log(map.getZoom(), map.getCenter())
                  this.setState({ lockedZoom: map.getZoom(), lockedCenter: map.getCenter(), });
                }
              });
              map.on('moveend', () => {
                if (this.state.isLocked && !this.isProgrammaticMove) {
                  this.setState({
                    lockedCenter: map.getCenter(), // 👈 update center on pan too
                  });
                }
              });
            }}
            onloadMapForGeofence={(map) => {
              this.mapRef = map;
              map.on('zoomend', () => {
                if (this.state.isLocked) {
                  this.setState({ lockedZoom: map.getZoom() });
                }
              });
            }}
            showGeofenceIcons={this.state.drawGeofence}
            geofenceformRef={this.formRef}
            onGeofenceCreate={this.onGeofenceCreate}
            onGeofenceUpdate={this.onGeofenceUpdate}
            editingGeofence={this.pendingGeofence}
            editGeofence={this.state.editing}
            showSelectedGeofence={this.state.showSelectedGeofence}
            isDistanceMeasurementEnabled={this.state.measureDistModal}
            loadSearchVehicleIcon={this.loadSearchVehicleIcon}
            SearchAssetPopup={this.state.SearchAssetPopup}
            SearchDriverPopup={this.state.SearchDriverPopup}
            searchAssetData={this.liveRootPathStore.vehiclePosition}
            searchDriverData={this.driverStore.driverSearchData}
            ShowNearAssetPopup={this.state.ShowNearAssetPopup}
            showNearestVehiclesData={this.state.nearestAssetData}
            onMapClick={this.handleMapClick}
            histTrackingOverspeedPolyline={
              this.state.histTrackingOverspeedPolyline
            }
            overspeedMarkersData={this.state.overspeedMarkersData}
            histTrackingStraightPolyline={
              this.state.histTrackingStraightPolyline
            }
            straightLineMarkersData={this.state.straightLineMarkersData}
            idleStopMarkersData={this.state.idleStopMarkersData}
            fuelMarkersData={this.state.fuelMarkersData}
            liveTrackingMainModal={this.state.liveTrackingMainModal}
            closeCard={this.state.closeCard}
            isPlottingVehicles={this.state.isPlottingVehicles}
            showAllPoiData={this.state.showAllPoiData}
            showAllPoi={this.state.showAllPoi}
            showSearchPoiData={this.state.showSearchPoiData}
            searchPoi={this.state.searchPoi}
            onPoiClick={(poi) => {
              this.setState({ showNewPoiPopup: true, updateClickedPoi: poi }, () => {
                this.fillPoiData(poi);
              },)
            }}
            getAddressUsingLatLng={this.getAddressUsingLatLng}
            getDistance={this.getDistance}
            deletedMarkerkey={this.state.deleteMarkerkey}
          />
        </div>

        {this.state.closeCard && ( //this.state.liveTrackingMainModal &&
          <div>
            <div className="slider-container">
              <div className="liveTrackingTableBtn">
                <div>
                  <div className="status-panel">
                    {this.state.statusPanel && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <div
                          className="status-all"
                          onClick={() => this.getStatusWiseList("all")}
                        >
                          <Image
                            src={require("../assets/images/NewDesign/livetracking/image 23.png")}
                            // src={allCarIcon}
                            style={{
                              width: "17px",
                              height: "17px",
                              flexShrink: 0,
                            }}
                          />
                          <span className="status-all-count">
                            {" "}
                            {this.liveTrackingStore.totalvehstate.total
                              ? this.liveTrackingStore.totalvehstate.total
                              : 0}
                          </span>
                        </div>
                        <div
                          className="status-stop"
                          onClick={() => this.getStatusWiseList("stop")}
                        >
                          <Image
                            src={require("../assets/images/NewDesign/livetracking/image 24.png")}
                            // src={stopCarIcon}
                            style={{
                              width: "20px",
                              height: "20px",
                              flexShrink: 0,
                            }}
                          />
                          <span className="status-stop-count">
                            {" "}
                            {this.liveTrackingStore.totalvehstate.Stopped
                              ? this.liveTrackingStore.totalvehstate.Stopped
                              : 0}
                          </span>
                        </div>
                        <div
                          className="status-Idle"
                          onClick={() => this.getStatusWiseList("idle")}
                        >
                          <Image
                            src={require("../assets/images/NewDesign/livetracking/image 25.png")}
                            // src={idleCarIcon}
                            style={{
                              width: "20px",
                              height: "20px",
                              flexShrink: 0,
                            }}
                          />
                          <span className="status-Idle-count">
                            {" "}
                            {this.liveTrackingStore.totalvehstate.Idle
                              ? this.liveTrackingStore.totalvehstate.Idle
                              : 0}
                          </span>
                        </div>

                        <div
                          className="status-active"
                          onClick={() => this.getStatusWiseList("running")}
                        >
                          <Image
                            src={require("../assets/images/NewDesign/livetracking/image 26.png")}
                            // src={activeCarIcon}
                            style={{
                              width: "20px",
                              height: "20px",
                              flexShrink: 0,
                            }}
                          />
                          <span className="status-active-count">
                            {" "}
                            {this.liveTrackingStore.totalvehstate.Moving
                              ? this.liveTrackingStore.totalvehstate.Moving
                              : 0}
                          </span>
                        </div>

                        <div
                          className="status-expired"
                          onClick={() => this.getStatusWiseList("nodata")}
                        >
                          <Image
                            src={expiredIcon}
                            style={{
                              width: "20px",
                              height: "20px",
                              flexShrink: 0,
                            }}
                          />
                          <span className="status-expired-count">
                            {" "}
                            {this.liveTrackingStore.totalvehstate.NoData
                              ? this.liveTrackingStore.totalvehstate.NoData
                              : 0}
                          </span>
                        </div>
                      </div>
                    )}
                    <div
                      className="status-panel-btn"
                      onClick={() => {
                        this.setState({
                          statusPanel: !this.state.statusPanel,
                        });
                      }}
                    >
                      <Image
                        src={
                          this.state.statusPanel
                            ? this.context.locale.language === "arabic"
                              ? statusArrIcon1
                              : statusArrIcon
                            : this.context.locale.language === "arabic"
                              ? statusArrIcon
                              : statusArrIcon1
                        }
                        style={{ width: "8.918px", height: "22.29px" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Card
              maskClosable={false}
              mask={false}
              title={
                <div className="liveTrackingWindowTitle">
                  {this.context.translate("_FLEET_TRACKING_")}
                </div>
              }
              open={this.state.liveTrackingMainModal && this.state.closeCard}
              onOk={() =>
                this.setState({
                  liveTrackingMainModal: false,
                  closeCard: false,
                })
              }
              className="rightPanel-black trackingRightPanel cardBody"
              onCancel={() =>
                this.setState({
                  liveTrackingMainModal: false,
                  closeCard: false,
                })
              }
              footer={null}
            >
              <div className="liveTrackingInputRow">
                <CompanyAutocomplete
                  style={{ width: "250px" }}
                  className="liveTrackingAutocomplete"
                  value={
                    this.state.company_value ? this.state.company_value : null
                  }
                  onChange={async (value) => {
                    await this.setState({
                      currentPage2: 1,
                      addPreviousVehicles: false,
                    });
                    await this.handleChange(value);
                  }}
                />
                <Input
                  className="livetrackingVehDriverSearch"
                  onChange={this.popupSearch}
                  value={this.state.popupSearch ? this.state.popupSearch : ""}
                  placeholder={this.context.translate("_VEHICLE_OR_DRIVER_")}
                  onSearch={async (value) => {
                    const wordCount = value.trim().split(/\s+/).length;

                    if (wordCount >= 4) {
                      await this.handleSearch(value);
                    }
                  }}
                  enterButton
                  suffix={
                    <Image
                      src={searchIcon}
                      style={{
                        width: "13.5px",
                        height: "21.5px",
                        flexShrink: 0,
                      }}
                    >
                      {" "}
                    </Image>
                  }
                />
                {!this.state.showGroupsWindow && (
                  <Space>
                    <Checkbox
                      checked={this.state.selectAllChecked}
                      onChange={async (e) => {
                        this.handleCheckboxChange(e.target.checked);
                      }}
                    >
                      <span style={{ fontSize: "15px" }}>
                        {this.context.translate("_ALL_")}
                      </span>
                    </Checkbox>
                  </Space>
                )}
                {this.state.showGroupsWindow && (
                  <Image
                    style={{
                      width: "16px",
                      height: "16px",
                      cursor: "pointer",
                    }}
                    src={
                      this.state.showCollapseGroups ? dashCircle : plusCircle
                    }
                    onClick={async () => {
                      const allKeys =
                        this.state.vehicleGroups?.map((_, idx) => idx) || [];
                      const isExpanding = !this.state.showCollapseGroups;

                      if (isExpanding) {
                        this.setState({
                          showCollapseGroups: true,
                          activeCollapseKeys: allKeys,
                        });

                        for (
                          let i = 0;
                          i < this.state.vehicleGroups.length;
                          i++
                        ) {
                          const group = this.state.vehicleGroups[i];

                          const groupId = group.deviceGroupId;

                          if (!this.state.vehicleGroupData?.[groupId]) {
                            await this.handleSearch(groupId);
                          }
                        }
                      } else {
                        this.setState({
                          showCollapseGroups: false,
                          activeCollapseKeys: [],
                        });
                      }
                    }}
                  />
                )}
                {this.props.getUserData().isadmin !== -1 &&
                  this.props.getUserData().isadmin !== 3 && (
                    <Image
                      style={{
                        width: "30px",
                        height: "20px",
                        aspectRatio: "1/1",
                        borderRadius: "30px",
                        cursor: "pointer",
                      }}
                      src={borderIcon}
                      onClick={() => {
                        this.setState(
                          (prev) => ({
                            showGroupsWindow: !prev.showGroupsWindow,
                            popupSearch: ''
                          }),
                          () => {
                            if (
                              this.state.showGroupsWindow &&
                              (this.props.getUserData().isadmin === 1 || this.props.getUserData().isadmin === 0)
                            ) {
                              this.getAllVehicleGroups();
                              this.setState({
                                selectedCardsData: [],
                                selectAllChecked: false,
                                offset: 0,
                                limit: 50
                              });
                              this.liveTrackingStore.selectedVehicles = [];
                            } else {
                              // this.setState({
                              //   selectedCardsData: [],
                              // });
                              // this.liveTrackingStore.selectedVehicles = [];
                              this.handleSearch();
                              // if (this.state.selectAllChecked) {
                              this.plotDefaultVehiclesOnMap()
                              // }
                            }
                          },
                        );
                      }}
                    ></Image>
                  )}
              </div>
              <Spin
                spinning={this.state.loading || this.state.isPlottingVehicles}
              >
                <div
                  id="scrollableDiv"
                  style={{
                    height: "90%",
                    overflowY: "auto",
                  }}
                >
                  {!this.state.showGroupsWindow ? (
                    <InfiniteScroll
                      dataLength={
                        this.liveTrackingStore?.liveTrackingData?.length || 0
                      }
                      next={this.fetchMoreVehicles}
                      hasMore={this.state.hasMoreVehicles}
                      loader={
                        <div style={{ textAlign: "center", padding: "10px" }}>
                          <Skeleton active paragraph={{ rows: 1 }} />
                        </div>
                      }
                      scrollableTarget="scrollableDiv"
                      endMessage={
                        <p style={{ textAlign: "center", color: "#999" }}>
                          <b>No more vehicles</b>
                        </p>
                      }
                    >
                      {this.liveTrackingStore?.liveTrackingData?.map(
                        (val, index) => this.showVehicleInfoCard(val, index),
                      )}
                    </InfiniteScroll>
                  ) : (
                    <>
                      {this.state.vehicleGroups?.map((val, index) => {
                        const groupId = val.deviceGroupId;
                        return (
                          <Collapse
                            key={groupId}
                            className="tracking-collapse"
                            dataLength={
                              this.liveTrackingStore?.liveTrackingData
                                ?.totalCount || 0
                            }
                            activeKey={this.state.activeCollapseKeys}
                            onChange={async (keys) => {
                              this.setState({ activeCollapseKeys: keys });
                              this.setState({
                                selectedActiveVehicleGroup: groupId,
                              });
                              if (!this.state.vehicleGroupData[groupId]) {
                                await this.handleSearch(groupId);
                              }
                            }}
                            items={[
                              {
                                key: index,
                                label: val.groupname,
                                children: (
                                  this.state.vehicleGroupData[groupId] || []
                                ).map((vehicle, vehicleIndex) =>
                                  this.showVehicleInfoCard(
                                    vehicle,
                                    vehicleIndex,
                                  ),
                                ),
                                extra: this.genExtra(val, groupId),
                              },
                            ]}
                            expandIcon={({ isActive }) => (
                              <Image
                                src={
                                  isActive
                                    ? collapseArrowIcon
                                    : collapseRightArrowIcon
                                }
                              />
                            )}
                          />
                        );
                      })}
                    </>
                  )}
                </div>
              </Spin>
            </Card>
          </div>
        )}

        {/* {this.state.navigationWindow
          ? false
          : this.state.measureDistModal && (
            <MeasureDist
              closeFun={async (resp) =>
                await this.setState({
                  measureDistModal: resp,
                  mapType: "google",
                })
              }
              mapRef={this.mapRef}
            />
          )} */}

        {this.state.navigationWindow
          ? false
          : this.state.measureDistModal && (
            <MeasureDist
              closeFun={async (resp) => {
                this.liveTrackingMapRef.current?.clearMarkersAndRoutes();
                await this.setState({
                  markersAddress: [],
                  markerDistance: "0 km",
                  markerTime: "0 min",
                  measureDistModal: resp,
                  mapType: "default",
                });
              }}
              markersAddress={this.state.markersAddress}
              markerDistance={this.state.markerDistance}
              markerTime={this.state.markerTime}
              mapRef={this.mapRef}
              handleDeleteMarker={this.handleDeleteMarker}
              handleAddAfterRow={this.handleAddAfterRow}
            />
          )}


        {this.state.ShowNearAssetPopup && (
          <DraggableModal
            getGeoFenceObj={async (recordFormNearestAsset) => {
              await this.handleShowingGeofenceInMap({ recordFormNearestAsset });
              await this.setState({ update: 1 });
            }}
            setNearestAssetData={this.setNearestAssetData}
            clickedMarker={this.state.clickedMarker}
            mapRef={this.mapRef}
            groupRef={this.groupRef}
            handleCancel={(val) => this.handleCancel(val)}
          />
        )}

        {this.state.drawGeofence && (
          <div>
            <Card
              className="right-menu-panel-newGeofence"
              // headStyle={{
              //   margin: "0px !important",
              //   padding: "0px !important",
              // }}
              title={
                <div>
                  <p style={{ cursor: "move" }}>
                    {/* New Geofence */}
                    {this.context.translate(this.state.geofenceTitle)}
                  </p>
                  <div style={{ paddingBottom: "10px" }}>
                    <Autocomplete
                      className="autocomplete-location-textbox"
                      // options={
                      //   {
                      //     types: ['geocode', 'establishment', 'address', 'locality', 'route'],
                      //   }
                      // }
                      defaultValue={this.state.drawGeoLocation}
                      onChange={(e) => {
                        this.setState({ selectedLatLng: e.target.value, testState: e.target.value });
                      }}
                      componentRestrictions={{ country: "us" }}
                      options={{
                        types: ["geocode", "establishment"],
                      }}
                      style={{ fontSize: "14px", width: "90%", height: "45px" }}
                      apiKey={config.googleMapKey}
                      onPlaceSelected={async (e) => {
                        await this.setState({
                          drawGeoLocation: e.formatted_address,
                        });
                        await this.getInformationOfVehicle({
                          latLong: {
                            latitude: e.geometry?.location?.lat(),
                            longitude: e.geometry?.location?.lng(),
                          },

                        });


                        // await this.setState({update:1})
                      }}
                    // onPlaceSelected={(e) => {
                    //   console.log(e);
                    // }}
                    />


                    <SearchOutlined
                      onClick={this.handleLocationSearch}
                      style={{ marginInlineStart: "10px", cursor: "pointer", fontSize: 20 }}
                    />

                  </div>
                </div>
              }

            // style={{ width: 400, padding: "20px" }}
            >
              <Form
                onFinish={this.onFinishDrawing}
                onFinishFailed={(a) => {
                  a.errorFields.forEach((val) => {
                    val.name.forEach((val2) => {
                      if (val2 === "address") {
                        Modal.warning({
                          // title: "Alert",
                          title: this.context.translate("_FLEET_ALERT_"),
                          // content: "We need to Draw Geofence for Address",
                          content: this.context.translate(
                            "_SELECT_SHAPE_DRAW_FENCE_",
                          ),
                        });
                      }
                    });
                  });
                }}
                layout="vertical"
                ref={this.formRef}
              >
                <div
                  style={{
                    overflow: "auto",
                    maxHeight: "395px",
                    paddingInlineEnd: "12px",
                    borderTop: "1px solid",
                    marginTop: "5px solid",
                  }}
                >
                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                      <Form.Item
                        name="companyId"
                        label={this.context.translate(
                          "_FLEET_DASHBORD_NEWPOI_CUSTOMER_",
                        )}
                        rules={[{ required: true }]}
                      >
                        <CompanyAutocomplete
                          // value={this.state.companyId}
                          onChange={async (value) => {
                            await this.handleChangeForDrawingGeofence(value);
                            await this.setState({ companyId: value.value });
                          }}
                        />
                      </Form.Item>
                    )}
                  {/* <Form.Item
                          label=" "
                          name="vehicleLoc"
                          className="checkbox-block"
                        > */}
                  <br />
                  <Checkbox
                    className="checkbox-block"
                    checked={this.state.currentVehicleLoc}
                    onChange={(e) =>
                      this.setState({
                        currentVehicleLoc: e.target.checked,
                      })
                    }
                  >
                    {/* Current Vehicle Location */}
                    {this.context.translate("_CURRENT_VEHICLE_LOCATION_")}
                  </Checkbox>
                  {/* </Form.Item> */}

                  <div
                    style={{
                      display: this.state.currentVehicleLoc ? "" : "none",
                    }}
                  >
                    <Form.Item
                      // label="Vehicle No"
                      label={this.context.translate("_VEHICLE_NO_")}
                      name="vehicleId"
                      style={formItemStyle}
                    >
                      <Select
                        onSelect={(val, record) => {
                          this.setState({ vehicleId: val });
                          this.getInformationOfVehicle({ vehicleId: val });
                        }}
                        showSearch
                        filterOption={(inputValue, option) => {
                          if (option.children) {
                            return (
                              option.children
                                .toLowerCase()
                                .indexOf(inputValue.toLowerCase()) >= 0
                            );
                          }
                        }}
                      >
                        {this.liveTrackingStore?.vehiclePositionArray?.map(
                          (val) => {
                            return (
                              <Option vehicleObj={val} value={val.vehicleId}>
                                {val.vehicleNo}
                              </Option>
                            );
                          },
                        )}
                      </Select>
                    </Form.Item>
                  </div>
                  <Form.Item
                    // label="Address"
                    label={this.context.translate(
                      "_FLEET_DASHBORD_NEWPOI_ADDRESS_",
                    )}
                    name="address"
                    style={formItemStyle}
                    rules={[{ required: true }]}
                  >
                    <Input disabled />
                  </Form.Item>
                  <Form.Item
                    // label="Name"
                    label={this.context.translate(
                      "_FLEET_DASHBORD_NEWPOI_NAME_",
                    )}
                    name="geosettingname"
                    style={formItemStyle}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>

                  {/* <Form.Item label=" " name="input5" className="checkbox-block"> */}
                  <br />
                  <Checkbox
                    className="checkbox-block"
                    checked={this.state.selectFormHistory}
                    onChange={(e) =>
                      this.setState({
                        selectFormHistory: e.target.checked,
                      })
                    }
                  >
                    {/* Select Form History */}
                    {this.context.translate("_SELECT_FROM_HISTORY_")}
                  </Checkbox>
                  {/* </Form.Item> */}

                  {this.state.selectFormHistory && (
                    <>
                      <Form.Item
                        // label="Vehicle No"
                        label={this.context.translate("_VEHICLE_NO_")}
                        name="vehicleId2"
                        style={formItemStyle}
                        rules={[{ required: true }]}
                      >
                        <Select
                          onSelect={(val) => {
                            this.setState({ vehicleId: val });
                            this.getInformationOfVehicle({ vehicleId: val });
                          }}
                          showSearch
                          filterOption={(inputValue, option) => {
                            if (option.children) {
                              return (
                                option.children
                                  .toLowerCase()
                                  .indexOf(inputValue.toLowerCase()) >= 0
                              );
                            }
                          }}
                        >
                          {this.liveTrackingStore?.vehiclesArray?.map((val) => {
                            return (
                              <Option value={val.vehicleId}>
                                {val.vehicleNo}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>

                      <Row>
                        <Col span={11}>
                          <Form.Item
                            // label="From Date"
                            label={this.context.translate("_FROM_DATE_")}
                            name="fromDate"
                            style={formItemStyle}
                          >
                            <DatePicker
                              format={"MM-DD-YYYY"}
                              defaultValue={this.state.fromDate}
                              onChange={(val) =>
                                this.setState({
                                  fromDate: val?.format("YYYY-MM-DD"),
                                  toDate: val?.format("YYYY-MM-DD"),
                                })
                              }
                              disabledDate={(current) => {
                                return current && current > dayjs();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={2}></Col>
                        <Col span={11}>
                          <Form.Item
                            // label="To Date"
                            label={this.context.translate("_TO_DATE_")}
                            name="toDate"
                            style={formItemStyle}
                          >
                            <DatePicker
                              format={"MM-DD-YYYY"}
                              defaultValue={this.state.toDate}
                              disabledDate={(current) => {
                                return (
                                  current &&
                                  current < dayjs(this.state.fromDate)
                                ); // Updated condition
                              }}
                              onChange={(val) =>
                                this.setState({
                                  toDate: val?.format("YYYY-MM-DD"),
                                })
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row>
                        <Col span={11}>
                          <Form.Item
                            // label="From Time"
                            label={this.context.translate("_FROM_TIME_")}
                            name="fromTime"
                            style={formItemStyle}
                            initialValue={"00:00:00"}
                          >
                            <Select
                              onChange={this.setFromTime}
                              onSelect={(val) =>
                                this.setState({ fromTime: val })
                              }
                              // value={this.state.fromTime}

                              allowClear={true}
                            >
                              {this.timeOptions()}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={2}></Col>
                        <Col span={11}>
                          <Form.Item
                            // label="To Time"
                            label={this.context.translate("_TO_TIME_")}
                            name="toTime"
                            style={formItemStyle}
                            initialValue={dayjs().format("hh:mm A")}
                          >
                            <Select
                              onSelect={(val) => this.setState({ toTime: val })}
                              allowClear={true}
                            >
                              {this.timeOptions()}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Form.Item label=" ">
                        <Button
                          type="primary"
                          onClick={this.LoadClick}
                          style={{ width: "100%" }}
                        >
                          {/* Load */}
                          {this.context.translate("_LOAD_")}
                        </Button>
                      </Form.Item>
                      <Form.Item
                        // label="Stop/Idle Points"
                        label={this.context.translate("_STOP_IDLE_POINTS_")}
                        name="stopIdlePoints"
                      // style={formItemStyle}
                      >
                        <Select
                          onChange={(val, b) => {
                            if (b.latLong?.length > 0) {
                              this.getInformationOfVehicle({
                                latLong: {
                                  latitude: b?.latLong[0],
                                  longitude: b?.latLong[1],
                                },
                              });
                            }
                          }}
                        >
                          {this.liveTrackingStore.stopIdleArray?.map((val) => {
                            return (
                              <Select.Option
                                key={val.vehicleNo}
                                value={val.stopIdleLocation}
                                latLong={[val?.latitude, val?.longitude]}
                              // title={val.stopIdleLocation}
                              >
                                {val.stopIdleLocation}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </>
                  )}

                  <Form.Item
                    // label="Type"
                    label={this.context.translate(
                      "_FLEET_DASHBORD_NEWPOI_TYPE_",
                    )}
                    name="typeName"
                    style={formItemStyle}
                  >
                    <Select>
                      <Select.Option value={1}>
                        {this.context.translate("_RETAILS_")}
                      </Select.Option>
                      <Select.Option value={2}>
                        {this.context.translate("_FOOD_SERVICE_")}
                      </Select.Option>
                      <Select.Option value={3}>
                        {this.context.translate(
                          "_FLEET_DASHBORD_NEWPOI_TYPEDDL_WAREHOUSE_",
                        )}
                      </Select.Option>
                      <Select.Option value={4}>
                        {this.context.translate("_FLEET_CUSTOMER_")}
                      </Select.Option>
                      <Select.Option value={5}>
                        {this.context.translate("_HEAD_OFFICE_")}
                      </Select.Option>
                      <Select.Option value={6}>
                        {this.context.translate("_GARAGE_")}
                      </Select.Option>
                      <Select.Option value={7}>
                        {this.context.translate("_OUTLET_")}
                      </Select.Option>
                      <Select.Option value={8}>
                        {this.context.translate("_BRANCH_")}
                      </Select.Option>
                      <Select.Option value={9}>
                        {this.context.translate("Store Start Point")}
                      </Select.Option>
                      <Select.Option value={10}>
                        {this.context.translate("Common Area")}
                      </Select.Option>
                      <Select.Option value={11}>
                        {this.context.translate("Taxi Zones")}
                      </Select.Option>
                      <Select.Option value={12}>
                        {this.context.translate("_STUDENT_PICK_UP_")}
                      </Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    // label="Speed"
                    label={this.context.translate(
                      "_FLEET_DASHBORD_SETTING_SPEED_",
                    )}
                    name="speed"
                    style={formItemStyle}
                  >
                    <Input />
                  </Form.Item>

                  <AddGeofenceFields />
                </div>

                <div className="formBtnGroup">
                  <Button
                    onClick={async () => {
                      this.liveTrackingMapRef?.current?.clearGeofencesFromMap();

                      await this.clearFields();
                      if (this.locationMarker) {
                        this.locationMarker.remove();
                        this.locationMarker = null;
                      }
                    }}
                    style={{ fontSize: "11px" }}
                    className="formCancelButton"
                    type="primary"
                  >
                    Discard &<br /> Create New
                  </Button>

                  <Button
                    className="formCancelButton"
                    onClick={() => {
                      this.setState({ drawGeofence: false, editing: false, selectedLatLng: null })
                      this.pendingGeofence = null;
                      if (this.locationMarker) {
                        this.locationMarker.remove();
                        this.locationMarker = null
                      }
                    }}
                  >
                    {this.context.translate("_FLEET_CLOSE_BTN_")}
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="formSaveButton"
                    loading={this.state.exce}
                  >
                    {this.context.translate("_SUBMIT_")}
                  </Button>
                </div>
              </Form>
            </Card>
          </div>
        )
        }

        {
          this.state.showGofence && (
            <div>
              <Draggable>
                <Card
                  className="right-menu-panel showgeofence headerGroup-panel"
                  title={
                    <div
                      className="handle"
                      style={{ display: "flex", alignItems: "center", cursor: "move" }}
                    >
                      <span style={{ fontSize: "18px", fontWeight: 500 }}>
                        {this.context.translate("_FLEET_DASHBORD_SHOWGEO_TITLE_")}
                      </span>

                      <div style={{ display: "flex", alignItems: "center", cursor: 'pointer', marginLeft: "auto", gap: "8px", }}>
                        <Button
                          size="small"
                          type="text"
                          style={{

                            height: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onClick={this.handleMinimize}
                        >
                          <img
                            src={minimized ? upArrow : downArrow}
                            alt="toggle"
                            style={{ width: 15, height: 15 }}
                          />
                        </Button>
                        <CloseOutlined
                          style={{ fontSize: "18px" }}
                          onClick={() => {
                            this.removePlottedGeofences();
                            this.setState({
                              showGofence: false,
                              selectGeofenceObjects: [],
                              geofenceData: [],
                              selectGeofenceInList: [],
                              selectGeofenceRows: [],
                              company_value: null,
                              // company_value:''
                            });

                            // this.liveTrackingStore.geofenceListArray = [];
                          }}
                        />
                      </div>

                    </div>
                  }
                  bodyStyle={{ display: minimized ? "none" : "block" }}
                  style={{ width: 400, padding: "20px" }}
                >
                  <Row>
                    <Space style={{ marginBottom: "10px" }}>
                      <CompanyAutocomplete
                        style={{ width: "150px" }}
                        // width={250}
                        // onClear={true}
                        value={
                          this.state.company_value
                            ? this.state.company_value
                            : null
                          // &&
                          // this.liveTrackingStore.geofenceListArray.length > 0
                          //   ? this.state.company_value
                          //   : null
                        }
                        onChange={async (value) => {
                          await this.setState({ companyId: value.value });
                          await this.handleGetGofenceList(value);
                        }}
                      />

                      <Input
                        placeholder={this.context.translate("_SEARCH_GEOFENCE_")}
                        className="search-geofence-input"
                        style={{ width: "185px" }}
                        onChange={(e) => {
                          this.setState({ searchGeoFence: e.target.value });
                          this.searchInput(e);
                        }}
                        suffix={
                          <Image
                            src={searchIcon}
                            style={{
                              width: "15.5px",
                              height: "21.5px",
                              flexShrink: 0,
                            }}
                          >
                            {" "}
                          </Image>
                        }
                      />
                    </Space>
                  </Row>

                  <Table
                    bordered
                    scroll={{ x: 300, y: 280 }}
                    rowSelection={{
                      selectedRowKeys: this.state.selectGeofenceInList,
                      selectedRows: this.state.selectGeofenceRows,
                      onChange: async (selectedRowKeys, selectedRows) => {
                        await this.setState({
                          selectGeofenceInList: selectedRowKeys,

                          selectGeofenceRows: selectedRows,
                          showSelectedGeofence: selectedRows,
                        });

                        if (selectedRows) {
                          this.showGeofencesOnMap(selectedRows);

                          // this.showGeofencesOnMap(selectedRows);
                          // await this.setPointsInArrayFormat(
                          //   this.state.selectGeofenceRows
                          // );
                        }
                      },
                    }}
                    pagination={{
                      currentPage: this.state.currentPage,
                      pageSize: this.state.pageSize,
                      total: this.liveTrackingStore.total,
                    }}
                    loading={this.liveTrackingStore?.loading}
                    rowKey="zoneId"
                    columns={this.showGeofenceListColumn}
                    dataSource={this.liveTrackingStore.geofenceListArray}
                    onChange={this.handleTableChange}
                  />

                  <div className="list-bottom-btns">
                    <AddVersionModal
                      handleAddVersionModal={this.handleAddVersionModal}
                      companyId={this.state.companyId}
                    />
                    <AntTooltip
                      title={this.context.translate(
                        "_FLEET_DASHBORD_SHOWGEO_DELETE_",
                      )}
                      placement="bottom"
                      color={config.tooltipColorDelete}
                    >
                      <Button
                        disabled={
                          this.state.selectGeofenceInList?.length > 1
                            ? false
                            : true
                        }
                        // type="primary"
                        icon={
                          <DeleteOutlined
                            style={{ color: "white", fontSize: "18px" }}
                          />
                        }
                        onClick={async () => {
                          this.deleteMultipleGeofence(
                            this.state.selectGeofenceInList,
                          );
                        }}
                      />
                    </AntTooltip>
                    <AntTooltip
                      title={this.context.translate("_UPLOAD_FROM_EXCEL_")}
                      color="blue"
                      placement="bottom"
                    >
                      <Button
                        type="primary"
                        onClick={async () =>
                          await this.setState({
                            showImportExcelModal: true,
                            showGofence: false,
                          })
                        }
                        icon={<i class="bi bi-cloud-upload"></i>}
                      ></Button>
                    </AntTooltip>
                    <AntTooltip
                      title={this.context.translate("_ADD_GEOFENCE_")}
                      color="blue"
                      placement="bottom"
                    >
                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={async () => {
                          await this.setState({ drawGeoLocation: "" });
                          await this.SearchMenuItemClick("drawGeofence");

                          await this.geofenceCardTitle(
                            this.context.translate("_NEW_GEOFENCE_"),
                          );
                        }}
                      ></Button>
                    </AntTooltip>
                  </div>
                </Card>
              </Draggable>
            </div>
          )
        }

        {
          this.state.navigationWindow && (
            <Draggable handle=".handle">
              <Card
                className="right-menu-panel headerGroup-panel"
                title={
                  <div
                    className="handle"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {/* <div> Navigation Window</div> */}
                    <div>{this.context.translate("_NAVIGATION_WINDOW_")}</div>
                    <CloseOutlined
                      onClick={() => {
                        this.removeRouteAndMarkers();
                        this.setState({
                          navigationWindow: false,
                          origin: null,
                          destination: null,
                          distance: "",
                          mapType: "default",
                          showCalculatedDist: false,
                        })
                      }
                      }
                    />
                  </div>
                }
              >
                <div className="lbl-field">
                  <span>
                    {" "}
                    {this.context.translate(
                      "_FLEET_DASHBORD_VEHICLE_HISTORY_FROM_",
                    )}{" "}
                  </span>
                  <Autocomplete
                    defaultValue={this.state.startLocation}
                    placeholder={this.context.translate("_ENTER_LOCATION_")}
                    ref={this.originInputRef}
                    className="autocomplete-location-textbox"
                    apiKey={config.googleMapKey}
                    onPlaceSelected={(e) => {
                      // console.log(e.geometry.location.lat());
                      this.setState({
                        origin: {
                          lat: e.geometry.location.lat(),
                          lng: e.geometry.location.lng(),
                        },
                      });
                    }}
                  // onPlaceSelected={(e) => {
                  //   console.log(e);
                  // }}
                  />
                </div>
                <div className="lbl-field">
                  {/* <span> To </span> */}
                  <span>
                    {" "}
                    {this.context.translate(
                      "_FLEET_DASHBORD_VEHICLE_HISTORY_TO_",
                    )}{" "}
                  </span>
                  <Autocomplete
                    defaultValue={this.state.endLocation}
                    placeholder={this.context.translate("_ENTER_LOCATION_")}
                    ref={this.destinationInputRef}
                    className="autocomplete-location-textbox"
                    apiKey={config.googleMapKey}
                    onPlaceSelected={(e) => {
                      // this.setState({ destination: e.formatted_address });
                      this.setState({
                        destination: {
                          lat: e.geometry.location.lat(),
                          lng: e.geometry.location.lng(),
                        },
                      });

                      // console.log(e.formatted_address);
                    }}
                  // onPlaceSelected={(e) => {
                  //   console.log(e);
                  // }}
                  />
                </div>
                {this.state.showCalculatedDist && (
                  <div className="distance-total-block">
                    <p>
                      {/* <b>Distance between them : </b> {this.state.distance} */}
                      <b>{this.context.translate("_DISTANCE_BETWEEN_THEM_")}: </b>{" "}
                      {this.state.distance ? `${this.state.distance} km` : ""}
                    </p>
                  </div>
                )}
                <div className="formBtnGroup">
                  <Button
                    className="formCancelButton"
                    onClick={() => {
                      this.handleClearFields();
                      this.removeRouteAndMarkers();
                      this.setState({
                        getDirection: false,
                        destination: "",
                        origin: "",
                        startLocation: undefined,
                        endLocation: undefined,
                        showCalculatedDist: false,
                      });
                    }}
                  >
                    {/* Clear */}
                    {this.context.translate("_FLEET_CLEAR_BTN_")}
                  </Button>
                  <Button
                    style={{ fontSize: "13px", padding: "0px" }}
                    type="primary"
                    className="formSaveButton"
                    onClick={() => {
                      this.drawRoute(this.state.origin, this.state.destination);
                      this.setState({
                        getDirection: true,
                        showCalculatedDist: true,
                      })
                    }
                    }
                  >
                    {/* Get Direction */}
                    {this.context.translate("_GET_DIRECTION_")}
                  </Button>
                </div>
              </Card>
            </Draggable>
          )
        }
        {
          (this.state.SearchAssetPopup || this.state.SearchDriverPopup) && (
            <Draggable handle=".handle">
              <Card
                className="right-menu-panel headerGroup-panel"
                title={
                  <div
                    className="handle"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      {" "}
                      {this.state.SearchAssetPopup
                        ? // "Search Asset"
                        // this.context.translate(
                        //   "_FLEET_DASHBORD_SEARCHVEHICLE_TITLE_"
                        // )
                        this.context.translate("_SEARCH_ASSET_")
                        : // "Search Driver"
                        this.context.translate("_SEARCH_DRIVER_")}
                    </div>
                    <CloseOutlined
                      onClick={() => this.handleCancel("SearchAssetPopup")}
                    />
                  </div>
                }
              >
                <Form
                  layout="vertical"
                  name="control-hooks"
                  ref={this.searchAssetformRef}
                >
                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                      <Form.Item
                        name="SelectAccount"
                        label={
                          <span>
                            {this.context.translate(
                              "_FLEET_DASHBORD_NEWPOI_CUSTOMER_",
                            )}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        required={false}
                        style={{ marginBottom: "20px" }}
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <CompanyAutocomplete
                          onChange={async (value) => {
                            await this.handleCompId(value);
                            this.searchAssetformRef.current.setFieldsValue({
                              SelectVehicle: undefined,
                              SelectDriver: undefined,
                            });
                          }}
                        />
                      </Form.Item>
                    )}

                  {this.state.SearchAssetPopup ? (
                    <Form.Item
                      name="SelectVehicle"
                      // label={this.context.translate(
                      //   "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_1"
                      // )}
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_1",
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select
                        placeholder={this.context.translate("_SELECT_VEHICLE_1")}
                        onSelect={this.handleVehicleChange}
                        disabled={this.state.vehicleDisable}
                        showSearch
                        filterOption={(inputValue, option) => {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }}
                      >
                        {this.state.vehicleList?.map((vehicle) => {
                          return (
                            <Option
                              key={vehicle.vehicleId}
                              value={parseInt(vehicle.vehicleId)}
                            >
                              {vehicle.vehicleNo}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  ) : (
                    <Form.Item
                      name="SelectDriver"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_",
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      // label={this.context.translate(
                      //   "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
                      // )}
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder={this.context.translate("_SELECT_DRIVER_")}
                        onSelect={this.handleDriverChange}
                        filterOption={(inputValue, option) => {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }}
                      >
                        {this.state.DriverList?.map((d) => {
                          return (
                            <Option key={d.driverId} value={d.driverId}>
                              {d.driverName}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  )}

                  <div className="formBtnGroup">
                    <Button
                      className="formCancelButton"
                      onClick={() => {
                        this.handleCancel("SearchAssetPopup");
                        this.setState({
                          selectedVehicles: "",
                          selectedDriver: "",
                        });
                        // this.searchAssetformRef.current.setFieldsValue({SelectVehicle:undefined,SelectDriver:undefined,SelectAccount:undefined})
                      }}
                    >
                      {this.context.translate("_FLEET_CLOSE_BTN_")}
                    </Button>
                    <Button
                      className="formSaveButton"
                      type="primary"
                      disabled={
                        this.state.selectedVehicles || this.state.selectedDriver
                          ? false
                          : true
                      }
                      htmlType="submit"
                      onClick={() => this.SearchAssetFunc()}
                    >
                      {this.context.translate("_SEARCH_")}
                    </Button>
                  </div>
                </Form>
              </Card>
            </Draggable>
          )
        }

        {
          this.state.searchAddressWindowShow && (
            <Draggable handle=".handle">
              <Card
                className="right-menu-panel headerGroup-panel"
                title={
                  <div
                    className="handle"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {/* <div> Search Address</div> */}
                    <div>{this.context.translate("_SEARCH_ADDRESS_")}</div>
                    <CloseOutlined
                      onClick={() => {
                        this.clearLocationMarker();
                        this.handleCancel("searchAddressWindowShow");
                      }}
                    />
                  </div>
                }
              >
                <Autocomplete
                  className="autocomplete-location-textbox"
                  componentRestrictions={{ country: "us" }}
                  options={{
                    types: ["geocode", "establishment"],
                  }}
                  apiKey={config.googleMapKey}
                  onPlaceSelected={(e) => {
                    // this.setState({latitude: e.geometry.location.lat(),longitude:e.geometry.location.lng()})
                    this.getInformationOfVehicle({
                      latLong: {
                        latitude: e.geometry.location.lat(),
                        longitude: e.geometry.location.lng(),
                      },
                    });
                  }}
                />
              </Card>
            </Draggable>
          )
        }

        {
          this.state.showImportExcelModal && (
            <Card
              className="right-menu-panel headerGroup-panel"
              title={
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  {/* <div>Import From Excel</div>{" "} */}
                  <div>
                    {this.context.translate("_IMPORT_EXPORT_EXCEL_")}
                  </div>{" "}
                  <CloseOutlined
                    onClick={() => this.setState({ showImportExcelModal: false })}
                  />
                </div>
              }
            >
              <Form
                ref={this.formRef}
                name="excelimport"
                layout="vertical"
                onFinish={this.onImportExcelSubmit}
                style={{ maxWidth: "100%" }}
              >
                {this.props.getUserData().isadmin === -1 && (
                  <>
                    <Form.Item
                      name="companyId"
                      className="form-fields"
                      label={
                        <span>
                          {this.context.translate("_ACCOUNT_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      // label={this.context.translate("_ACCOUNT_")}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_ACCOUNT_",
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <CompanyAutocomplete
                        // className="uploadCompany"
                        onChange={(companyId) => {
                          this.setState({ excelCompanyId: companyId.value });
                        }}
                      />
                    </Form.Item>

                    <br />
                  </>
                )}
                {this.props.getUserData().isadmin === 1 && <br />}
                <Form.Item
                  className="form-fields"
                  name="excelFile"
                  // label="Excel File"
                  rules={[
                    {
                      required: true,
                      message: this.context.translate("_ENTER_EXCEL_"),
                    },
                  ]}
                >
                  <Upload
                    name="excelFile"
                    action={config.NodeUrl + "/liveTracking/uploadExcel"}
                    listType="text"
                    data={{ fileType: "accountimport", fieldName: "excelFile" }}
                    onChange={this.getUploadData}
                    maxCount={1}
                  // accept=".excel"
                  >
                    <Button icon={<UploadOutlined />}>
                      {this.context.translate("_CLICKTOUPLOAD_EXCELFILE_")}
                    </Button>
                  </Upload>
                </Form.Item>

                <div className="formBtnGroup">
                  <Button
                    className="formCancelButton"
                    key="Sample"
                    // style={{ backgroundColor: config.activeColor }}
                    onClick={() => {
                      this.liveTrackingStore.sampleExcel();
                      // this.setState({ showImportExcelModal: false });
                    }}
                  >
                    {/* Sample */}
                    {this.context.translate("_SAMPLE_")}
                  </Button>

                  <Button
                    className="formSaveButton"
                    type="primary"
                    htmlType="submit"
                    loading={this.liveTrackingStore.excelLoading}
                  // onClick={() => {this.setState({ showImportExcelModal: false })}}
                  >
                    {/* Upload */}
                    {this.context.translate("_UPLOAD_")}
                  </Button>

                  <Button
                    className="formCancelButton"
                    type="primary"
                    onClick={() => {
                      this.setState({ showImportExcelModal: false });
                    }}
                  >
                    {/* Cancel */}
                    {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                  </Button>
                </div>
              </Form>
            </Card>
          )
        }
        {
          this.state.sendCommandPopUp && (
            <SendCommandPopup
              vehicleInfoObj={this.state.vehicleOtherInfo}
              sendCommandPopUpBoolean={this.state.sendCommandPopUp}
              sendCommandPopUpFunc={(resp) =>
                this.setState({ sendCommandPopUp: resp })
              }
            />
          )
        }

        {
          this.state.historyTrackingWindow && (
            <HistoryTracking
              vehicleInfoObj={this.state.vehicleOtherInfo}
              trackingMapBoolean={this.state.trackingMapBoolean}
              closeTrackingMapWindow={(resp) =>
                this.setState({ historyTrackingWindow: resp })
              }
              mapRef={this.mapRef}
              isHistoryTracking={true}
              histTrackingOverspeedPolyline={(geoJson) =>
                this.setState({ histTrackingOverspeedPolyline: geoJson })
              }
              histTrackingStraightPolyline={(geoJson) =>
                this.setState({ histTrackingStraightPolyline: geoJson })
              }
              overspeedMarkersData={(geoJson) =>
                this.setState({ overspeedMarkersData: geoJson })
              }
              straightLineMarkersData={(geoJson) =>
                this.setState({ straightLineMarkersData: geoJson })
              }
            />
          )
        }

        {this.state.historyTrackingWindow && (
          <HistoryTracking
            vehicleInfoObj={this.state.vehicleOtherInfo}
            trackingMapBoolean={this.state.trackingMapBoolean}
            closeTrackingMapWindow={(resp) =>
              this.setState({ historyTrackingWindow: resp })
            }
            mapRef={this.mapRef}
            fromLivetracking={true}
            histTrackingOverspeedPolyline={(geoJson) =>
              this.setState({ histTrackingOverspeedPolyline: geoJson })
            }
            histTrackingStraightPolyline={(geoJson) =>
              this.setState({ histTrackingStraightPolyline: geoJson })
            }
            overspeedMarkersData={(geoJson) =>
              this.setState({ overspeedMarkersData: geoJson })
            }
            straightLineMarkersData={(geoJson) =>
              this.setState({ straightLineMarkersData: geoJson })
            }
          />
        )}
        {
          this.state.keepAnEyeModal && (
            <MapForVehiclePosition
              showLiveTrackingMap={true}
              showTooltip={this.state.keepAnEyeModal}
              vehicleObj={this.state.vehicleOtherInfo}
              heading={this.state.vehicleOtherInfo?.vehicleNo}
              closeMapModal={(resp) => {
                this.setState({ keepAnEyeModal: resp });
              }}
            />
          )
        }

        {
          this.state.markerClusterGroupPopup && (
            <MarkerClusterPopup infoObj={this.state.markerClusterGroupPopup} />
          )
        }

        {
          this.state.showNewPoiPopup && (
            <div>
              <Card
                className="right-menu-panel-newGeofence"
                title={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div style={{ fontSize: "18px" }}>
                      {this.context.translate("_FLEET_DASHBORD_NEWPOI_TITLE_")}
                    </div>

                    <CloseOutlined style={{ fontSize: "18px", cursor: "pointer" }}
                      onClick={() => {
                        this.setState({ showNewPoiPopup: false })
                        if (this.vehicleMarker) {
                          this.vehicleMarker.remove()
                        }
                      }} />
                  </div>
                }
              >
                <Form
                  onFinish={this.createNewPoi}
                  layout="vertical"
                  ref={this.formRef}
                >
                  <div
                    style={{
                      overflow: "auto",
                      maxHeight: "395px",
                      paddingInlineEnd: "12px",
                      // borderTop: "1px solid",
                      marginTop: "5px solid",
                    }}
                  >
                    {(this.props.getUserData().isadmin === -1 ||
                      this.props.getUserData().isadmin === 3) && (
                        <Form.Item
                          name="companyId"
                          label={
                            <span>
                              {this.context.translate(
                                "_FLEET_DASHBORD_NEWPOI_COMPANY_",
                              )}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: true,
                              message: `${this.context.translate(
                                "_FLEET_COMPANY_COMPANYLIST_COMPANYNAME_",
                              )} ${this.context.translate("_IS_REQUIRED_")}`,
                            },
                          ]}
                        >
                          <CompanyAutocomplete
                            onChange={async (value) => {
                              await this.handleChangeForCreatePoi(value)
                              this.setState({ createPoiCompanyId: value.value })
                            }}
                          />
                        </Form.Item>
                      )}

                    <br />
                    <Checkbox
                      className="checkbox-block"
                      checked={this.state.poicurrentVehicleLoc}
                      onChange={(e) =>
                        this.setState({
                          poicurrentVehicleLoc: e.target.checked,
                        })

                      }
                    >
                      {this.context.translate("_CURRENT_VEHICLE_LOCATION_")}
                    </Checkbox>

                    {this.state.poicurrentVehicleLoc &&
                      <Form.Item
                        label={this.context.translate("_VEHICLE_NO_")}
                        name="vehicleId"
                        style={formItemStyle}
                      >
                        <Select
                          // onChange={(value, option) => {
                          //   this.setState({ selectedPoiVehicleData: option.vehicleObj }, () => {
                          //     this.plotSelectedVehicle();
                          //   });
                          // }}
                          onChange={(value, option) => {
                            const vehicle = option.vehicleObj;

                            this.setState(
                              {
                                selectedPoiVehicleData: vehicle,
                                drawGeoLocationLatLng: {
                                  latitude: vehicle.latitude,   // make sure keys match your object
                                  longitude: vehicle.longitude,
                                },
                              },
                              () => {
                                // Optionally plot vehicle on map
                                this.plotSelectedVehicle();

                                // Auto-fill address field
                                this.setAddressFromLatLng(vehicle.latitude, vehicle.longitude);
                              }
                            );
                          }}
                          showSearch
                          filterOption={(inputValue, option) => {
                            if (option.children) {
                              return (
                                option.children
                                  .toLowerCase()
                                  .indexOf(inputValue.toLowerCase()) >= 0
                              );
                            }
                          }}
                        >
                          {this.liveTrackingStore?.vehiclePositionArray?.map(
                            (val) => {
                              return (
                                <Option key={val.vehicleId}
                                  value={val.vehicleId}
                                  vehicleObj={val}>
                                  {val.vehicleNo}
                                </Option>
                              );
                            },
                          )}
                        </Select>
                      </Form.Item>}
                    <Form.Item
                      label={this.context.translate("_FLEET_DASHBORD_DROWGEO_ADDRESS_")}
                      name="Address"
                      style={formItemStyle}
                    >
                      <Autocomplete
                        className="autocomplete-location-textbox"
                        // componentRestrictions={{ country: "us" }}
                        options={{ types: ["geocode", "establishment"] }}
                        apiKey={config.googleMapKey}
                        defaultValue={this.state.drawGeoLocation} // prefilled
                        onPlaceSelected={async (place) => {
                          const lat = place.geometry.location.lat();
                          const lng = place.geometry.location.lng();

                          console.log("lat", lat);
                          console.log("lng", lng);
                          this.setState({
                            drawGeoLocation: place.formatted_address,
                            selectedPoiVehicleData: {
                              latitude: lat,
                              longitude: lng
                            },
                            drawGeoLocationLatLng: {
                              latitude: lat,
                              longitude: lng,
                            },
                          });

                          this.formRef.current.setFieldsValue({ Address: place.formatted_address, })
                          await this.plotSelectedVehicle();

                          // Auto-fill address field
                          this.setAddressFromLatLng(lat, lng);
                        }}
                      />
                    </Form.Item>
                    <Form.Item
                      name="poiText"
                      style={formItemStyle}

                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_DASHBORD_NEWPOI_NAME_",
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_FLEET_DASHBORD_NEWPOI_NAME_",
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      name="Customer"
                      style={formItemStyle}
                      label={
                        this.context.translate("_ACCOUNT_")
                      }
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      // label="Type"
                      label={this.context.translate("_FLEET_DASHBORD_NEWPOI_TYPE_")}
                      name="Type"
                      style={formItemStyle}
                    >
                      <Select>
                        <Select.Option value={1}>
                          {this.context.translate(
                            "_FLEET_DASHBORD_NEWPOI_CUSTOMER_",
                          )}
                        </Select.Option>
                        <Select.Option value={2}>
                          {this.context.translate(
                            "_FLEET_DASHBORD_NEWPOI_TYPEDDL_FUEL_",
                          )}
                        </Select.Option>
                        <Select.Option value={3}>
                          {this.context.translate(
                            "_FLEET_DASHBORD_NEWPOI_TYPEDDL_HOUSE_",
                          )}
                        </Select.Option>
                        <Select.Option value={4}>
                          {this.context.translate(
                            "_FLEET_DASHBORD_NEWPOI_TYPEDDL_SHOP_",
                          )}
                        </Select.Option>
                        <Select.Option value={5}>
                          {this.context.translate(
                            "_FLEET_DASHBORD_NEWPOI_TYPEDDL_WAREHOUSE_",
                          )}
                        </Select.Option>
                        <Select.Option value={6}>
                          {this.context.translate(
                            "_FLEET_DASHBORD_NEWPOI_TYPEDDL_CEDIS_",
                          )}
                        </Select.Option>
                        <Select.Option value={7}>
                          {this.context.translate(
                            "_FLEET_DASHBORD_NEWPOI_TYPEDDL_AIRPORT_",
                          )}
                        </Select.Option>
                      </Select>
                    </Form.Item>
                    <Form.Item
                      // label="Speed"
                      label={this.context.translate(
                        "_FLEET_DASHBORD_NEWPOI_PHONE_",
                      )}
                      name="Phoneno"
                      style={formItemStyle}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      name="Photo"
                      // className="formCheckboxCss"
                      label={this.context.translate("_FLEET_DASHBORD_NEWPOI_PHOTO_")}
                      style={{ marginTop: "16px" }}
                    >
                      <Upload
                        style={{ backgroundColor: "black" }}
                        name="logo"

                        listType="picture"
                        accept=".jpg,.png"
                        // beforeUpload={(file) => this.validateFile(file)}

                        onChange={this.getUploadPhoto}
                        maxCount={1}
                        customRequest={(options) =>
                          this.uploadFunction(options)
                        }
                      >
                        <Button
                          className="imgupload"
                          icon={<UploadOutlined />}
                        >
                          {/* Upload Photo */}
                          {this.context.translate(
                            "_FLEET_DASHBORD_NEWPOI_PHOTO_"
                          )}
                        </Button>
                      </Upload>
                    </Form.Item>
                  </div>
                  <div className="formBtnGroup">
                    <Button
                      className="poiCancelButton"
                      onClick={() => {
                        if (this.state.poiId !== -1) {
                          this.setState({ showAlertPoiPopup: true, })

                        } else {
                          this.setState({ showNewPoiPopup: false })
                        }
                      }
                      }
                    >
                      {this.context.translate("_FLEET_DASHBORD_NEWPOI_REMOVEBTN_")}
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="formSaveButton"
                    >
                      {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                    </Button>
                  </div>
                </Form>
              </Card>
            </div>
          )
        }

        {
          this.state.showAllPoi &&
          <Card
            className="right-menu-panel-newGeofence"
            title={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div style={{ fontSize: "18px" }}>
                  {this.context.translate("_FLEET_DASHBORD_SHOWPOI_TITLE_")}
                </div>

                <CloseOutlined style={{ fontSize: "18px", cursor: "pointer" }}
                  onClick={() => this.setState({ showAllPoi: false })} />
              </div>
            }
          >

            <CompanyAutocomplete
              style={{ width: "100%", marginTop: 20 }}
              onChange={async (value) => {
                await this.setState({ showPoicompanyId: value.value });
              }}
            />

            <div className="formBtnGroup">
              <Button
                className="poiCancelButton"
                onClick={() =>
                  this.setState({ showAllPoi: false })
                }
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>
              <Button
                type="primary"
                // htmlType="submit"
                className="formSaveButton"
                onClick={() => { this.showAllPoiData(); }}
              >
                {this.context.translate("_FLEET_DASHBORD_NAVIRIGHT_SHOWPOI_")}
              </Button>
            </div>
          </Card>
        }

        {
          this.state.searchPoi &&
          <Card
            className="right-menu-panel-newGeofence"
            title={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div style={{ fontSize: "18px" }}>
                  {this.context.translate("_FLEET_DASHBORD_NAVIRIGHT_SEARCHPOI_")}
                </div>

                <CloseOutlined style={{ fontSize: "18px", cursor: "pointer" }}
                  onClick={() => this.setState({ searchPoi: false })} />
              </div>
            }
          >
            <Form
              layout="vertical"
              ref={this.formRef}
            >
              {(this.props.getUserData().isadmin === -1 ||
                this.props.getUserData().isadmin === 3) && (<Form.Item
                  // label="Speed"
                  // label={this.context.translate(
                  //   "_FLEET_DASHBORD_SEARCHPOI_COMPANY_",
                  // )}
                  label={
                    <span>
                      {this.context.translate(
                        "_FLEET_DASHBORD_SEARCHPOI_COMPANY_",
                      )}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_FLEET_DASHBORD_SEARCHPOI_COMPANY_",
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                  name="companyId"
                  style={formItemStyle}
                >
                  <CompanyAutocomplete
                    style={{ width: "100%" }}
                    onChange={async (value) => {
                      await this.setState({ searchPoicompanyId: value.value });
                      await this.liveTrackingStore.showAllPois(value.value)
                      this.setState({ loadData: 1 })
                    }}
                  />
                </Form.Item>)}
              <Form.Item
                // label={this.context.translate(
                //   "_FLEET_DASHBORD_SEARCHPOI_NAME_",
                // )}
                label={
                  <span>
                    {this.context.translate(
                      "_FLEET_DASHBORD_SEARCHPOI_NAME_",
                    )}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </span>
                }
                required={false}
                rules={[
                  {
                    required: true,
                    message: `${this.context.translate(
                      "_FLEET_DASHBORD_SEARCHPOI_NAME_",
                    )} ${this.context.translate("_IS_REQUIRED_")}`,
                  },
                ]}
                name="poiId"
                style={formItemStyle}
              >
                <Select
                  showSearch
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                  onChange={(poiId) => {
                    this.setState({ selectedPoiId: poiId })
                  }}
                >
                  {this.liveTrackingStore?.poiData?.map((val) => {
                    return (
                      <Option value={val.poiId}>{val.poiText}</Option>
                    );
                  })}
                </Select>

              </Form.Item>

              <div className="formBtnGroup">
                <Button
                  className="poiCancelButton"
                  onClick={() =>
                    this.setState({ searchPoi: false })
                  }
                >
                  {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="formSaveButton"
                  onClick={() => { this.searchPoiData(); }}
                >
                  {this.context.translate("_SEARCH_")}
                </Button>
              </div>
            </Form>
          </Card>
        }

        {
          this.state.importExcelFromPoi && (
            <Card
              className="right-menu-panel headerGroup-panel"
              title={
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    {this.context.translate("_FLEET_DASHBORD_IMPORTPOI_TITLE_")}
                  </div>{" "}
                  <CloseOutlined
                    onClick={() => this.setState({ importExcelFromPoi: false })}
                  />
                </div>
              }
            >
              <Form
                ref={this.formRef}
                name="excelimport"
                layout="vertical"
                onFinish={this.onImportPoiExcelSubmit}
                style={{ maxWidth: "100%" }}
              >
                {(this.props.getUserData().isadmin === -1
                  || this.props.getUserData().isadmin === 3) && (
                    <>
                      <Form.Item
                        name="companyId"

                        label={
                          <span>
                            {this.context.translate("_ACCOUNT_")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        required={false}
                        // label={this.context.translate("_ACCOUNT_")}
                        rules={[
                          {
                            required: true,
                            message: `${this.context.translate(
                              "_ACCOUNT_",
                            )} ${this.context.translate("_IS_REQUIRED_")}`,
                          },
                        ]}
                      >
                        <CompanyAutocomplete
                          onChange={(companyId) => {
                            this.setState({ excelPoiCompanyId: companyId.value });
                          }}
                        />
                      </Form.Item>

                      <br />
                      <br />
                    </>
                  )}

                <Form.Item
                  name="excelFile"
                  // label="Excel File"
                  rules={[
                    {
                      required: true,
                      message: this.context.translate("_ENTER_EXCEL_"),
                    },
                  ]}
                >
                  <Upload
                    name="excelFile"
                    action={config.NodeUrl + "/pointOfInterest/uploadExcel"}
                    listType="text"
                    data={{ fileType: "accountimport", fieldName: "excelFile" }}
                    onChange={this.getUploadPoiData}
                    maxCount={1}
                    customRequest={(options) => this.uploadPOIFunction(options)}
                  // accept=".excel"
                  >
                    <Button icon={<UploadOutlined />}>
                      {this.context.translate("_CLICKTOUPLOAD_EXCELFILE_")}
                    </Button>
                  </Upload>

                </Form.Item>

                <div className="formBtnGroup">
                  <Button
                    className="formCancelButton"
                    key="Sample"
                    onClick={() => {
                      this.liveTrackingStore.samplePoiExcel();
                    }}
                  >

                    {this.context.translate("_SAMPLE_")}
                  </Button>

                  <Button
                    className="formSaveButton"
                    type="primary"
                    htmlType="submit"
                  >
                    {this.context.translate("_UPLOAD_")}
                  </Button>

                  <Button
                    className="formCancelButton"
                    // type="primary"
                    onClick={() => {
                      this.setState({ importExcelFromPoi: false });
                    }}
                  >
                    {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                  </Button>
                </div>
              </Form>
            </Card>
          )
        }

        {
          this.state.showAlertPoiPopup && (
            <Modal
              maskClosable={false}
              title={
                <div className="deleteModalTitle">
                  <span>
                    {" "}
                    {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                  </span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ showAlertPoiPopup: false })}
                  />
                </div>
              }
              className="deleteModal"
              description="Are you sure you want to delete this Item? This action cannot be undone."
              centered
              open={this.state.showAlertPoiPopup}
              footer={null}
              width={400}
              closable={false}
            >
              <div className="deleteModalText">
                <p>{this.context.translate("_DELETE_STATUS_")}</p>
              </div>
              <div className="deleteModalButtons">
                <Button
                  className="deleteModalCancelButton"
                  onClick={() => this.setState({ showAlertPoiPopup: false })}
                >
                  {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                </Button>

                <Button
                  className="deleteModalOkButton"
                  onClick={() => this.onDeletePoi()}
                >
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </Button>
              </div>
            </Modal>
          )
        }

        <div
          className="handle"
          style={{ insetInlineStart: "10%" }} // display: "flex", flexDirection: "row",
        >
          {this.state.vehicleOtherInfo && (
            <VehicleOtherInfo
              key={this.state.selectedVehicleId}
              This={this}
              update={this.state.update}
              liveTrackingStore={this.liveTrackingStore}
              info={this.state.vehicleOtherInfo}
              selectAllChecked={this.state.selectAllChecked}
              // daySummary={this.liveTrackingStore.daySummaryObj}
              vehicleObj={this.state.vehicleDetailsShow}
              closeMapModal={(resp) => {
                this.setState({ keepAnEyeModal: resp });
              }}
              onShowPolyline={(geoJson) =>
                this.setState({ polylineData: geoJson })
              }
              onShowTrackingPolyline={(geoJson) =>
                this.setState({ trackingPolylineData: geoJson })
              }
              onClearPolyline={this.onClearPolyline}
              onClearTrackingPolyline={this.clearTrackingPolyline}
              mapRef={this.mapRef}
              idleStopMarkersData={(geoJson) =>
                this.setState({ idleStopMarkersData: geoJson })
              }
              fuelMarkersData={(geoJson) =>
                this.setState({ fuelMarkersData: geoJson })
              }
            />
          )}
          <div
            style={{
              top: "10.2%",
              backgroundColor: "rgba(24, 23, 34, 0.50)",
              color: "white",
              position: "absolute",
              zIndex: "999",
              width: "20%",
              marginInlineStart: "4px",
            }}
          >
            {this.state.vehicleOtherInfo && (
              <FloatButton.Group
                className="floatBtnGroup"
                shape="square"
                style={{
                  zIndex: "999",
                  top: "60%",
                  insetInlineStart: "100%",
                  position: "absolute",
                }}
              >
                {/* <AntTooltip
                  title={this.context.translate("_HISTORY_")}
                  placement="right"
                  color="green"
                >
                  <FloatButton
                    icon={<i class="bi bi-clock-history"></i>}
                    onClick={() =>
                      this.setState({
                        historyTrackingWindow: true,
                        liveTrackingMainModal: false,
                        closeCard: false,
                      })
                    }
                  />
                </AntTooltip> */}
                <AntTooltip
                  title={this.context.translate("_KEEP_AN_EYE_")}
                  placement="right"
                  color="green"
                >
                  <FloatButton
                    icon={<i class="bi bi-eye"></i>}
                    onClick={() =>
                      this.setState({
                        keepAnEyeModal: true,
                        liveTrackingMainModal: false,
                        closeCard: false,
                      })
                    }
                  />
                </AntTooltip>

                <AntTooltip
                  title={this.context.translate("_SEND_COMMAND_")}
                  placement="right"
                  color="green"
                >
                  <FloatButton
                    icon={<i class="bi bi-send"></i>}
                    onClick={() =>
                      this.setState({
                        sendCommandPopUp: true,
                        liveTrackingMainModal: false,
                        closeCard: false,
                      })
                    }
                  />
                </AntTooltip>
                <AntTooltip
                  title={this.context.translate("_SHARE_LIVE_LOCATION_")}
                  placement="right"
                  color="green"
                >
                  <FloatButton
                    icon={<i class="bi bi-geo-alt"></i>}
                    onClick={() => {
                      this.setState({ openLiveLocationModal: true, shareLocationtitle: "_SHARE_LIVE_LOCATION_" });
                      this.getLiveLocationUrl();
                    }}
                  />
                </AntTooltip>
                <AntTooltip
                  title={this.context.translate("_SHARE_VEHICLE_LOCATION_")}
                  placement="right"
                  color="green"
                >
                  <FloatButton
                    icon={<i class="bi bi-share"></i>}
                    onClick={() => {
                      //let data = [];
                      let data = `${Number(this.state.vehicleOtherInfo.latitude)},${Number(this.state.vehicleOtherInfo.longitude)}`;
                      //console.log(data) 
                      this.setState({ shareSingleLocation: data, shareModalVisible: true, shareLocationtitle: "_SHARE_VEHICLE_LOCATION_" });
                    }}
                  />
                </AntTooltip>

                {[6, 13, 18].includes(
                  Number(this.state.vehicleOtherInfo?.deviceId)
                ) && (
                    <>
                      <Popover
                        placement="right"
                        content={
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                            }}
                          >
                            <Button
                              style={{ border: "none" }}
                              onClick={() => this.handleVideoMonitoringData(1)}
                            >
                              {this.context.translate("_CHANNEL1_")}
                            </Button>
                            <Button
                              style={{ border: "none" }}
                              onClick={() => this.handleVideoMonitoringData(2)}
                            >
                              {this.context.translate("_CHANNEL2_")}
                            </Button>
                            <Button
                              style={{ border: "none" }}
                              onClick={() => this.handleVideoMonitoringData(3)}
                            >
                              {this.context.translate("_CHANNEL3_")}
                            </Button>
                            <Button
                              style={{ border: "none" }}
                              onClick={() => this.handleVideoMonitoringData(4)}
                            >
                              {this.context.translate("_CHANNEL4_")}
                            </Button>
                          </div>
                        }
                      >
                        <FloatButton
                          icon={<i class="bi bi-camera"></i>}
                        ></FloatButton>
                      </Popover>
                    </>
                  )}
              </FloatButton.Group>
            )}
          </div>
        </div>

        {
          this.state.openLiveLocationModal && (
            <Draggable>
              <Modal
                open={this.state.openLiveLocationModal}
                maskClosable={false}
                // title="File Upload"
                title={this.context.translate("_LIVE_LOCATION_")}
                onOk={() => this.setState({ openLiveLocationModal: false })}
                onCancel={() => {
                  this.setState({ openLiveLocationModal: false });
                }}
                footer={false}
                width={400}
              >
                <Form
                  ref={this.livelocationFormRef}
                  name="livelocation"
                  layout="vertical"
                  onFinish={this.onLiveLocationFormSubmit}
                  initialValues={{ expiryDate: dayjs() }}
                // className="formClass"
                >
                  <Form.Item
                    name="expiryDate"
                    label={this.context.translate("_EXPIRY_DATE_")}
                  >
                    <DatePicker
                      format={"YYYY-MM-DD"}
                      style={{ width: "100%" }}
                    ></DatePicker>
                  </Form.Item>

                  <Form.Item
                    name="startTime"
                    label={this.context.translate("_FLEET_START_TIME_")}
                    rules={[{ required: true }]}
                  >
                    <Select>{this.timeOptionsForLiveLocation()}</Select>
                  </Form.Item>

                  <Form.Item
                    name="endTime"
                    label={this.context.translate("_END_TIME_")}
                    rules={[{ required: true }]}
                  >
                    <Select>{this.timeOptionsForLiveLocation()}</Select>
                  </Form.Item>

                  {/* {this.state.locationUrl.Id !== -1 && (
                  <Form.Item
                    name="locationUrl"
                    label="Link"
                  // rules={[{ required: true }]}
                  >
                    <Input></Input>
                  </Form.Item>
                )} */}

                  <div className="formBtnGroup">
                    <Button
                      type="primary"
                      className="formSaveButton"
                      htmlType="submit"
                    >
                      {this.context.translate(
                        "_FLEET_CREATEROUTE_ROUTEADD_SAVEBTN_",
                      )}
                    </Button>
                    <Button
                      htmlType="submit"
                      className="formCancelButton"
                      onClick={() => {
                        this.setState({ shareModalVisible: true });
                      }}
                    >
                      {this.context.translate("_FLEET_SERVICE_POILIST_SHARE_")}
                    </Button>
                    <Button
                      className="formCancelButton"
                      onClick={() => {
                        this.setState({ openLiveLocationModal: false });
                      }}
                    >
                      {this.context.translate("_FLEET_CLOSE_BTN_")}
                    </Button>
                  </div>
                </Form>
                {/* </Card> */}
              </Modal>
            </Draggable>
          )
        }

        {
          this.state.shareModalVisible && (
            <ShareModalWindow
              shareModalCloseFunc={(resp) => {
                this.setState({ shareModalVisible: resp });
              }}
              shareSingleLocation={this.state.shareSingleLocation}
              shareLiveLocation={this.state.locationUrl.locationUrl}
              title={this.state.shareLocationtitle}
            />
          )
        }

        <Modal
          width={400}
          title={this.context.translate("_ADD_VERSION_")}
          open={this.state.openAddVersionModal}
          onCancel={() => this.setState({ openAddVersionModal: false })}
          footer={null}
        >
          <Form layout="vertical" onFinish={this.handleAddVersionForm}>
            <Form.Item
              label={this.context.translate("_VERSION_")}
              name="reason"
              rules={[{ required: true }]}
            >
              <Input></Input>
            </Form.Item>

            <Form.Item label="CRC32" name="reason" rules={[{ required: true }]}>
              <Input></Input>
            </Form.Item>

            <div className="formBtnGroup">
              <Button
                type="primary"
                htmlType="submit"
                style={{ height: "40px", marginInlineEnd: "10px" }}
              >
                Gennerate CRC32
              </Button>

              <Button
                type="primary"
                // className="formSaveButton"
                htmlType="submit"
                style={{
                  // color: "#fff",
                  // backgroundColor: "#4096ff",
                  width: "105px",
                  height: "40px",
                }}
              // loading={this.state.loading}
              >
                {this.context.translate("_DOWNLOAD_")}
              </Button>
            </div>
          </Form>
        </Modal>

        <div
          style={{
            position: "absolute",
            bottom: "7%",
            display: "flex",
            gap: "16px",
            justifyContent: "center",
            width: "100%",
            insetInlineStart: "235px",
            zIndex: "999",
          }}
        >
          {Object.keys(this.state.videoMonitoringUrl || {}).map((channelId) =>
            this.state.openVideoModal !== channelId ? (
              <Card
                style={{ width: 270 }}
                key={channelId}
                title={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "18px",
                    }}
                  >
                    {`Channel ${channelId}`}
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <i
                        className="bi bi-arrows-fullscreen"
                        style={{
                          border: "none",
                          fontSize: "15px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.setState({
                            openVideoModal: channelId,
                          })
                        }
                      ></i>
                      <CloseOutlined
                        onClick={() => this.handleCloseChannel(channelId)}
                        style={{ cursor: "pointer", color: "black" }}
                      />
                    </div>
                  </div>
                }
                bordered={true}
              >
                {this.state.videoMonitoringUrl[channelId] && (
                  <>
                    {this.state.videoMonitoringData.MDVR === "H-Protocol" ? (
                      <HLSPlayer isSingle={true} heightFactor={219}
                        src={this.state.videoMonitoringUrl[channelId]}
                      />
                    ) : this.state.videoMonitoringData.MDVR === "JT1078" ? (
                      <FlvPlayer isSingle={true} heightFactor={219}
                        url={this.state.videoMonitoringUrl[channelId]}
                      />
                    ) : (
                      <iframe
                        src={this.state.videoMonitoringUrl[channelId]}
                        width="100%"
                        height="200px"
                        frameBorder="0"
                        scrolling="no"
                        allow="fullscreen"
                      />
                    )}
                  </>
                )}
              </Card>
            ) : null,
          )}
        </div>
        {
          Object.keys(this.state.videoMonitoringUrl || {}).map((channelId) => (
            <Modal
              open={this.state.openVideoModal === channelId}
              onCancel={() => this.closeModal()}
              footer={null}
              width={800}
              title={`Channel ${channelId}`}
            >
              {this.state.videoMonitoringUrl[channelId] && (
                <>
                  {
                    // this.state.videoMonitoringData.MDVR == "JT1078" ||
                    // this.state.videoMonitoringData.MDVR == "H-Protocol" ? (
                    //   <HLSPlayer src={this.state.videoMonitoringUrl[channelId]} />
                    this.state.videoMonitoringData.MDVR === "H-Protocol" ? (
                      <HLSPlayer isSingle={true} heightFactor={219} src={this.state.videoMonitoringUrl[channelId]} />
                    ) : this.state.videoMonitoringData.MDVR === "JT1078" ? (
                      <FlvPlayer isSingle={true} heightFactor={219} url={this.state.videoMonitoringUrl[channelId]} />
                    ) : (
                      <iframe
                        src={this.state.videoMonitoringUrl[channelId]}
                        width="100%"
                        height="200px"
                        frameBorder="0"
                        scrolling="no"
                        allow="fullscreen"
                      />
                    )
                  }
                </>
              )}
            </Modal>
          ))
        }

        {
          this.state.sosnotificationCount > 0 &&
          (
            <SosAlertNotification
              notifyData={(this.sosAlertStore.sosAlertList)}
              user={this.state.user}
              getSOSAlert={this.getSOSAlert}

            />
          )
        }
        {
          this.state.showChatSystem && (
            <ChatDriver
              onClose={() => this.setState({ showChatSystem: false })}
            />
          )
        }
      </div >
    );
  }
}

LiveTracking.contextType = StoreContext;
export default observer(withRouter(LiveTracking));
